import {
	Client,
	ClientContact,
	ClientContactRequest
} from "@/Contracts/Clients";
import { OpportunityRequest } from "@/Contracts/Opportunity";
import {
	syncEntityWithPsa,
	getOneSalesActivity,
	deleteOneSalesActivity,
	fetchMeetingClashStatus,
	fetchAuditLogs,
	retryFailedAuditLog,
	getAuditLogRedirectUrl,
	fetchSalesActivityAndAutomationViewMetadata,
	getAllSalesActivityAndAutomationViews,
	createSalesActivityAndAutomationView,
	updateSalesActivityAndAutomationView,
	deleteSalesActivityAndAutomationView,
	getSalesActivityAndAutomationListPost,
	fetchCustomDistributorAuditLogs,
	getConflictMeetingsDetail
} from "../../../services/SalesActivity";
import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import {
	CustomView,
	CustomViewResponse,
	CustomViewsMetadata,
	DefaultErrorMessage,
	FetchCustomDistributorAuditLogsRequest,
	PaymentHistoryActivity,
	SalesActivityUserViews,
	TableQueryFilter,
	ZomentumEntities
} from "@/Contracts";
import {
	SalesActivityRequest,
	AggregateSalesActivityResponse,
	SalesActivity,
	SalesActivityAutomation,
	AddSalesActivityAutomationRequest,
	AddSalesActivityCommentRequest,
	AddLogCallRequest,
	AddLogEmailRequest,
	AddTaskRequest,
	AddMeetingRequest,
	SalesActivityAutomationMetadataRequest,
	SalesActivityAutomationMetadataFilter,
	HistoryActivity,
	HistoryActivityRequest,
	GetOneSaleActivityRequest,
	SalesActivityResponse,
	SalesActivityPageRequest,
	MeetingClashStatus,
	FetchCategoryBasedAuditLogsRequest,
	EditSalesActivityAutomationRequest,
	RetryFailedAuditLogsRequest,
	FetchClashStatusInput,
	SelectedDocumentAndTemplate,
	SalesActivityAutomationResponse,
	ConflictedMeetigs
} from "@/Contracts/Others/SalesActivity";

import { MergeTagVariable } from "@/Contracts/Documents";

import {
	getAllSalesActivity,
	getAllCompletedSalesActivity,
	getAllOverdueSalesActivity,
	getAllUpcomingSalesActivity,
	getNotesSalesActivity,
	getNotesPinnedSalesActivity,
	getNotesCompletedSalesActivity,
	getTasksSalesActivity,
	getTasksCompletedSalesActivity,
	getTasksOverdueSalesActivity,
	getTasksUpcomingSalesActivity,
	getMeetingsSalesActivity,
	getMeetingsCompletedSalesActivity,
	getMeetingsUpcomingSalesActivity,
	getCallsSalesActivity,
	getEmailsSalesActivity,
	deleteComment,
	addComment,
	editComment,
	deleteLogCall,
	addLogCall,
	editLogCall,
	deleteLogEmail,
	addLogEmail,
	editLogEmail,
	deleteTask,
	addTask,
	editTask,
	deleteMeeting,
	addMeeting,
	editMeeting,
	getSalesActivityAutomations,
	getSalesActivityAutomationMetadata,
	getSalesActivityAutomationDetails,
	reorderSalesActivityAutomation,
	deleteSalesActivityAutomation,
	addSalesActivityAutomation,
	editSalesActivityAutomation,
	getHistoryActivities,
	getOneMeeting,
	getOneComment,
	getOneLogEmail,
	getOneLogCall,
	getOneTask,
	getUsersAllSalesActivity
} from "../../../services/SalesActivity";
import { Opportunity } from "@/Contracts/Opportunity";
import { ClientsRequest } from "@/Contracts/Clients";
import { getOpportunities } from "../../../services/Opportunity";
import { getClients, getClientContacts } from "../../../services/Clients";
import {
	RecentActivityFeedType,
	SyncEntityRequest
} from "@/Contracts/Others/RecentActivityFeed";
import { OpportunityStage } from "@/Contracts/Pipelines";
// import { SalesActivityState } from "@/Reducers/interface";
import { ZMessage } from "@molecules";
import { ListPagePostRequest } from "@/Contracts";
import { SalesActivityModuleState } from "../..";
import { areFiltersChanged, hydrateUserData } from "@/Utils";
import { UserData } from "@/Contracts";

export enum SalesActivityActionTypes {
	// Sales Activity Get Actions
	SHOW_SALES_ACTIVITY_LOADER = "SHOW_SALES_ACTIVITY_LOADER",
	HIDE_SALES_ACTIVITY_LOADER = "HIDE_SALES_ACTIVITY_LOADER",
	SALES_ACTIVITY_ACTIVE_TAB_CHANGED = "SALES_ACTIVITY_ACTIVE_TAB_CHANGED",
	ALL_SALES_ACTIVITY_REQUESTED = "ALL_SALES_ACTIVITY_REQUESTED",
	ALL_SALES_ACTIVITY_SUCCESSFUL = "ALL_SALES_ACTIVITY_SUCCESSFUL",
	ALL_SALES_ACTIVITY_FAILED = "ALL_SALES_ACTIVITY_FAILED",
	ALL_COMPLETED_SALES_ACTIVITY_REQUESTED = "ALL_COMPLETED_SALES_ACTIVITY_REQUESTED",
	ALL_COMPLETED_SALES_ACTIVITY_SUCCESSFUL = "ALL_COMPLETED_SALES_ACTIVITY_SUCCESSFUL",
	ALL_COMPLETED_SALES_ACTIVITY_FAILED = "ALL_COMPLETED_SALES_ACTIVITY_FAILED",
	ALL_OVERDUE_SALES_ACTIVITY_REQUESTED = "ALL_OVERDUE_SALES_ACTIVITY_REQUESTED",
	ALL_OVERDUE_SALES_ACTIVITY_SUCCESSFUL = "ALL_OVERDUE_SALES_ACTIVITY_SUCCESSFUL",
	ALL_OVERDUE_SALES_ACTIVITY_FAILED = "ALL_OVERDUE_SALES_ACTIVITY_FAILED",
	ALL_UPCOMING_SALES_ACTIVITY_REQUESTED = "ALL_UPCOMING_SALES_ACTIVITY_REQUESTED",
	ALL_UPCOMING_SALES_ACTIVITY_SUCCESSFUL = "ALL_UPCOMING_SALES_ACTIVITY_SUCCESSFUL",
	ALL_UPCOMING_SALES_ACTIVITY_FAILED = "ALL_UPCOMING_SALES_ACTIVITY_FAILED",
	ALL_SALES_ACTIVITY_RESET = "ALL_SALES_ACTIVITY_RESET",
	NOTES_SALES_ACTIVITY_REQUESTED = "NOTES_SALES_ACTIVITY_REQUESTED",
	NOTES_SALES_ACTIVITY_SUCCESSFUL = "NOTES_SALES_ACTIVITY_SUCCESSFUL",
	NOTES_SALES_ACTIVITY_FAILED = "NOTES_SALES_ACTIVITY_FAILED",
	NOTES_PINNED_SALES_ACTIVITY_REQUESTED = "NOTES_PINNED_SALES_ACTIVITY_REQUESTED",
	NOTES_PINNED_SALES_ACTIVITY_SUCCESSFUL = "NOTES_PINNED_SALES_ACTIVITY_SUCCESSFUL",
	NOTES_PINNED_SALES_ACTIVITY_FAILED = "NOTES_PINNED_SALES_ACTIVITY_FAILED",
	NOTES_COMPLETED_SALES_ACTIVITY_REQUESTED = "NOTES_COMPLETED_SALES_ACTIVITY_REQUESTED",
	NOTES_COMPLETED_SALES_ACTIVITY_SUCCESSFUL = "NOTES_COMPLETED_SALES_ACTIVITY_SUCCESSFUL",
	NOTES_COMPLETED_SALES_ACTIVITY_FAILED = "NOTES_COMPLETED_SALES_ACTIVITY_FAILED",
	NOTES_SALES_ACTIVITY_RESET = "NOTES_SALES_ACTIVITY_RESET",
	TASKS_SALES_ACTIVITY_REQUESTED = "TASKS_SALES_ACTIVITY_REQUESTED",
	TASKS_SALES_ACTIVITY_SUCCESSFUL = "TASKS_SALES_ACTIVITY_SUCCESSFUL",
	TASKS_SALES_ACTIVITY_FAILED = "TASKS_SALES_ACTIVITY_FAILED",
	TASKS_COMPLETED_SALES_ACTIVITY_REQUESTED = "TASKS_COMPLETED_SALES_ACTIVITY_REQUESTED",
	TASKS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL = "TASKS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL",
	TASKS_COMPLETED_SALES_ACTIVITY_FAILED = "TASKS_COMPLETED_SALES_ACTIVITY_FAILED",
	TASKS_OVERDUE_SALES_ACTIVITY_REQUESTED = "TASKS_OVERDUE_SALES_ACTIVITY_REQUESTED",
	TASKS_OVERDUE_SALES_ACTIVITY_SUCCESSFUL = "TASKS_OVERDUE_SALES_ACTIVITY_SUCCESSFUL",
	TASKS_OVERDUE_SALES_ACTIVITY_FAILED = "TASKS_OVERDUE_SALES_ACTIVITY_FAILED",
	TASKS_UPCOMING_SALES_ACTIVITY_REQUESTED = "TASKS_UPCOMING_SALES_ACTIVITY_REQUESTED",
	TASKS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL = "TASKS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL",
	TASKS_UPCOMING_SALES_ACTIVITY_FAILED = "TASKS_UPCOMING_SALES_ACTIVITY_FAILED",
	TASKS_SALES_ACTIVITY_RESET = "TASKS_SALES_ACTIVITY_RESET",
	MEETINGS_SALES_ACTIVITY_REQUESTED = "MEETINGS_SALES_ACTIVITY_REQUESTED",
	MEETINGS_SALES_ACTIVITY_SUCCESSFUL = "MEETINGS_SALES_ACTIVITY_SUCCESSFUL",
	MEETINGS_SALES_ACTIVITY_FAILED = "MEETINGS_SALES_ACTIVITY_FAILED",
	MEETINGS_COMPLETED_SALES_ACTIVITY_REQUESTED = "MEETINGS_COMPLETED_SALES_ACTIVITY_REQUESTED",
	MEETINGS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL = "MEETINGS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL",
	MEETINGS_COMPLETED_SALES_ACTIVITY_FAILED = "MEETINGS_COMPLETED_SALES_ACTIVITY_FAILED",
	MEETINGS_UPCOMING_SALES_ACTIVITY_REQUESTED = "MEETINGS_UPCOMING_SALES_ACTIVITY_REQUESTED",
	MEETINGS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL = "MEETINGS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL",
	MEETINGS_UPCOMING_SALES_ACTIVITY_FAILED = "MEETINGS_UPCOMING_SALES_ACTIVITY_FAILED",
	MEETINGS_SALES_ACTIVITY_RESET = "MEETINGS_SALES_ACTIVITY_RESET",
	CALLS_SALES_ACTIVITY_REQUESTED = "CALLS_SALES_ACTIVITY_REQUESTED",
	CALLS_SALES_ACTIVITY_SUCCESSFUL = "CALLS_SALES_ACTIVITY_SUCCESSFUL",
	CALLS_SALES_ACTIVITY_FAILED = "CALLS_SALES_ACTIVITY_FAILED",
	CALLS_SALES_ACTIVITY_RESET = "CALLS_SALES_ACTIVITY_RESET",
	EMAILS_SALES_ACTIVITY_REQUESTED = "EMAIL_SALES_ACTIVITY_REQUESTED",
	EMAILS_SALES_ACTIVITY_SUCCESSFUL = "EMAIL_SALES_ACTIVITY_SUCCESSFUL",
	EMAILS_SALES_ACTIVITY_FAILED = "EMAIL_SALES_ACTIVITY_FAILED",
	EMAILS_SALES_ACTIVITY_RESET = "EMAILS_SALES_ACTIVITY_RESET",
	UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY = "UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY",

	HISTORY_ACTIVITIES_REQUESTED = "HISTORY_ACTIVITIES_REQUESTED",
	HISTORY_ACTIVITIES_SUCCESSFUL = "HISTORY_ACTIVITIES_SUCCESSFUL",
	HISTORY_ACTIVITIES_FAILED = "HISTORY_ACTIVITIES_FAILED",

	HISTORY_ACTIVITIES_RESET = "HISTORY_ACTIVITIES_RESET",

	GET_ONE_MEETING_REQUESTED = "GET_ONE_MEETING_REQUESTED",
	GET_ONE_MEETING_SUCCESSFUL = "GET_ONE_MEETING_SUCCESSFUL",
	GET_ONE_MEETING_FAILED = "GET_ONE_MEETING_FAILED",

	GET_ONE_TASK_FAILED = "GET_ONE_TASK_FAILED",
	GET_ONE_TASK_REQUESTED = "GET_ONE_TASK_REQUESTED",
	GET_ONE_TASK_SUCCESSFUL = "GET_ONE_TASK_SUCCESSFUL",

	GET_ONE_NOTE_FAILED = "GET_ONE_NOTE_FAILED",
	GET_ONE_NOTE_REQUESTED = "GET_ONE_NOTE_REQUESTED",
	GET_ONE_NOTE_SUCCESSFUL = "GET_ONE_NOTE_SUCCESSFUL",

	GET_ONE_LOG_CALL_FAILED = "GET_ONE_LOG_CALL_FAILED",
	GET_ONE_LOG_CALL_REQUESTED = "GET_ONE_LOG_CALL_REQUESTED",
	GET_ONE_LOG_CALL_SUCCESSFUL = "GET_ONE_LOG_CALL_SUCCESSFUL",

	GET_ONE_LOG_EMAIL_FAILED = "GET_ONE_LOG_EMAIL_FAILED",
	GET_ONE_LOG_EMAIL_REQUESTED = "GET_ONE_LOG_EMAIL_REQUESTED",
	GET_ONE_LOG_EMAIL_SUCCESSFUL = "GET_ONE_LOG_EMAIL_SUCCESSFUL",

	// Sales Activity Delete / Add / Edit Actions
	DELETE_COMMENT_REQUESTED = "DELETE_COMMENT_REQUESTED",
	DELETE_COMMENT_SUCCESSFUL = "DELETE_COMMENT_SUCCESSFUL",
	DELETE_COMMENT_FAILED = "DELETE_COMMENT_FAILED",
	ADD_COMMENT_REQUESTED = "ADD_COMMENT_REQUESTED",
	ADD_COMMENT_SUCCESSFUL = "ADD_COMMENT_SUCCESSFUL",
	ADD_COMMENT_FAILED = "ADD_COMMENT_FAILED",
	EDIT_COMMENT_REQUESTED = "EDIT_COMMENT_REQUESTED",
	EDIT_COMMENT_SUCCESSFUL = "EDIT_COMMENT_SUCCESSFUL",
	EDIT_COMMENT_FAILED = "EDIT_COMMENT_FAILED",
	DELETE_TASK_REQUESTED = "DELETE_TASK_REQUESTED",
	DELETE_TASK_SUCCESSFUL = "DELETE_TASK_SUCCESSFUL",
	DELETE_TASK_FAILED = "DELETE_TASK_FAILED",
	ADD_TASK_REQUESTED = "ADD_TASK_REQUESTED",
	ADD_TASK_SUCCESSFUL = "ADD_TASK_SUCCESSFUL",
	ADD_TASK_FAILED = "ADD_TASK_FAILED",
	EDIT_TASK_REQUESTED = "EDIT_TASK_REQUESTED",
	EDIT_TASK_SUCCESSFUL = "EDIT_TASK_SUCCESSFUL",
	EDIT_TASK_FAILED = "EDIT_TASK_FAILED",
	DELETE_MEETING_REQUESTED = "DELETE_MEETING_REQUESTED",
	DELETE_MEETING_SUCCESSFUL = "DELETE_MEETING_SUCCESSFUL",
	DELETE_MEETING_FAILED = "DELETE_MEETING_FAILED",
	ADD_MEETING_REQUESTED = "ADD_MEETING_REQUESTED",
	ADD_MEETING_SUCCESSFUL = "ADD_MEETING_SUCCESSFUL",
	ADD_MEETING_FAILED = "ADD_MEETING_FAILED",
	EDIT_MEETING_REQUESTED = "EDIT_MEETING_REQUESTED",
	EDIT_MEETING_SUCCESSFUL = "EDIT_MEETING_SUCCESSFUL",
	EDIT_MEETING_FAILED = "EDIT_MEETING_FAILED",
	DELETE_LOG_CALL_REQUESTED = "DELETE_LOG_CALL_REQUESTED",
	DELETE_LOG_CALL_SUCCESSFUL = "DELETE_LOG_CALL_SUCCESSFUL",
	DELETE_LOG_CALL_FAILED = "DELETE_LOG_CALL_FAILED",
	ADD_LOG_CALL_REQUESTED = "ADD_LOG_CALL_REQUESTED",
	ADD_LOG_CALL_SUCCESSFUL = "ADD_LOG_CALL_SUCCESSFUL",
	ADD_LOG_CALL_FAILED = "ADD_LOG_CALL_FAILED",
	EDIT_LOG_CALL_REQUESTED = "EDIT_LOG_CALL_REQUESTED",
	EDIT_LOG_CALL_SUCCESSFUL = "EDIT_LOG_CALL_SUCCESSFUL",
	EDIT_LOG_CALL_FAILED = "EDIT_LOG_CALL_FAILED",
	DELETE_LOG_EMAIL_REQUESTED = "DELETE_LOG_EMAIL_REQUESTED",
	DELETE_LOG_EMAIL_SUCCESSFUL = "DELETE_LOG_EMAIL_SUCCESSFUL",
	DELETE_LOG_EMAIL_FAILED = "DELETE_LOG_EMAIL_FAILED",
	ADD_LOG_EMAIL_REQUESTED = "ADD_LOG_EMAIL_REQUESTED",
	ADD_LOG_EMAIL_SUCCESSFUL = "ADD_LOG_EMAIL_SUCCESSFUL",
	ADD_LOG_EMAIL_FAILED = "ADD_LOG_EMAIL_FAILED",
	EDIT_LOG_EMAIL_REQUESTED = "EDIT_LOG_EMAIL_REQUESTED",
	EDIT_LOG_EMAIL_SUCCESSFUL = "EDIT_LOG_EMAIL_SUCCESSFUL",
	EDIT_LOG_EMAIL_FAILED = "EDIT_LOG_EMAIL_FAILED",

	SYNC_WITH_PSA_REQUESTED = "SYNC_WITH_PSA_REQUESTED",
	SYNC_WITH_PSA_SUCCESSFUL = "SYNC_WITH_PSA_SUCCESSFUL",
	SYNC_WITH_PSA_FAILED = "SYNC_WITH_PSA_FAILED",

	// Sales Activity Automation Actions
	SALES_ACTIVITY_AUTOMATIONS_REQUESTED = "SALES_ACTIVITY_AUTOMATIONS_REQUESTED",
	SALES_ACTIVITY_AUTOMATIONS_SUCCESSFUL = "SALES_ACTIVITY_AUTOMATIONS_SUCCESSFUL",
	SALES_ACTIVITY_AUTOMATIONS_FAILED = "SALES_ACTIVITY_AUTOMATIONS_FAILED",
	SALES_ACTIVITY_AUTOMATION_METADATA_REQUESTED = "SALES_ACTIVITY_AUTOMATION_METADATA_REQUESTED",
	SALES_ACTIVITY_AUTOMATION_METADATA_SUCCESSFUL = "SALES_ACTIVITY_AUTOMATION_METADATA_SUCCESSFUL",
	SALES_ACTIVITY_AUTOMATION_METADATA_FAILED = "SALES_ACTIVITY_AUTOMATION_METADATA_FAILED",
	SALES_ACTIVITY_AUTOMATION_DETAILS_REQUESTED = "SALES_ACTIVITY_AUTOMATION_DETAILS_REQUESTED",
	SALES_ACTIVITY_AUTOMATION_DETAILS_SUCCESSFUL = "SALES_ACTIVITY_AUTOMATION_DETAILS_SUCCESSFUL",
	SALES_ACTIVITY_AUTOMATION_DETAILS_FAILED = "SALES_ACTIVITY_AUTOMATION_DETAILS_FAILED",
	SALES_ACTIVITY_AUTOMATION_DETAILS_RESET = "SALES_ACTIVITY_AUTOMATION_DETAILS_RESET",
	REORDER_SALES_ACTIVITY_AUTOMATION_REQUESTED = "REORDER_SALES_ACTIVITY_AUTOMATION_REQUESTED",
	REORDER_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL = "REORDER_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL",
	REORDER_SALES_ACTIVITY_AUTOMATION_FAILED = "REORDER_SALES_ACTIVITY_AUTOMATION_FAILED",
	RESET_SALES_ACTIVITY_AUTOMATIONS = "RESET_SALES_ACTIVITY_AUTOMATIONS",
	DELETE_SALES_ACTIVITY_AUTOMATION_REQUESTED = "DELETE_SALES_ACTIVITY_AUTOMATION_REQUESTED",
	DELETE_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL = "DELETE_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL",
	DELETE_SALES_ACTIVITY_AUTOMATION_FAILED = "DELETE_SALES_ACTIVITY_AUTOMATION_FAILED",
	ADD_SALES_ACTIVITY_AUTOMATION_REQUESTED = "ADD_SALES_ACTIVITY_AUTOMATION_REQUESTED",
	ADD_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL = "ADD_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL",
	ADD_SALES_ACTIVITY_AUTOMATION_FAILED = "ADD_SALES_ACTIVITY_AUTOMATION_FAILED",
	EDIT_SALES_ACTIVITY_AUTOMATION_REQUESTED = "EDIT_SALES_ACTIVITY_AUTOMATION_REQUESTED",
	EDIT_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL = "EDIT_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL",
	EDIT_SALES_ACTIVITY_AUTOMATION_FAILED = "EDIT_SALES_ACTIVITY_AUTOMATION_FAILED",
	UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION = "UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_REQUESTED = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_REQUESTED",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_SUCCESSFUL = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_SUCCESSFUL",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_FAILED = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_FAILED",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_REQUESTED = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_REQUESTED",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_SUCCESSFUL = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_SUCCESSFUL",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_FAILED = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_FAILED",

	UPDATE_SALES_ACTIVITY_AND_AUTOMATION_CURRENT_ACTIVE_VIEW = "UPDATE_SALES_ACTIVITY_AND_AUTOMATION_CURRENT_ACTIVE_VIEW",

	CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED = "CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED",
	CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL = "CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL",
	CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED = "CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED",

	UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED = "UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED",
	UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL = "UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL",
	UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED = "UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED",

	DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED = "DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED",
	DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL = "DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL",
	DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED = "DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_REQUESTED = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_REQUESTED",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_SUCCESSFUL = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_SUCCESSFUL",
	FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_FAILED = "FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_FAILED",

	// Sales Activity Drawer Actions
	ADD_COMMENT_DRAWER_OPENED = "ADD_COMMENT_DRAWER_OPENED",
	ADD_COMMENT_DRAWER_CLOSED = "ADD_COMMENT_DRAWER_CLOSED",
	EDIT_COMMENT_DRAWER_OPENED = "EDIT_COMMENT_DRAWER_OPENED",
	EDIT_COMMENT_DRAWER_CLOSED = "EDIT_COMMENT_DRAWER_CLOSED",
	ADD_TASK_DRAWER_OPENED = "ADD_TASK_DRAWER_OPENED",
	ADD_TASK_DRAWER_CLOSED = "ADD_TASK_DRAWER_CLOSED",
	EDIT_TASK_DRAWER_OPENED = "EDIT_TASK_DRAWER_OPENED",
	EDIT_TASK_DRAWER_CLOSED = "EDIT_TASK_DRAWER_CLOSED",
	ADD_MEETING_DRAWER_OPENED = "ADD_MEETING_DRAWER_OPENED",
	ADD_MEETING_DRAWER_CLOSED = "ADD_MEETING_DRAWER_CLOSED",
	EDIT_MEETING_DRAWER_OPENED = "EDIT_MEETING_DRAWER_OPENED",
	EDIT_MEETING_DRAWER_CLOSED = "EDIT_MEETING_DRAWER_CLOSED",
	ADD_LOG_CALL_DRAWER_OPENED = "ADD_LOG_CALL_DRAWER_OPENED",
	ADD_LOG_CALL_DRAWER_CLOSED = "ADD_LOG_CALL_DRAWER_CLOSED",
	EDIT_LOG_CALL_DRAWER_OPENED = "EDIT_LOG_CALL_DRAWER_OPENED",
	EDIT_LOG_CALL_DRAWER_CLOSED = "EDIT_LOG_CALL_DRAWER_CLOSED",
	ADD_LOG_EMAIL_DRAWER_OPENED = "ADD_LOG_EMAIL_DRAWER_OPENED",
	ADD_LOG_EMAIL_DRAWER_CLOSED = "ADD_LOG_EMAIL_DRAWER_CLOSED",
	EDIT_LOG_EMAIL_DRAWER_OPENED = "EDIT_LOG_EMAIL_DRAWER_OPENED",
	EDIT_LOG_EMAIL_DRAWER_CLOSED = "EDIT_LOG_EMAIL_DRAWER_CLOSED",
	UPCOMING_ACTIVITIES_DRAWER_OPENED = "UPCOMING_ACTIVITIES_DRAWER_OPENED",
	UPCOMING_ACTIVITIES_DRAWER_CLOSED = "UPCOMING_ACTIVITIES_DRAWER_CLOSED",
	AUDIT_LOGS_DRAWER_OPENED = "AUDIT_LOGS_DRAWER_OPENED",
	AUDIT_LOGS_DRAWER_CLOSED = "AUDIT_LOGS_DRAWER_CLOSED",

	FETCH_USERS_ALL_SALES_ACTIVITY_REQUESTED = "FETCH_USERS_ALL_SALES_ACTIVITY_REQUESTED",
	FETCH_USERS_ALL_SALES_ACTIVITY_SUCCESSFULLY = "FETCH_USERS_ALL_SALES_ACTIVITY_SUCCESSFULLY",
	FETCH_USERS_ALL_SALES_ACTIVITY_FAILED = "FETCH_USERS_ALL_SALES_ACTIVITY_FAILED",

	RESET_USERS_ALL_SALES_ACTIVITY = "RESET_USERS_ALL_SALES_ACTIVITY",

	FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_REQUESTED = "FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_REQUESTED",
	FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_SUCCESSFUL = "FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_SUCCESSFUL",
	FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_FAILED = "FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_FAILED",

	FETCH_CLIENTS_FOR_SALES_ACTIVITY_REQUESTED = "FETCH_CLIENTS_FOR_SALES_ACTIVITY_REQUESTED",
	FETCH_CLIENTS_FOR_SALES_ACTIVITY_SUCCESSFUL = "FETCH_CLIENTS_FOR_SALES_ACTIVITY_SUCCESSFUL",
	FETCH_CLIENTS_FOR_SALES_ACTIVITY_FAILED = "FETCH_CLIENTS_FOR_SALES_ACTIVITY_FAILED",

	FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_REQUESTED = "FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_REQUESTED",
	FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_SUCCESSFUL = "FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_SUCCESSFUL",
	FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_FAILED = "FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_FAILED",

	RESET_SALES_ACTIVITY_OPPORTUNITIES = "RESET_SALES_ACTIVITIES_OPPORTUNITIES",
	RESET_SALES_ACTIVITY_CLIENTS = "RESET_SALES_ACTIVITY_CLIENTS",
	RESET_SALES_ACTIVITY_CLIENT_CONTACTS = "RESET_SALES_ACTIVITY_CLIENTS_CONTACTS",

	ADD_GLOBAL_COMMENT_DRAWER_OPENED = "ADD_GLOBAL_COMMENT_DRAWER_OPENED",
	ADD_GLOBAL_COMMENT_DRAWER_CLOSED = "ADD_GLOBAL_COMMENT_DRAWER_CLOSED",
	ADD_GLOBAL_TASK_DRAWER_OPENED = "ADD_GLOBAL_TASK_DRAWER_OPENED",
	ADD_GLOBAL_TASK_DRAWER_CLOSED = "ADD_GLOBAL_TASK_DRAWER_CLOSED",
	ADD_GLOBAL_MEETING_DRAWER_OPENED = "ADD_GLOBAL_MEETING_DRAWER_OPENED",
	ADD_GLOBAL_MEETING_DRAWER_CLOSED = "ADD_GLOBAL_MEETING_DRAWER_CLOSED",
	ADD_GLOBAL_LOG_CALL_DRAWER_OPENED = "ADD_GLOBAL_LOG_CALL_DRAWER_OPENED",
	ADD_GLOBAL_LOG_CALL_DRAWER_CLOSED = "ADD_GLOBAL_LOG_CALL_DRAWER_CLOSED",
	ADD_GLOBAL_LOG_EMAIL_DRAWER_OPENED = "ADD_GLOBAL_LOG_EMAIL_DRAWER_OPENED",
	ADD_GLOBAL_LOG_EMAIL_DRAWER_CLOSED = "ADD_GLOBAL_LOG_EMAIL_DRAWER_CLOSED",

	EDIT_GLOBAL_COMMENT_DRAWER_OPENED = "EDIT_GLOBAL_COMMENT_DRAWER_OPENED",
	EDIT_GLOBAL_COMMENT_DRAWER_CLOSED = "EDIT_GLOBAL_COMMENT_DRAWER_CLOSED",
	EDIT_GLOBAL_TASK_DRAWER_OPENED = "EDIT_GLOBAL_TASK_DRAWER_OPENED",
	EDIT_GLOBAL_TASK_DRAWER_CLOSED = "EDIT_GLOBAL_TASK_DRAWER_CLOSED",
	EDIT_GLOBAL_MEETING_DRAWER_OPENED = "EDIT_GLOBAL_MEETING_DRAWER_OPENED",
	EDIT_GLOBAL_MEETING_DRAWER_CLOSED = "EDIT_GLOBAL_MEETING_DRAWER_CLOSED",
	EDIT_GLOBAL_LOG_CALL_DRAWER_OPENED = "EDIT_GLOBAL_LOG_CALL_DRAWER_OPENED",
	EDIT_GLOBAL_LOG_CALL_DRAWER_CLOSED = "EDIT_GLOBAL_LOG_CALL_DRAWER_CLOSED",
	EDIT_GLOBAL_LOG_EMAIL_DRAWER_OPENED = "EDIT_GLOBAL_LOG_EMAIL_DRAWER_OPENED",
	EDIT_GLOBAL_LOG_EMAIL_DRAWER_CLOSED = "EDIT_GLOBAL_LOG_EMAIL_DRAWER_CLOSED",

	UPDATE_ACTIVE_FILTERS = "UPDATE_ACTIVE_FILTERS",

	ADD_ACTIVITY_TO_USERS_SALES_ACTIVITY = "ADD_ACTIVITY_TO_USERS_SALES_ACTIVITY",
	UPDATE_SINGLE_USERS_SALES_ACTIVITY = "UPDATE_SINGLE_USERS_SALES_ACTIVITY",

	GET_ONE_SALES_ACTIVITY_FAILED = "GET_ONE_SALES_ACTIVITY_FAILED",
	GET_ONE_SALES_ACTIVITY_REQUESTED = "GET_ONE_SALES_ACTIVITY_REQUESTED",
	GET_ONE_SALES_ACTIVITY_SUCCESSFUL = "GET_ONE_SALES_ACTIVITY_SUCCESSFUL",

	DELETE_ONE_SALES_ACTIVITY_REQUESTED = "DELETE_ONE_SALES_ACTIVITY_REQUESTED",
	DELETE_ONE_SALES_ACTIVITY_SUCCESSFULLY = "DELETE_ONE_SALES_ACTIVITY_SUCCESSFULLY",
	DELETE_ONE_SALES_ACTIVITY_FAILED = "DELETE_ONE_SALES_ACTIVITY_FAILED",

	FETCHING_MEETING_CLASH_STATUS_REQUESTED = "FETCHING_MEETING_CLASH_STATUS_REQUESTED",
	FETCHING_MEETING_CLASH_STATUS_SUCCESSFUL = "FETCHING_MEETING_CLASH_STATUS_SUCCESSFUL",
	FETCHING_MEETING_CLASH_STATUS_FAILED = "FETCHING_MEETING_CLASH_STATUS_FAILED",

	FETCH_ALL_PSA_AUDIT_LOGS_REQUESTED = "FETCH_ALL_PSA_AUDIT_LOGS_REQUESTED",
	FETCH_ALL_PSA_AUDIT_LOGS_SUCCESSFUL = "FETCH_ALL_PSA_AUDIT_LOGS_SUCCESSFUL",
	FETCH_ALL_PSA_AUDIT_LOGS_FAILED = "FETCH_ALL_PSA_AUDIT_LOGS_FAILED",

	RETRY_FAILED_AUDIT_LOG_REQUESTED = "RETRY_FAILED_AUDIT_LOG_REQUESTED",
	RETRY_FAILED_AUDIT_LOG_SUCCESFUL = "RETRY_FAILED_AUDIT_LOG_SUCCESFUL",
	RETRY_FAILED_AUDIT_LOG_FAILED = "RETRY_FAILED_AUDIT_LOG_FAILED",

	AUDIT_LOG_REDIRECT_URL_REQUESTED = "AUDIT_LOG_REDIRECT_URL_REQUESTED",
	AUDIT_LOG_REDIRECT_URL_SUCCESFUL = "AUDIT_LOG_REDIRECT_URL_SUCCESFUL",
	AUDIT_LOG_REDIRECT_URL_FAILED = "AUDIT_LOG_REDIRECT_URL_FAILED",

	UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION_ACTION_INDEX = "UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION_ACTION_INDEX",
	SHOW_PAYMENT_DRAWER = "SHOW_PAYMENT_DRAWER",
	HIDE_PAYMENT_DRAWER = "HIDE_PAYMENT_DRAWER",
	SHOW_WEBHOOK_DRAWER = "SHOW_WEBHOOK_DRAWER",
	HIDE_WEBHOOK_DRAWER = "HIDE_WEBHOOK_DRAWER",
	UPDATE_SELECTED_DOCUMENT_TYPE = "UPDATE_SELECTED_DOCUMENT_TYPE",

	GET_CONFLICT_MEETING_DETAIL_SUCCESSFUL = "GET_CONFLICT_MEETING_DETAIL_SUCCESSFUL",

	UPDATE_SELECTED_OWNER = "UPDATE_SELECTED_OWNER",
	UPDATE_AUDIT_LOGS_COUNT = "UPDATE_AUDIT_LOGS_COUNT"
}

// Sales Activity Get Actions
export type ShowSalesActivityLoaderAction =
	Action<SalesActivityActionTypes.SHOW_SALES_ACTIVITY_LOADER>;
export type HideSalesActivityLoaderAction =
	Action<SalesActivityActionTypes.HIDE_SALES_ACTIVITY_LOADER>;
export interface SalesActivityActiveTabChangedAction
	extends Action<SalesActivityActionTypes.SALES_ACTIVITY_ACTIVE_TAB_CHANGED> {
	readonly salesActivityActiveTab: RecentActivityFeedType | null;
}
export type AllSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.ALL_SALES_ACTIVITY_REQUESTED>;
export interface AllSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.ALL_SALES_ACTIVITY_SUCCESSFUL> {
	readonly allSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type AllSalesActivityFailedAction =
	Action<SalesActivityActionTypes.ALL_SALES_ACTIVITY_FAILED>;
export type AllCompletedSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.ALL_COMPLETED_SALES_ACTIVITY_REQUESTED>;
export interface AllCompletedSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.ALL_COMPLETED_SALES_ACTIVITY_SUCCESSFUL> {
	readonly allSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type AllCompletedSalesActivityFailedAction =
	Action<SalesActivityActionTypes.ALL_COMPLETED_SALES_ACTIVITY_FAILED>;
export type AllOverdueSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.ALL_OVERDUE_SALES_ACTIVITY_REQUESTED>;
export interface AllOverdueSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.ALL_OVERDUE_SALES_ACTIVITY_SUCCESSFUL> {
	readonly allSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type AllOverdueSalesActivityFailedAction =
	Action<SalesActivityActionTypes.ALL_OVERDUE_SALES_ACTIVITY_FAILED>;
export type AllUpcomingSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.ALL_UPCOMING_SALES_ACTIVITY_REQUESTED>;
export interface AllUpcomingSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.ALL_UPCOMING_SALES_ACTIVITY_SUCCESSFUL> {
	readonly allSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type AllUpcomingSalesActivityFailedAction =
	Action<SalesActivityActionTypes.ALL_UPCOMING_SALES_ACTIVITY_FAILED>;
export type AllSalesActivityResetAction =
	Action<SalesActivityActionTypes.ALL_SALES_ACTIVITY_RESET>;
export type NotesSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.NOTES_SALES_ACTIVITY_REQUESTED>;
export interface NotesSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.NOTES_SALES_ACTIVITY_SUCCESSFUL> {
	readonly notesSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type NotesSalesActivityFailedAction =
	Action<SalesActivityActionTypes.NOTES_SALES_ACTIVITY_FAILED>;
export type NotesPinnedSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.NOTES_PINNED_SALES_ACTIVITY_REQUESTED>;
export interface NotesPinnedSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.NOTES_PINNED_SALES_ACTIVITY_SUCCESSFUL> {
	readonly notesSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type NotesPinnedSalesActivityFailedAction =
	Action<SalesActivityActionTypes.NOTES_PINNED_SALES_ACTIVITY_FAILED>;

export type NotesCompletedSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.NOTES_COMPLETED_SALES_ACTIVITY_REQUESTED>;
export interface NotesCompletedSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.NOTES_COMPLETED_SALES_ACTIVITY_SUCCESSFUL> {
	readonly notesSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type NotesCompletedSalesActivityFailedAction =
	Action<SalesActivityActionTypes.NOTES_COMPLETED_SALES_ACTIVITY_FAILED>;
export type NotesSalesActivityResetAction =
	Action<SalesActivityActionTypes.NOTES_SALES_ACTIVITY_RESET>;
export type TasksSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.TASKS_SALES_ACTIVITY_REQUESTED>;
export interface TasksSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.TASKS_SALES_ACTIVITY_SUCCESSFUL> {
	readonly tasksSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type TasksSalesActivityFailedAction =
	Action<SalesActivityActionTypes.TASKS_SALES_ACTIVITY_FAILED>;
export type TasksCompletedSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.TASKS_COMPLETED_SALES_ACTIVITY_REQUESTED>;
export interface TasksCompletedSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.TASKS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL> {
	readonly tasksSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type TasksCompletedSalesActivityFailedAction =
	Action<SalesActivityActionTypes.TASKS_COMPLETED_SALES_ACTIVITY_FAILED>;
export type TasksOverdueSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.TASKS_OVERDUE_SALES_ACTIVITY_REQUESTED>;
export interface TasksOverdueSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.TASKS_OVERDUE_SALES_ACTIVITY_SUCCESSFUL> {
	readonly tasksSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type TasksOverdueSalesActivityFailedAction =
	Action<SalesActivityActionTypes.TASKS_OVERDUE_SALES_ACTIVITY_FAILED>;
export type TasksUpcomingSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.TASKS_UPCOMING_SALES_ACTIVITY_REQUESTED>;
export interface TasksUpcomingSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.TASKS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL> {
	readonly tasksSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type TasksUpcomingSalesActivityFailedAction =
	Action<SalesActivityActionTypes.TASKS_UPCOMING_SALES_ACTIVITY_FAILED>;
export type TasksSalesActivityResetAction =
	Action<SalesActivityActionTypes.TASKS_SALES_ACTIVITY_RESET>;
export type MeetingsSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_REQUESTED>;
export interface MeetingsSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_SUCCESSFUL> {
	readonly meetingsSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type MeetingsSalesActivityFailedAction =
	Action<SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_FAILED>;
export type MeetingsCompletedSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.MEETINGS_COMPLETED_SALES_ACTIVITY_REQUESTED>;
export interface MeetingsCompletedSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.MEETINGS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL> {
	readonly meetingsSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type MeetingsCompletedSalesActivityFailedAction =
	Action<SalesActivityActionTypes.MEETINGS_COMPLETED_SALES_ACTIVITY_FAILED>;
export type MeetingsUpcomingSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.MEETINGS_UPCOMING_SALES_ACTIVITY_REQUESTED>;
export interface MeetingsUpcomingSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.MEETINGS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL> {
	readonly meetingsSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type MeetingsUpcomingSalesActivityFailedAction =
	Action<SalesActivityActionTypes.MEETINGS_UPCOMING_SALES_ACTIVITY_FAILED>;
export type MeetingsSalesActivityResetAction =
	Action<SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_RESET>;
export type CallsSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.CALLS_SALES_ACTIVITY_REQUESTED>;
export interface CallsSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.CALLS_SALES_ACTIVITY_SUCCESSFUL> {
	readonly callsSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type CallsSalesActivityFailedAction =
	Action<SalesActivityActionTypes.CALLS_SALES_ACTIVITY_FAILED>;
export type CallsSalesActivityResetAction =
	Action<SalesActivityActionTypes.CALLS_SALES_ACTIVITY_RESET>;
export type EmailsSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_REQUESTED>;
export interface EmailsSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_SUCCESSFUL> {
	readonly emailsSalesActivity: AggregateSalesActivityResponse;
	readonly paginate: boolean;
}
export type EmailsSalesActivityFailedAction =
	Action<SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_FAILED>;
export type EmailsSalesActivityResetAction =
	Action<SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_RESET>;
export interface UpdateCurrentActiveSalesActivityAction
	extends Action<SalesActivityActionTypes.UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY> {
	readonly currentActiveSalesActivity: SalesActivity | null;
}
// Sales Activity Delete / Add / Edit Actions
export type DeleteCommentRequestedAction =
	Action<SalesActivityActionTypes.DELETE_COMMENT_REQUESTED>;
export interface DeleteCommentSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_COMMENT_SUCCESSFUL> {
	readonly deleteComment: SalesActivity;
}
export type DeleteCommentFailedAction =
	Action<SalesActivityActionTypes.DELETE_COMMENT_FAILED>;
export type AddSalesActivityCommentRequestedAction =
	Action<SalesActivityActionTypes.ADD_COMMENT_REQUESTED>;
export interface AddCommentSuccessfulAction
	extends Action<SalesActivityActionTypes.ADD_COMMENT_SUCCESSFUL> {
	readonly addComment: SalesActivity;
}
export type AddCommentFailedAction =
	Action<SalesActivityActionTypes.ADD_COMMENT_FAILED>;
export type EditCommentRequestedAction =
	Action<SalesActivityActionTypes.EDIT_COMMENT_REQUESTED>;
export interface EditCommentSuccessfulAction
	extends Action<SalesActivityActionTypes.EDIT_COMMENT_SUCCESSFUL> {
	readonly editComment: SalesActivity;
}
export type EditCommentFailedAction =
	Action<SalesActivityActionTypes.EDIT_COMMENT_FAILED>;
export type DeleteTaskRequestedAction =
	Action<SalesActivityActionTypes.DELETE_TASK_REQUESTED>;
export interface DeleteTaskSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_TASK_SUCCESSFUL> {
	readonly deleteTask: SalesActivity;
}
export type DeleteTaskFailedAction =
	Action<SalesActivityActionTypes.DELETE_TASK_FAILED>;
export type AddTaskRequestedAction =
	Action<SalesActivityActionTypes.ADD_TASK_REQUESTED>;
export interface AddTaskSuccessfulAction
	extends Action<SalesActivityActionTypes.ADD_TASK_SUCCESSFUL> {
	readonly addTask: SalesActivity;
}
export type AddTaskFailedAction =
	Action<SalesActivityActionTypes.ADD_TASK_FAILED>;
export type EditTaskRequestedAction =
	Action<SalesActivityActionTypes.EDIT_TASK_REQUESTED>;
export interface EditTaskSuccessfulAction
	extends Action<SalesActivityActionTypes.EDIT_TASK_SUCCESSFUL> {
	readonly editTask: SalesActivity;
}
export type EditTaskFailedAction =
	Action<SalesActivityActionTypes.EDIT_TASK_FAILED>;
export type DeleteMeetingRequestedAction =
	Action<SalesActivityActionTypes.DELETE_MEETING_REQUESTED>;
export interface DeleteMeetingSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_MEETING_SUCCESSFUL> {
	readonly deleteMeeting: SalesActivity;
}
export type DeleteMeetingFailedAction =
	Action<SalesActivityActionTypes.DELETE_MEETING_FAILED>;
export type AddMeetingRequestedAction =
	Action<SalesActivityActionTypes.ADD_MEETING_REQUESTED>;
export interface AddMeetingSuccessfulAction
	extends Action<SalesActivityActionTypes.ADD_MEETING_SUCCESSFUL> {
	readonly addMeeting: SalesActivity;
}
export type AddMeetingFailedAction =
	Action<SalesActivityActionTypes.ADD_MEETING_FAILED>;
export type EditMeetingRequestedAction =
	Action<SalesActivityActionTypes.EDIT_MEETING_REQUESTED>;
export interface EditMeetingSuccessfulAction
	extends Action<SalesActivityActionTypes.EDIT_MEETING_SUCCESSFUL> {
	readonly editMeeting: SalesActivity;
}
export type EditMeetingFailedAction =
	Action<SalesActivityActionTypes.EDIT_MEETING_FAILED>;
export type DeleteLogCallRequestedAction =
	Action<SalesActivityActionTypes.DELETE_LOG_CALL_REQUESTED>;
export interface DeleteLogCallSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_LOG_CALL_SUCCESSFUL> {
	readonly deleteLogCall: SalesActivity;
}
export type DeleteLogCallFailedAction =
	Action<SalesActivityActionTypes.DELETE_LOG_CALL_FAILED>;
export type AddLogCallRequestedAction =
	Action<SalesActivityActionTypes.ADD_LOG_CALL_REQUESTED>;
export interface AddLogCallSuccessfulAction
	extends Action<SalesActivityActionTypes.ADD_LOG_CALL_SUCCESSFUL> {
	readonly addLogCall: SalesActivity;
}
export type AddLogCallFailedAction =
	Action<SalesActivityActionTypes.ADD_LOG_CALL_FAILED>;
export type EditLogCallRequestedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_CALL_REQUESTED>;
export interface EditLogCallSuccessfulAction
	extends Action<SalesActivityActionTypes.EDIT_LOG_CALL_SUCCESSFUL> {
	readonly editLogCall: SalesActivity;
}
export type EditLogCallFailedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_CALL_FAILED>;
export type DeleteLogEmailRequestedAction =
	Action<SalesActivityActionTypes.DELETE_LOG_EMAIL_REQUESTED>;
export interface DeleteLogEmailSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_LOG_EMAIL_SUCCESSFUL> {
	readonly deleteLogEmail: SalesActivity;
}
export type DeleteLogEmailFailedAction =
	Action<SalesActivityActionTypes.DELETE_LOG_EMAIL_FAILED>;
export type AddLogEmailRequestedAction =
	Action<SalesActivityActionTypes.ADD_LOG_EMAIL_REQUESTED>;
export interface AddLogEmailSuccessfulAction
	extends Action<SalesActivityActionTypes.ADD_LOG_EMAIL_SUCCESSFUL> {
	readonly addLogEmail: SalesActivity;
}
export type AddLogEmailFailedAction =
	Action<SalesActivityActionTypes.ADD_LOG_EMAIL_FAILED>;
export type EditLogEmailRequestedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_EMAIL_REQUESTED>;
export interface EditLogEmailSuccessfulAction
	extends Action<SalesActivityActionTypes.EDIT_LOG_EMAIL_SUCCESSFUL> {
	readonly editLogEmail: SalesActivity;
}
export type EditLogEmailFailedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_EMAIL_FAILED>;
// Sales Activity Automation Actions
export type SalesActivityAutomationsRequestedAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATIONS_REQUESTED>;
export interface SalesActivityAutomationsSuccessfulAction
	extends Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATIONS_SUCCESSFUL> {
	readonly salesActivityAutomationList: SalesActivityAutomation[];
}
export type SalesActivityAutomationsFailedAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATIONS_FAILED>;
export type SalesActivityAutomationMetadataRequestedAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_METADATA_REQUESTED>;
export interface SalesActivityAutomationMetadataSuccessfulAction
	extends Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_METADATA_SUCCESSFUL> {
	readonly salesActivityAutomationFiltersList: SalesActivityAutomationMetadataFilter[];
	readonly opportunity_stages: OpportunityStage[];
	readonly salesActivityAutomationMergeTags: MergeTagVariable[];
}
export type SalesActivityAutomationMetadataFailedAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_METADATA_FAILED>;
export type SalesActivityAutomationDetailsRequestedAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_REQUESTED>;
export interface SalesActivityAutomationDetailsSuccessfulAction
	extends Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_SUCCESSFUL> {
	readonly currentActiveSalesActivityAutomation: SalesActivityAutomation;
}
export type SalesActivityAutomationDetailsFailedAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_FAILED>;
export type SalesActivityAutomationDetailsResetAction =
	Action<SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_RESET>;
export type ReorderSalesActivityAutomationRequestedAction =
	Action<SalesActivityActionTypes.REORDER_SALES_ACTIVITY_AUTOMATION_REQUESTED>;
export interface ReorderSalesActivityAutomationSuccessfulAction
	extends Action<SalesActivityActionTypes.REORDER_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL> {
	readonly salesActivityAutomationList: SalesActivityAutomation[];
}
export type ReorderSalesActivityAutomationFailedAction =
	Action<SalesActivityActionTypes.REORDER_SALES_ACTIVITY_AUTOMATION_FAILED>;
export type ResetSalesActivityAutomationsAction =
	Action<SalesActivityActionTypes.RESET_SALES_ACTIVITY_AUTOMATIONS>;
export type DeleteSalesActivityAutomationRequestedAction =
	Action<SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_REQUESTED>;
export interface DeleteSalesActivityAutomationSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL> {
	readonly deleteSalesActivityAutomation: SalesActivityAutomation;
}
export type DeleteSalesActivityAutomationFailedAction =
	Action<SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_FAILED>;
export type AddSalesActivityAutomationRequestedAction =
	Action<SalesActivityActionTypes.ADD_SALES_ACTIVITY_AUTOMATION_REQUESTED>;
export interface AddSalesActivityAutomationSuccessfulAction
	extends Action<SalesActivityActionTypes.ADD_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL> {
	readonly addSalesActivityAutomation: SalesActivityAutomation;
}
export type AddSalesActivityAutomationFailedAction =
	Action<SalesActivityActionTypes.ADD_SALES_ACTIVITY_AUTOMATION_FAILED>;
export type EditSalesActivityAutomationRequestedAction =
	Action<SalesActivityActionTypes.EDIT_SALES_ACTIVITY_AUTOMATION_REQUESTED>;
export interface EditSalesActivityAutomationSuccessfulAction
	extends Action<SalesActivityActionTypes.EDIT_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL> {
	readonly editSalesActivityAutomation: SalesActivityAutomation;
}
export type EditSalesActivityAutomationFailedAction =
	Action<SalesActivityActionTypes.EDIT_SALES_ACTIVITY_AUTOMATION_FAILED>;
export interface UpdateCurrentActiveSalesActivityAutomationAction
	extends Action<SalesActivityActionTypes.UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION> {
	readonly currentActiveSalesActivityAutomation: SalesActivityAutomation | null;
}
// Sales Activity Drawer Actions
export type AddCommentDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_COMMENT_DRAWER_OPENED>;
export type AddCommentDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_COMMENT_DRAWER_CLOSED>;
export type EditCommentDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_COMMENT_DRAWER_OPENED>;
export type EditCommentDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_COMMENT_DRAWER_CLOSED>;
export type AddTaskDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_TASK_DRAWER_OPENED>;
export type AddTaskDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_TASK_DRAWER_CLOSED>;
export type EditTaskDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_TASK_DRAWER_OPENED>;
export type EditTaskDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_TASK_DRAWER_CLOSED>;
export type AddMeetingDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_MEETING_DRAWER_OPENED>;
export type AddMeetingDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_MEETING_DRAWER_CLOSED>;
export type EditMeetingDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_MEETING_DRAWER_OPENED>;
export type EditMeetingDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_MEETING_DRAWER_CLOSED>;
export type AddLogCallDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_LOG_CALL_DRAWER_OPENED>;
export type AddLogCallDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_LOG_CALL_DRAWER_CLOSED>;
export type EditLogCallDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_CALL_DRAWER_OPENED>;
export type EditLogCallDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_CALL_DRAWER_CLOSED>;
export type AddLogEmailDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_LOG_EMAIL_DRAWER_OPENED>;
export type AddLogEmailDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_LOG_EMAIL_DRAWER_CLOSED>;
export type EditLogEmailDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_EMAIL_DRAWER_OPENED>;
export type EditLogEmailDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_LOG_EMAIL_DRAWER_CLOSED>;
export type UpcomingActivitiesDrawerOpenedAction =
	Action<SalesActivityActionTypes.UPCOMING_ACTIVITIES_DRAWER_OPENED>;
export type UpcomingActivitiesDrawerClosedAction =
	Action<SalesActivityActionTypes.UPCOMING_ACTIVITIES_DRAWER_CLOSED>;
export type AuditLogsDrawerOpenedAction =
	Action<SalesActivityActionTypes.AUDIT_LOGS_DRAWER_OPENED>;
export type AuditLogsDrawerClosedAction =
	Action<SalesActivityActionTypes.AUDIT_LOGS_DRAWER_CLOSED>;

export type HistoryActivitiesRequestedAction =
	Action<SalesActivityActionTypes.HISTORY_ACTIVITIES_REQUESTED>;
export interface HistoryActivitiesSuccessfulAction
	extends Action<SalesActivityActionTypes.HISTORY_ACTIVITIES_SUCCESSFUL> {
	readonly historyResponse: HistoryActivity[];
	readonly next: number | null;
}
export type HistoryActivitiesFailedAction =
	Action<SalesActivityActionTypes.HISTORY_ACTIVITIES_FAILED>;

export type HistoryActivityResetAction =
	Action<SalesActivityActionTypes.HISTORY_ACTIVITIES_RESET>;

export type GetOneMeetingRequestedAction =
	Action<SalesActivityActionTypes.GET_ONE_MEETING_REQUESTED>;
export interface GetOneMeetingSuccessfulAction
	extends Action<SalesActivityActionTypes.GET_ONE_MEETING_SUCCESSFUL> {
	readonly salesActivity: SalesActivity | null;
}
export type GetOneMeetingFailedAction =
	Action<SalesActivityActionTypes.GET_ONE_MEETING_FAILED>;

export type GetOneTaskRequestedAction =
	Action<SalesActivityActionTypes.GET_ONE_TASK_REQUESTED>;
export interface GetOneTaskSuccessfulAction
	extends Action<SalesActivityActionTypes.GET_ONE_TASK_SUCCESSFUL> {
	readonly salesActivity: SalesActivity | null;
}
export type GetOneTaskFailedAction =
	Action<SalesActivityActionTypes.GET_ONE_TASK_FAILED>;

export type GetOneLogCallRequestedAction =
	Action<SalesActivityActionTypes.GET_ONE_LOG_CALL_REQUESTED>;
export interface GetOneLogCallSuccessfulAction
	extends Action<SalesActivityActionTypes.GET_ONE_LOG_CALL_SUCCESSFUL> {
	readonly salesActivity: SalesActivity | null;
}
export type GetOneLogCallFailedAction =
	Action<SalesActivityActionTypes.GET_ONE_LOG_CALL_FAILED>;

export type GetOneLogEmailRequestedAction =
	Action<SalesActivityActionTypes.GET_ONE_LOG_EMAIL_REQUESTED>;
export interface GetOneLogEmailSuccessfulAction
	extends Action<SalesActivityActionTypes.GET_ONE_LOG_EMAIL_SUCCESSFUL> {
	readonly salesActivity: SalesActivity | null;
}
export type GetOneLogEmailFailedAction =
	Action<SalesActivityActionTypes.GET_ONE_LOG_EMAIL_FAILED>;

export type GetOneNoteRequestedAction =
	Action<SalesActivityActionTypes.GET_ONE_NOTE_REQUESTED>;
export interface GetOneNoteSuccessfulAction
	extends Action<SalesActivityActionTypes.GET_ONE_NOTE_SUCCESSFUL> {
	readonly salesActivity: SalesActivity | null;
}
export type GetOneNoteFailedAction =
	Action<SalesActivityActionTypes.GET_ONE_NOTE_FAILED>;

export type FetchUsersAllSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.FETCH_USERS_ALL_SALES_ACTIVITY_REQUESTED>;
export interface FetchUsersAllSalesActivitySuccessfullyAction
	extends Action<SalesActivityActionTypes.FETCH_USERS_ALL_SALES_ACTIVITY_SUCCESSFULLY> {
	readonly salesActivities: SalesActivityResponse;
}
export type FetchUsersAllSalesActivityFailedAction =
	Action<SalesActivityActionTypes.FETCH_USERS_ALL_SALES_ACTIVITY_FAILED>;

export type FetchOpportunitiesForSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_REQUESTED>;
export interface FetchOpportunitiesForSalesActivitySuccessfullyAction
	extends Action<SalesActivityActionTypes.FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_SUCCESSFUL> {
	readonly opportunities: Opportunity[];
}
export type FetchOpportunitiesForSalesActivityFailedAction =
	Action<SalesActivityActionTypes.FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_FAILED>;
export type FetchClientsForSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.FETCH_CLIENTS_FOR_SALES_ACTIVITY_REQUESTED>;
export interface FetchClientsForSalesActivitySuccessfullyAction
	extends Action<SalesActivityActionTypes.FETCH_CLIENTS_FOR_SALES_ACTIVITY_SUCCESSFUL> {
	readonly clients: Client[];
}
export type FetchClientsForSalesActivityFailedAction =
	Action<SalesActivityActionTypes.FETCH_CLIENTS_FOR_SALES_ACTIVITY_FAILED>;
export type FetchClientContactsForSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_REQUESTED>;
export interface FetchClientContactsForSalesActivitySuccessfullyAction
	extends Action<SalesActivityActionTypes.FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_SUCCESSFUL> {
	readonly clientContacts: ClientContact[];
}
export type FetchClientContactsForSalesActivityFailedAction =
	Action<SalesActivityActionTypes.FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_FAILED>;

export type ResetSalesActivityOpportunitiesAction =
	Action<SalesActivityActionTypes.RESET_SALES_ACTIVITY_OPPORTUNITIES>;
export type ResetSalesActivityClientsAction =
	Action<SalesActivityActionTypes.RESET_SALES_ACTIVITY_CLIENTS>;

export type ResetSalesActivityClientContactsAction =
	Action<SalesActivityActionTypes.RESET_SALES_ACTIVITY_CLIENT_CONTACTS>;

export type ResetAllUserSalesActivityAction =
	Action<SalesActivityActionTypes.RESET_USERS_ALL_SALES_ACTIVITY>;
export type SyncWithPSARequestedAction =
	Action<SalesActivityActionTypes.SYNC_WITH_PSA_REQUESTED>;
export type SyncWithPSASuccessfulAction =
	Action<SalesActivityActionTypes.SYNC_WITH_PSA_SUCCESSFUL>;
export type SyncWithPSAFailedAction =
	Action<SalesActivityActionTypes.SYNC_WITH_PSA_FAILED>;

export type AddGlobalCommentDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_COMMENT_DRAWER_OPENED>;
export type AddGlobalCommentDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_COMMENT_DRAWER_CLOSED>;
export type AddGlobalTaskDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_TASK_DRAWER_OPENED>;
export type AddGlobalTaskDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_TASK_DRAWER_CLOSED>;
export type AddGlobalMeetingDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_MEETING_DRAWER_OPENED>;
export type AddGlobalMeetingDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_MEETING_DRAWER_CLOSED>;
export type AddGlobalLogCallDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_LOG_CALL_DRAWER_OPENED>;
export type AddGlobalLogCallDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_LOG_CALL_DRAWER_CLOSED>;
export type AddGlobalLogEmailDrawerOpenedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_LOG_EMAIL_DRAWER_OPENED>;
export type AddGlobalLogEmailDrawerClosedAction =
	Action<SalesActivityActionTypes.ADD_GLOBAL_LOG_EMAIL_DRAWER_CLOSED>;

export type EditGlobalCommentDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_COMMENT_DRAWER_OPENED>;
export type EditGlobalCommentDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_COMMENT_DRAWER_CLOSED>;
export type EditGlobalTaskDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_TASK_DRAWER_OPENED>;
export type EditGlobalTaskDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_TASK_DRAWER_CLOSED>;
export type EditGlobalMeetingDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_MEETING_DRAWER_OPENED>;
export type EditGlobalMeetingDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_MEETING_DRAWER_CLOSED>;
export type EditGlobalLogCallDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_LOG_CALL_DRAWER_OPENED>;
export type EditGlobalLogCallDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_LOG_CALL_DRAWER_CLOSED>;
export type EditGlobalLogEmailDrawerOpenedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_LOG_EMAIL_DRAWER_OPENED>;
export type EditGlobalLogEmailDrawerClosedAction =
	Action<SalesActivityActionTypes.EDIT_GLOBAL_LOG_EMAIL_DRAWER_CLOSED>;

export interface UpdateActiveFiltersAction
	extends Action<SalesActivityActionTypes.UPDATE_ACTIVE_FILTERS> {
	readonly activeFilters: TableQueryFilter[];
}
export interface AddActivityToUsersSalesActivityAction
	extends Action<SalesActivityActionTypes.ADD_ACTIVITY_TO_USERS_SALES_ACTIVITY> {
	readonly salesActivity: SalesActivity;
}

export interface UpdateSingleUserSalesActivityAction
	extends Action<SalesActivityActionTypes.UPDATE_SINGLE_USERS_SALES_ACTIVITY> {
	readonly salesActivity: SalesActivity;
}

export type GetOneSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.GET_ONE_SALES_ACTIVITY_REQUESTED>;
export interface GetOneSalesActivitySuccessfulAction
	extends Action<SalesActivityActionTypes.GET_ONE_SALES_ACTIVITY_SUCCESSFUL> {
	readonly salesActivity: SalesActivity;
}
export type GetOneSalesActivityFailedAction =
	Action<SalesActivityActionTypes.GET_ONE_SALES_ACTIVITY_FAILED>;

export type DeleteOneSalesActivityRequestedAction =
	Action<SalesActivityActionTypes.DELETE_ONE_SALES_ACTIVITY_REQUESTED>;
export interface DeleteOneSalesActivitySuccessfullyAction
	extends Action<SalesActivityActionTypes.DELETE_ONE_SALES_ACTIVITY_SUCCESSFULLY> {
	readonly salesActivityId: string;
}
export type DeleteOneSalesActivityFailedAction =
	Action<SalesActivityActionTypes.DELETE_ONE_SALES_ACTIVITY_FAILED>;

export type FetchMeetingClashStatusRequested =
	Action<SalesActivityActionTypes.FETCHING_MEETING_CLASH_STATUS_REQUESTED>;
export interface FetchMeetingClashStatusSuccessful
	extends Action<SalesActivityActionTypes.FETCHING_MEETING_CLASH_STATUS_SUCCESSFUL> {
	readonly meetingStatus: MeetingClashStatus;
}
export type FetchMeetingClashStatusFailed =
	Action<SalesActivityActionTypes.FETCHING_MEETING_CLASH_STATUS_FAILED>;

export type FetchAllPSAAuditLogsRequestedAction =
	Action<SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_REQUESTED>;
export interface FetchAllPSAAuditLogsSuccessfulAction
	extends Action<SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_SUCCESSFUL> {
	readonly auditLogs: HistoryActivity[];
	readonly paymentLogs?: PaymentHistoryActivity[];
	readonly next: number | null;
	readonly count: number | null;
}
export type FetchAllPSAAuditLogsFailedAction =
	Action<SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_FAILED>;

export type RetryFailedAuditLogsRequestedAction =
	Action<SalesActivityActionTypes.RETRY_FAILED_AUDIT_LOG_REQUESTED>;
export type RetryFailedAuditLogsSuccesfulAction =
	Action<SalesActivityActionTypes.RETRY_FAILED_AUDIT_LOG_SUCCESFUL>;
export type RetryFailedAuditLogsFailedAction =
	Action<SalesActivityActionTypes.RETRY_FAILED_AUDIT_LOG_FAILED>;

export type AuditLogRedirectUrlRequestedAction =
	Action<SalesActivityActionTypes.AUDIT_LOG_REDIRECT_URL_REQUESTED>;

export interface AuditLogRedirectUrlSuccessfulAction
	extends Action<SalesActivityActionTypes.AUDIT_LOG_REDIRECT_URL_SUCCESFUL> {
	readonly redirectUrl: string;
}

export type AuditLogRedirectUrlFailedAction =
	Action<SalesActivityActionTypes.AUDIT_LOG_REDIRECT_URL_FAILED>;

export interface UpdateCurrentActiveSalesActivityAutomationActionIndex
	extends Action<SalesActivityActionTypes.UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION_ACTION_INDEX> {
	readonly index: number;
}

export type PaymentDrawerOpenedAction =
	Action<SalesActivityActionTypes.SHOW_PAYMENT_DRAWER>;
export type PaymentDrawerClosedAction =
	Action<SalesActivityActionTypes.HIDE_PAYMENT_DRAWER>;
export type WebhookDrawerOpenedAction =
	Action<SalesActivityActionTypes.SHOW_WEBHOOK_DRAWER>;
export type WebhookDrawerClosedAction =
	Action<SalesActivityActionTypes.HIDE_WEBHOOK_DRAWER>;
export interface UpdatedSelectedDocumentAction
	extends Action<SalesActivityActionTypes.UPDATE_SELECTED_DOCUMENT_TYPE> {
	readonly selectedDocumentType: SelectedDocumentAndTemplate;
}
export type FetchSalesActivityAndAutomationViewMetadataRequested =
	Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_REQUESTED>;
export interface FetchSalesActivityAndAutomationViewMetadataSuccessful
	extends Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_SUCCESSFUL> {
	readonly metadata: CustomViewsMetadata;
}
export type FetchSalesActivityAndAutomationViewMetadataFailed =
	Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_FAILED>;

export type FetchSalesActivityAndAutomationViewsRequested =
	Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_REQUESTED>;

export interface FetchSalesActivityAndAutomationViewsSussessfull
	extends Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_SUCCESSFUL> {
	readonly viewsList: CustomViewResponse;
}

export type FetchSalesActivityAndAutomationViewsFailed =
	Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_FAILED>;

export interface UpdateCurrentActiveViewAction
	extends Action<SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_CURRENT_ACTIVE_VIEW> {
	readonly currentActiveView: CustomView;
	readonly isViewChanged: boolean;
}

export type CreateSalesActivityAndAutomationViewRequestedAction =
	Action<SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED>;
export interface CreateSalesActivityAndAutomationViewSuccessfulAction
	extends Action<SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL> {
	readonly view: CustomView;
}
export type CreateSalesActivityAndAutomationViewFailedAction =
	Action<SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED>;

export type UpdateSalesActivityAndAutomationViewRequestedAction =
	Action<SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED>;
export interface UpdateSalesActivityAndAutomationViewSuccessfulAction
	extends Action<SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL> {
	readonly view: CustomView;
}
export type UpdateSalesActivityAndAutomationViewFailedAction =
	Action<SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED>;

export type DeleteSalesActivityAndAutomationViewRequestedAction =
	Action<SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED>;
export interface DeleteSalesActivityAndAutomationViewSuccessfulAction
	extends Action<SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL> {
	readonly deletedView: CustomView;
	readonly initialView: CustomView;
}
export type DeleteSalesActivityAndAutomationViewFailedAction =
	Action<SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED>;

export type FetchSalesActivityAndAutomationListRequested =
	Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_REQUESTED>;
export interface FetchSalesActivityAndAutomationListSuccessful
	extends Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_SUCCESSFUL> {
	readonly salesAutomationList: SalesActivityAutomationResponse;
}
export type FetchSalesActivityAndAutomationListFailed =
	Action<SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_FAILED>;

export interface GetConflictMeetingDetailSuccessful
	extends Action<SalesActivityActionTypes.GET_CONFLICT_MEETING_DETAIL_SUCCESSFUL> {
	readonly conflictMeetings: ConflictedMeetigs[];
}
export interface UpdateSelectedOwnerViewAction
	extends Action<SalesActivityActionTypes.UPDATE_SELECTED_OWNER> {
	readonly selectedOwnerView: SalesActivityUserViews;
}

export interface UpdateAuditLogsCountViewAction
	extends Action<SalesActivityActionTypes.UPDATE_AUDIT_LOGS_COUNT> {
	readonly auditLogsCount: number;
}

export type SalesActivityActions =
	// Sales Activity Get Actions
	| ShowSalesActivityLoaderAction
	| HideSalesActivityLoaderAction
	| SalesActivityActiveTabChangedAction
	| AllSalesActivityRequestedAction
	| AllSalesActivitySuccessfulAction
	| AllSalesActivityFailedAction
	| AllCompletedSalesActivityRequestedAction
	| AllCompletedSalesActivitySuccessfulAction
	| AllCompletedSalesActivityFailedAction
	| AllOverdueSalesActivityRequestedAction
	| AllOverdueSalesActivitySuccessfulAction
	| AllOverdueSalesActivityFailedAction
	| AllUpcomingSalesActivityRequestedAction
	| AllUpcomingSalesActivitySuccessfulAction
	| AllUpcomingSalesActivityFailedAction
	| AllSalesActivityResetAction
	| NotesSalesActivityRequestedAction
	| NotesSalesActivitySuccessfulAction
	| NotesSalesActivityFailedAction
	| NotesPinnedSalesActivityRequestedAction
	| NotesPinnedSalesActivitySuccessfulAction
	| NotesPinnedSalesActivityFailedAction
	| NotesCompletedSalesActivityRequestedAction
	| NotesCompletedSalesActivitySuccessfulAction
	| NotesCompletedSalesActivityFailedAction
	| NotesSalesActivityResetAction
	| TasksSalesActivityRequestedAction
	| TasksSalesActivitySuccessfulAction
	| TasksSalesActivityFailedAction
	| TasksCompletedSalesActivityRequestedAction
	| TasksCompletedSalesActivitySuccessfulAction
	| TasksCompletedSalesActivityFailedAction
	| TasksOverdueSalesActivityRequestedAction
	| TasksOverdueSalesActivitySuccessfulAction
	| TasksOverdueSalesActivityFailedAction
	| TasksUpcomingSalesActivityRequestedAction
	| TasksUpcomingSalesActivitySuccessfulAction
	| TasksUpcomingSalesActivityFailedAction
	| TasksSalesActivityResetAction
	| MeetingsSalesActivityRequestedAction
	| MeetingsSalesActivitySuccessfulAction
	| MeetingsSalesActivityFailedAction
	| MeetingsCompletedSalesActivityRequestedAction
	| MeetingsCompletedSalesActivitySuccessfulAction
	| MeetingsCompletedSalesActivityFailedAction
	| MeetingsUpcomingSalesActivityRequestedAction
	| MeetingsUpcomingSalesActivitySuccessfulAction
	| MeetingsUpcomingSalesActivityFailedAction
	| MeetingsSalesActivityResetAction
	| CallsSalesActivityRequestedAction
	| CallsSalesActivitySuccessfulAction
	| CallsSalesActivityFailedAction
	| CallsSalesActivityResetAction
	| EmailsSalesActivityRequestedAction
	| EmailsSalesActivitySuccessfulAction
	| EmailsSalesActivityFailedAction
	| EmailsSalesActivityResetAction
	| UpdateCurrentActiveSalesActivityAction
	| GetOneMeetingRequestedAction
	| GetOneMeetingSuccessfulAction
	| GetOneMeetingFailedAction
	| GetOneTaskRequestedAction
	| GetOneTaskSuccessfulAction
	| GetOneTaskFailedAction
	| GetOneLogCallRequestedAction
	| GetOneLogCallSuccessfulAction
	| GetOneLogCallFailedAction
	| GetOneLogEmailRequestedAction
	| GetOneLogEmailSuccessfulAction
	| GetOneLogEmailFailedAction
	| GetOneNoteRequestedAction
	| GetOneNoteSuccessfulAction
	| GetOneNoteFailedAction
	// Sales Activity Delete / Add / Edit Actions
	| DeleteCommentRequestedAction
	| DeleteCommentSuccessfulAction
	| DeleteCommentFailedAction
	| AddSalesActivityCommentRequestedAction
	| AddCommentSuccessfulAction
	| AddCommentFailedAction
	| EditCommentRequestedAction
	| EditCommentSuccessfulAction
	| EditCommentFailedAction
	| DeleteTaskRequestedAction
	| DeleteTaskSuccessfulAction
	| DeleteTaskFailedAction
	| AddTaskRequestedAction
	| AddTaskSuccessfulAction
	| AddTaskFailedAction
	| EditTaskRequestedAction
	| EditTaskSuccessfulAction
	| EditTaskFailedAction
	| DeleteMeetingRequestedAction
	| DeleteMeetingSuccessfulAction
	| DeleteMeetingFailedAction
	| AddMeetingRequestedAction
	| AddMeetingSuccessfulAction
	| AddMeetingFailedAction
	| EditMeetingRequestedAction
	| EditMeetingSuccessfulAction
	| EditMeetingFailedAction
	| DeleteLogCallRequestedAction
	| DeleteLogCallSuccessfulAction
	| DeleteLogCallFailedAction
	| AddLogCallRequestedAction
	| AddLogCallSuccessfulAction
	| AddLogCallFailedAction
	| EditLogCallRequestedAction
	| EditLogCallSuccessfulAction
	| EditLogCallFailedAction
	| DeleteLogEmailRequestedAction
	| DeleteLogEmailSuccessfulAction
	| DeleteLogEmailFailedAction
	| AddLogEmailRequestedAction
	| AddLogEmailSuccessfulAction
	| AddLogEmailFailedAction
	| EditLogEmailRequestedAction
	| EditLogEmailSuccessfulAction
	| EditLogEmailFailedAction
	// Sales Activity Automation Actions
	| SalesActivityAutomationsRequestedAction
	| SalesActivityAutomationsSuccessfulAction
	| SalesActivityAutomationsFailedAction
	| SalesActivityAutomationMetadataRequestedAction
	| SalesActivityAutomationMetadataSuccessfulAction
	| SalesActivityAutomationMetadataFailedAction
	| SalesActivityAutomationDetailsRequestedAction
	| SalesActivityAutomationDetailsSuccessfulAction
	| SalesActivityAutomationDetailsFailedAction
	| SalesActivityAutomationDetailsResetAction
	| ReorderSalesActivityAutomationRequestedAction
	| ReorderSalesActivityAutomationSuccessfulAction
	| ReorderSalesActivityAutomationFailedAction
	| ResetSalesActivityAutomationsAction
	| DeleteSalesActivityAutomationRequestedAction
	| DeleteSalesActivityAutomationSuccessfulAction
	| DeleteSalesActivityAutomationFailedAction
	| AddSalesActivityAutomationRequestedAction
	| AddSalesActivityAutomationSuccessfulAction
	| AddSalesActivityAutomationFailedAction
	| EditSalesActivityAutomationRequestedAction
	| EditSalesActivityAutomationSuccessfulAction
	| EditSalesActivityAutomationFailedAction
	| UpdateCurrentActiveSalesActivityAutomationAction
	| FetchSalesActivityAndAutomationViewMetadataRequested
	| FetchSalesActivityAndAutomationViewMetadataSuccessful
	| FetchSalesActivityAndAutomationViewMetadataFailed
	| FetchSalesActivityAndAutomationViewsRequested
	| FetchSalesActivityAndAutomationViewsSussessfull
	| FetchSalesActivityAndAutomationViewsFailed
	| UpdateCurrentActiveViewAction
	| CreateSalesActivityAndAutomationViewRequestedAction
	| CreateSalesActivityAndAutomationViewSuccessfulAction
	| CreateSalesActivityAndAutomationViewFailedAction
	| UpdateSalesActivityAndAutomationViewRequestedAction
	| UpdateSalesActivityAndAutomationViewSuccessfulAction
	| UpdateSalesActivityAndAutomationViewFailedAction
	| DeleteSalesActivityAndAutomationViewRequestedAction
	| DeleteSalesActivityAndAutomationViewSuccessfulAction
	| DeleteSalesActivityAndAutomationViewFailedAction
	| FetchSalesActivityAndAutomationListRequested
	| FetchSalesActivityAndAutomationListSuccessful
	| FetchSalesActivityAndAutomationListFailed

	// Sales Activity Drawer Actions
	| AddCommentDrawerOpenedAction
	| AddCommentDrawerClosedAction
	| EditCommentDrawerOpenedAction
	| EditCommentDrawerClosedAction
	| AddTaskDrawerOpenedAction
	| AddTaskDrawerClosedAction
	| EditTaskDrawerOpenedAction
	| EditTaskDrawerClosedAction
	| AddMeetingDrawerOpenedAction
	| AddMeetingDrawerClosedAction
	| EditMeetingDrawerOpenedAction
	| EditMeetingDrawerClosedAction
	| AddLogCallDrawerOpenedAction
	| AddLogCallDrawerClosedAction
	| EditLogCallDrawerOpenedAction
	| EditLogCallDrawerClosedAction
	| AddLogEmailDrawerOpenedAction
	| AddLogEmailDrawerClosedAction
	| EditLogEmailDrawerOpenedAction
	| EditLogEmailDrawerClosedAction
	| HistoryActivitiesRequestedAction
	| HistoryActivitiesSuccessfulAction
	| HistoryActivitiesFailedAction
	| HistoryActivityResetAction
	| UpcomingActivitiesDrawerOpenedAction
	| UpcomingActivitiesDrawerClosedAction
	| AuditLogsDrawerOpenedAction
	| AuditLogsDrawerClosedAction
	| FetchUsersAllSalesActivityRequestedAction
	| FetchUsersAllSalesActivitySuccessfullyAction
	| FetchUsersAllSalesActivityFailedAction
	| FetchOpportunitiesForSalesActivityRequestedAction
	| FetchOpportunitiesForSalesActivitySuccessfullyAction
	| FetchOpportunitiesForSalesActivityFailedAction
	| FetchClientsForSalesActivityRequestedAction
	| FetchClientsForSalesActivitySuccessfullyAction
	| FetchClientsForSalesActivityFailedAction
	| FetchClientContactsForSalesActivityRequestedAction
	| FetchClientContactsForSalesActivitySuccessfullyAction
	| FetchClientContactsForSalesActivityFailedAction
	| ResetSalesActivityOpportunitiesAction
	| ResetSalesActivityClientsAction
	| ResetSalesActivityClientContactsAction
	| SyncWithPSARequestedAction
	| SyncWithPSASuccessfulAction
	| SyncWithPSAFailedAction
	| ResetAllUserSalesActivityAction
	| AddGlobalCommentDrawerOpenedAction
	| AddGlobalCommentDrawerClosedAction
	| AddGlobalTaskDrawerOpenedAction
	| AddGlobalTaskDrawerClosedAction
	| AddGlobalMeetingDrawerOpenedAction
	| AddGlobalMeetingDrawerClosedAction
	| AddGlobalLogCallDrawerOpenedAction
	| AddGlobalLogCallDrawerClosedAction
	| AddGlobalLogEmailDrawerOpenedAction
	| AddGlobalLogEmailDrawerClosedAction
	| EditGlobalCommentDrawerOpenedAction
	| EditGlobalCommentDrawerClosedAction
	| EditGlobalTaskDrawerOpenedAction
	| EditGlobalTaskDrawerClosedAction
	| EditGlobalMeetingDrawerOpenedAction
	| EditGlobalMeetingDrawerClosedAction
	| EditGlobalLogCallDrawerOpenedAction
	| EditGlobalLogCallDrawerClosedAction
	| EditGlobalLogEmailDrawerOpenedAction
	| EditGlobalLogEmailDrawerClosedAction
	| UpdateActiveFiltersAction
	| AddActivityToUsersSalesActivityAction
	| UpdateSingleUserSalesActivityAction
	| GetOneSalesActivityRequestedAction
	| GetOneSalesActivitySuccessfulAction
	| GetOneSalesActivityFailedAction
	| DeleteOneSalesActivityRequestedAction
	| DeleteOneSalesActivitySuccessfullyAction
	| DeleteOneSalesActivityFailedAction
	| FetchMeetingClashStatusRequested
	| FetchMeetingClashStatusSuccessful
	| FetchMeetingClashStatusFailed
	| FetchAllPSAAuditLogsRequestedAction
	| FetchAllPSAAuditLogsSuccessfulAction
	| FetchAllPSAAuditLogsFailedAction
	| RetryFailedAuditLogsRequestedAction
	| RetryFailedAuditLogsSuccesfulAction
	| RetryFailedAuditLogsFailedAction
	| AuditLogRedirectUrlRequestedAction
	| AuditLogRedirectUrlSuccessfulAction
	| AuditLogRedirectUrlFailedAction
	| UpdateCurrentActiveSalesActivityAutomationActionIndex
	| PaymentDrawerOpenedAction
	| PaymentDrawerClosedAction
	| WebhookDrawerOpenedAction
	| WebhookDrawerClosedAction
	| UpdatedSelectedDocumentAction
	| GetConflictMeetingDetailSuccessful
	| UpdateSelectedOwnerViewAction
	| UpdateAuditLogsCountViewAction;

export interface SalesActivityDispatch {
	// Sales Activity Get Actions
	showSalesActivityLoader: ActionCreator<
		ThunkAction<
			ShowSalesActivityLoaderAction,
			SalesActivityModuleState,
			null,
			ShowSalesActivityLoaderAction
		>
	>;
	hideSalesActivityLoader: ActionCreator<
		ThunkAction<
			HideSalesActivityLoaderAction,
			SalesActivityModuleState,
			null,
			HideSalesActivityLoaderAction
		>
	>;
	salesActivityActiveTabChanged: ActionCreator<
		ThunkAction<
			SalesActivityActiveTabChangedAction,
			SalesActivityModuleState,
			RecentActivityFeedType | null,
			SalesActivityActiveTabChangedAction
		>
	>;
	getAllSalesActivity: ActionCreator<
		ThunkAction<
			Promise<AllSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			AllSalesActivitySuccessfulAction
		>
	>;
	getAllCompletedSalesActivity: ActionCreator<
		ThunkAction<
			Promise<AllCompletedSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			AllCompletedSalesActivitySuccessfulAction
		>
	>;
	getAllOverdueSalesActivity: ActionCreator<
		ThunkAction<
			Promise<AllOverdueSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			AllOverdueSalesActivitySuccessfulAction
		>
	>;
	getAllUpcomingSalesActivity: ActionCreator<
		ThunkAction<
			Promise<AllUpcomingSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			AllUpcomingSalesActivitySuccessfulAction
		>
	>;
	resetAllSalesActivity: ActionCreator<
		ThunkAction<
			AllSalesActivityResetAction,
			SalesActivityModuleState,
			null,
			AllSalesActivityResetAction
		>
	>;
	getNotesSalesActivity: ActionCreator<
		ThunkAction<
			Promise<NotesSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			NotesSalesActivitySuccessfulAction
		>
	>;
	getNotesPinnedSalesActivity: ActionCreator<
		ThunkAction<
			Promise<NotesPinnedSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			NotesPinnedSalesActivitySuccessfulAction
		>
	>;
	getNotesCompletedSalesActivity: ActionCreator<
		ThunkAction<
			Promise<NotesCompletedSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			NotesCompletedSalesActivitySuccessfulAction
		>
	>;
	resetNotesSalesActivity: ActionCreator<
		ThunkAction<
			NotesSalesActivityResetAction,
			SalesActivityModuleState,
			null,
			NotesSalesActivityResetAction
		>
	>;
	getTasksSalesActivity: ActionCreator<
		ThunkAction<
			Promise<TasksSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			TasksSalesActivitySuccessfulAction
		>
	>;
	getTasksCompletedSalesActivity: ActionCreator<
		ThunkAction<
			Promise<TasksCompletedSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			TasksCompletedSalesActivitySuccessfulAction
		>
	>;
	getTasksOverdueSalesActivity: ActionCreator<
		ThunkAction<
			Promise<TasksOverdueSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			TasksOverdueSalesActivitySuccessfulAction
		>
	>;
	getTasksUpcomingSalesActivity: ActionCreator<
		ThunkAction<
			Promise<TasksUpcomingSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			TasksUpcomingSalesActivitySuccessfulAction
		>
	>;
	resetTasksSalesActivity: ActionCreator<
		ThunkAction<
			TasksSalesActivityResetAction,
			SalesActivityModuleState,
			null,
			TasksSalesActivityResetAction
		>
	>;
	getMeetingsSalesActivity: ActionCreator<
		ThunkAction<
			Promise<MeetingsSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			MeetingsSalesActivitySuccessfulAction
		>
	>;
	getMeetingsCompletedSalesActivity: ActionCreator<
		ThunkAction<
			Promise<MeetingsCompletedSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			MeetingsCompletedSalesActivitySuccessfulAction
		>
	>;
	getMeetingsUpcomingSalesActivity: ActionCreator<
		ThunkAction<
			Promise<MeetingsUpcomingSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			MeetingsUpcomingSalesActivitySuccessfulAction
		>
	>;
	resetMeetingsSalesActivity: ActionCreator<
		ThunkAction<
			MeetingsSalesActivityResetAction,
			SalesActivityModuleState,
			null,
			MeetingsSalesActivityResetAction
		>
	>;
	getCallsSalesActivity: ActionCreator<
		ThunkAction<
			Promise<CallsSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			CallsSalesActivitySuccessfulAction
		>
	>;
	resetCallsSalesActivity: ActionCreator<
		ThunkAction<
			CallsSalesActivityResetAction,
			SalesActivityModuleState,
			null,
			CallsSalesActivityResetAction
		>
	>;
	getEmailsSalesActivity: ActionCreator<
		ThunkAction<
			Promise<EmailsSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityRequest,
			EmailsSalesActivitySuccessfulAction
		>
	>;
	resetEmailsSalesActivity: ActionCreator<
		ThunkAction<
			EmailsSalesActivityResetAction,
			SalesActivityModuleState,
			null,
			EmailsSalesActivityResetAction
		>
	>;
	updateCurrentActiveSalesActivity: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveSalesActivityAction,
			SalesActivityModuleState,
			SalesActivity | null,
			UpdateCurrentActiveSalesActivityAction
		>
	>;
	// Sales Activity Delete / Add / Edit Actions
	deleteComment: ActionCreator<
		ThunkAction<
			Promise<DeleteCommentSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			DeleteCommentSuccessfulAction
		>
	>;
	addComment: ActionCreator<
		ThunkAction<
			Promise<AddCommentSuccessfulAction>,
			SalesActivityModuleState,
			AddSalesActivityCommentRequest,
			AddCommentSuccessfulAction
		>
	>;
	editComment: ActionCreator<
		ThunkAction<
			Promise<EditCommentSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			EditCommentSuccessfulAction
		>
	>;
	deleteTask: ActionCreator<
		ThunkAction<
			Promise<DeleteTaskSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			DeleteTaskSuccessfulAction
		>
	>;
	addTask: ActionCreator<
		ThunkAction<
			Promise<AddTaskSuccessfulAction>,
			SalesActivityModuleState,
			AddTaskRequest,
			AddTaskSuccessfulAction
		>
	>;
	editTask: ActionCreator<
		ThunkAction<
			Promise<EditTaskSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			EditTaskSuccessfulAction
		>
	>;
	deleteMeeting: ActionCreator<
		ThunkAction<
			Promise<DeleteMeetingSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			DeleteMeetingSuccessfulAction
		>
	>;
	addMeeting: ActionCreator<
		ThunkAction<
			Promise<AddMeetingSuccessfulAction>,
			SalesActivityModuleState,
			AddMeetingRequest,
			AddMeetingSuccessfulAction
		>
	>;
	editMeeting: ActionCreator<
		ThunkAction<
			Promise<EditMeetingSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			EditMeetingSuccessfulAction
		>
	>;
	deleteLogCall: ActionCreator<
		ThunkAction<
			Promise<DeleteLogCallSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			DeleteLogCallSuccessfulAction
		>
	>;
	addLogCall: ActionCreator<
		ThunkAction<
			Promise<AddLogCallSuccessfulAction>,
			SalesActivityModuleState,
			AddLogCallRequest,
			AddLogCallSuccessfulAction
		>
	>;
	editLogCall: ActionCreator<
		ThunkAction<
			Promise<EditLogCallSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			EditLogCallSuccessfulAction
		>
	>;
	deleteLogEmail: ActionCreator<
		ThunkAction<
			Promise<DeleteLogEmailSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			DeleteLogEmailSuccessfulAction
		>
	>;
	addLogEmail: ActionCreator<
		ThunkAction<
			Promise<AddLogEmailSuccessfulAction>,
			SalesActivityModuleState,
			AddLogEmailRequest,
			AddLogEmailSuccessfulAction
		>
	>;
	editLogEmail: ActionCreator<
		ThunkAction<
			Promise<EditLogEmailSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivity,
			EditLogEmailSuccessfulAction
		>
	>;
	// Sales Activity Automation Actions
	getSalesActivityAutomations: ActionCreator<
		ThunkAction<
			Promise<SalesActivityAutomationsSuccessfulAction>,
			SalesActivityModuleState,
			null,
			SalesActivityAutomationsSuccessfulAction
		>
	>;
	getSalesActivityAutomationMetadata: ActionCreator<
		ThunkAction<
			Promise<SalesActivityAutomationMetadataSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityAutomationMetadataRequest,
			SalesActivityAutomationMetadataSuccessfulAction
		>
	>;
	getSalesActivityAutomationDetails: ActionCreator<
		ThunkAction<
			Promise<SalesActivityAutomationDetailsSuccessfulAction>,
			SalesActivityModuleState,
			string,
			SalesActivityAutomationDetailsSuccessfulAction
		>
	>;
	resetSalesActivityAutomationDetails: ActionCreator<
		ThunkAction<
			SalesActivityAutomationDetailsResetAction,
			SalesActivityModuleState,
			null,
			SalesActivityAutomationDetailsResetAction
		>
	>;
	reorderSalesActivityAutomation: ActionCreator<
		ThunkAction<
			Promise<ReorderSalesActivityAutomationSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityAutomation[],
			ReorderSalesActivityAutomationSuccessfulAction
		>
	>;
	resetSalesActivityAutomations: ActionCreator<
		ThunkAction<
			ResetSalesActivityAutomationsAction,
			SalesActivityModuleState,
			null,
			ResetSalesActivityAutomationsAction
		>
	>;
	deleteSalesActivityAutomation: ActionCreator<
		ThunkAction<
			Promise<DeleteSalesActivityAutomationSuccessfulAction>,
			SalesActivityModuleState,
			SalesActivityAutomation,
			DeleteSalesActivityAutomationSuccessfulAction
		>
	>;
	addSalesActivityAutomation: ActionCreator<
		ThunkAction<
			Promise<AddSalesActivityAutomationSuccessfulAction>,
			SalesActivityModuleState,
			AddSalesActivityAutomationRequest,
			AddSalesActivityAutomationSuccessfulAction
		>
	>;
	editSalesActivityAutomation: ActionCreator<
		ThunkAction<
			Promise<EditSalesActivityAutomationSuccessfulAction>,
			SalesActivityModuleState,
			EditSalesActivityAutomationRequest,
			EditSalesActivityAutomationSuccessfulAction
		>
	>;
	updateCurrentActiveSalesActivityAutomation: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveSalesActivityAutomationAction,
			SalesActivityModuleState,
			SalesActivityAutomation | null,
			UpdateCurrentActiveSalesActivityAutomationAction
		>
	>;
	getHistoryActivities: ActionCreator<
		ThunkAction<
			Promise<HistoryActivitiesSuccessfulAction>,
			SalesActivityModuleState,
			HistoryActivityRequest,
			HistoryActivitiesSuccessfulAction
		>
	>;
	resetHistoryActivity: ActionCreator<
		ThunkAction<
			HistoryActivityResetAction,
			SalesActivityModuleState,
			null,
			HistoryActivityResetAction
		>
	>;
	getOneMeeting: ActionCreator<
		ThunkAction<
			Promise<GetOneMeetingSuccessfulAction>,
			SalesActivityModuleState,
			GetOneSaleActivityRequest,
			GetOneMeetingSuccessfulAction
		>
	>;
	getOneTask: ActionCreator<
		ThunkAction<
			Promise<GetOneTaskSuccessfulAction>,
			SalesActivityModuleState,
			GetOneSaleActivityRequest,
			GetOneTaskSuccessfulAction
		>
	>;
	getOneLogCall: ActionCreator<
		ThunkAction<
			Promise<GetOneLogCallSuccessfulAction>,
			SalesActivityModuleState,
			GetOneSaleActivityRequest,
			GetOneLogCallSuccessfulAction
		>
	>;
	getOneLogEmail: ActionCreator<
		ThunkAction<
			Promise<GetOneLogEmailSuccessfulAction>,
			SalesActivityModuleState,
			GetOneSaleActivityRequest,
			GetOneLogEmailSuccessfulAction
		>
	>;
	getOneNote: ActionCreator<
		ThunkAction<
			Promise<GetOneNoteSuccessfulAction>,
			SalesActivityModuleState,
			GetOneSaleActivityRequest,
			GetOneNoteSuccessfulAction
		>
	>;
	fetchSalesActivityAndAutomationViewMetadata: ActionCreator<
		ThunkAction<
			Promise<FetchSalesActivityAndAutomationViewMetadataSuccessful>,
			SalesActivityModuleState,
			{ entity: ZomentumEntities },
			FetchSalesActivityAndAutomationViewMetadataSuccessful
		>
	>;
	fetchSalesActivityAndAutomationViewsList: ActionCreator<
		ThunkAction<
			Promise<FetchSalesActivityAndAutomationViewsSussessfull>,
			SalesActivityModuleState,
			{ entity: ZomentumEntities },
			FetchSalesActivityAndAutomationViewsSussessfull
		>
	>;
	updateCurrentActiveView: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveViewAction,
			SalesActivityModuleState,
			{ selectCurrentActiveView: CustomView; discardingView?: boolean },
			UpdateCurrentActiveViewAction
		>
	>;
	createSalesActivityAndAutomationView: ActionCreator<
		ThunkAction<
			Promise<CreateSalesActivityAndAutomationViewSuccessfulAction>,
			SalesActivityModuleState,
			CustomView,
			CreateSalesActivityAndAutomationViewSuccessfulAction
		>
	>;
	updateSalesActivityAndAutomationView: ActionCreator<
		ThunkAction<
			Promise<UpdateSalesActivityAndAutomationViewSuccessfulAction>,
			SalesActivityModuleState,
			CustomView,
			UpdateSalesActivityAndAutomationViewSuccessfulAction
		>
	>;
	deleteSalesActivityAndAutomationView: ActionCreator<
		ThunkAction<
			Promise<DeleteSalesActivityAndAutomationViewSuccessfulAction>,
			SalesActivityModuleState,
			{ deleteView: CustomView; initialView: CustomView },
			DeleteSalesActivityAndAutomationViewSuccessfulAction
		>
	>;
	fetchAllSalesActivityAndAutomation: ActionCreator<
		ThunkAction<
			Promise<FetchSalesActivityAndAutomationListSuccessful>,
			SalesActivityModuleState,
			ListPagePostRequest,
			FetchSalesActivityAndAutomationListSuccessful
		>
	>;

	// Sales Activity Drawer Actions
	addCommentDrawerOpened: ActionCreator<
		ThunkAction<
			AddCommentDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddCommentDrawerOpenedAction
		>
	>;
	addCommentDrawerClosed: ActionCreator<
		ThunkAction<
			AddCommentDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddCommentDrawerClosedAction
		>
	>;
	editCommentDrawerOpened: ActionCreator<
		ThunkAction<
			EditCommentDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditCommentDrawerOpenedAction
		>
	>;
	editCommentDrawerClosed: ActionCreator<
		ThunkAction<
			EditCommentDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditCommentDrawerClosedAction
		>
	>;
	addTaskDrawerOpened: ActionCreator<
		ThunkAction<
			AddTaskDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddTaskDrawerOpenedAction
		>
	>;
	addTaskDrawerClosed: ActionCreator<
		ThunkAction<
			AddTaskDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddTaskDrawerClosedAction
		>
	>;
	editTaskDrawerOpened: ActionCreator<
		ThunkAction<
			EditTaskDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditTaskDrawerOpenedAction
		>
	>;
	editTaskDrawerClosed: ActionCreator<
		ThunkAction<
			EditTaskDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditTaskDrawerClosedAction
		>
	>;
	addMeetingDrawerOpened: ActionCreator<
		ThunkAction<
			AddMeetingDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddMeetingDrawerOpenedAction
		>
	>;
	addMeetingDrawerClosed: ActionCreator<
		ThunkAction<
			AddMeetingDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddMeetingDrawerClosedAction
		>
	>;
	editMeetingDrawerOpened: ActionCreator<
		ThunkAction<
			EditMeetingDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditMeetingDrawerOpenedAction
		>
	>;
	editMeetingDrawerClosed: ActionCreator<
		ThunkAction<
			EditMeetingDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditMeetingDrawerClosedAction
		>
	>;
	addLogCallDrawerOpened: ActionCreator<
		ThunkAction<
			AddLogCallDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddLogCallDrawerOpenedAction
		>
	>;
	addLogCallDrawerClosed: ActionCreator<
		ThunkAction<
			AddLogCallDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddLogCallDrawerClosedAction
		>
	>;
	editLogCallDrawerOpened: ActionCreator<
		ThunkAction<
			EditLogCallDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditLogCallDrawerOpenedAction
		>
	>;
	editLogCallDrawerClosed: ActionCreator<
		ThunkAction<
			EditLogCallDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditLogCallDrawerClosedAction
		>
	>;
	addLogEmailDrawerOpened: ActionCreator<
		ThunkAction<
			AddLogEmailDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddLogEmailDrawerOpenedAction
		>
	>;
	addLogEmailDrawerClosed: ActionCreator<
		ThunkAction<
			AddLogEmailDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddLogEmailDrawerClosedAction
		>
	>;
	editLogEmailDrawerOpened: ActionCreator<
		ThunkAction<
			EditLogEmailDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditLogEmailDrawerOpenedAction
		>
	>;
	editLogEmailDrawerClosed: ActionCreator<
		ThunkAction<
			EditLogEmailDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditLogEmailDrawerClosedAction
		>
	>;
	upcomingActivitiesDrawerOpened: ActionCreator<
		ThunkAction<
			UpcomingActivitiesDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			UpcomingActivitiesDrawerOpenedAction
		>
	>;
	upcomingActivitiesDrawerClosed: ActionCreator<
		ThunkAction<
			UpcomingActivitiesDrawerClosedAction,
			SalesActivityModuleState,
			null,
			UpcomingActivitiesDrawerClosedAction
		>
	>;
	auditLogsDrawerOpened: ActionCreator<
		ThunkAction<
			AuditLogsDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AuditLogsDrawerOpenedAction
		>
	>;
	auditLogsDrawerClosed: ActionCreator<
		ThunkAction<
			AuditLogsDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AuditLogsDrawerClosedAction
		>
	>;
	fetchUsersAllSalesActivity: ActionCreator<
		ThunkAction<
			Promise<FetchUsersAllSalesActivitySuccessfullyAction>,
			SalesActivityModuleState,
			SalesActivityPageRequest,
			FetchUsersAllSalesActivitySuccessfullyAction
		>
	>;
	fetchOpportunitiesForSalesActivities: ActionCreator<
		ThunkAction<
			Promise<FetchOpportunitiesForSalesActivitySuccessfullyAction>,
			SalesActivityModuleState,
			OpportunityRequest,
			FetchOpportunitiesForSalesActivitySuccessfullyAction
		>
	>;
	fetchClientsForSalesActivities: ActionCreator<
		ThunkAction<
			Promise<FetchClientsForSalesActivitySuccessfullyAction>,
			SalesActivityModuleState,
			ClientsRequest,
			FetchClientsForSalesActivitySuccessfullyAction
		>
	>;
	fetchClientsContactForSalesActivities: ActionCreator<
		ThunkAction<
			Promise<FetchClientContactsForSalesActivitySuccessfullyAction>,
			SalesActivityModuleState,
			ClientContactRequest,
			FetchClientContactsForSalesActivitySuccessfullyAction
		>
	>;
	resetSalesActivityOpportunities: ActionCreator<
		ThunkAction<
			ResetSalesActivityOpportunitiesAction,
			SalesActivityModuleState,
			null,
			ResetSalesActivityOpportunitiesAction
		>
	>;
	resetSalesActivityClients: ActionCreator<
		ThunkAction<
			ResetSalesActivityClientsAction,
			SalesActivityModuleState,
			null,
			ResetSalesActivityClientsAction
		>
	>;
	resetSalesActivityClientContacts: ActionCreator<
		ThunkAction<
			ResetSalesActivityClientContactsAction,
			SalesActivityModuleState,
			null,
			ResetSalesActivityClientContactsAction
		>
	>;
	syncEntityWithPSA: ActionCreator<
		ThunkAction<
			Promise<SyncWithPSASuccessfulAction>,
			SalesActivityModuleState,
			SyncEntityRequest,
			SyncWithPSASuccessfulAction
		>
	>;
	resetAllUsersSalesActivity: ActionCreator<
		ThunkAction<
			ResetAllUserSalesActivityAction,
			SalesActivityModuleState,
			null,
			ResetAllUserSalesActivityAction
		>
	>;
	addGlobalCommentDrawerOpened: ActionCreator<
		ThunkAction<
			AddGlobalCommentDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddGlobalCommentDrawerOpenedAction
		>
	>;
	addGlobalCommentDrawerClosed: ActionCreator<
		ThunkAction<
			AddGlobalCommentDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddGlobalCommentDrawerClosedAction
		>
	>;
	addGlobalTaskDrawerOpened: ActionCreator<
		ThunkAction<
			AddGlobalTaskDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddGlobalTaskDrawerOpenedAction
		>
	>;
	addGlobalTaskDrawerClosed: ActionCreator<
		ThunkAction<
			AddGlobalTaskDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddGlobalTaskDrawerClosedAction
		>
	>;
	addGlobalMeetingDrawerOpened: ActionCreator<
		ThunkAction<
			AddGlobalMeetingDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddGlobalMeetingDrawerOpenedAction
		>
	>;
	addGlobalMeetingDrawerClosed: ActionCreator<
		ThunkAction<
			AddGlobalMeetingDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddGlobalMeetingDrawerClosedAction
		>
	>;
	addGlobalLogCallDrawerOpened: ActionCreator<
		ThunkAction<
			AddGlobalLogCallDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddGlobalLogCallDrawerOpenedAction
		>
	>;
	addGlobalLogCallDrawerClosed: ActionCreator<
		ThunkAction<
			AddGlobalLogCallDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddGlobalLogCallDrawerClosedAction
		>
	>;
	addGlobalLogEmailDrawerOpened: ActionCreator<
		ThunkAction<
			AddGlobalLogEmailDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			AddGlobalLogEmailDrawerOpenedAction
		>
	>;
	addGlobalLogEmailDrawerClosed: ActionCreator<
		ThunkAction<
			AddGlobalLogEmailDrawerClosedAction,
			SalesActivityModuleState,
			null,
			AddGlobalLogEmailDrawerClosedAction
		>
	>;
	editGlobalCommentDrawerOpened: ActionCreator<
		ThunkAction<
			EditGlobalCommentDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditGlobalCommentDrawerOpenedAction
		>
	>;
	editGlobalCommentDrawerClosed: ActionCreator<
		ThunkAction<
			EditGlobalCommentDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditGlobalCommentDrawerClosedAction
		>
	>;
	editGlobalTaskDrawerOpened: ActionCreator<
		ThunkAction<
			EditGlobalTaskDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditGlobalTaskDrawerOpenedAction
		>
	>;
	editGlobalTaskDrawerClosed: ActionCreator<
		ThunkAction<
			EditGlobalTaskDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditGlobalTaskDrawerClosedAction
		>
	>;
	editGlobalMeetingDrawerOpened: ActionCreator<
		ThunkAction<
			EditGlobalMeetingDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditGlobalMeetingDrawerOpenedAction
		>
	>;
	editGlobalMeetingDrawerClosed: ActionCreator<
		ThunkAction<
			EditGlobalMeetingDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditGlobalMeetingDrawerClosedAction
		>
	>;
	editGlobalLogCallDrawerOpened: ActionCreator<
		ThunkAction<
			EditGlobalLogCallDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditGlobalLogCallDrawerOpenedAction
		>
	>;
	editGlobalLogCallDrawerClosed: ActionCreator<
		ThunkAction<
			EditGlobalLogCallDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditGlobalLogCallDrawerClosedAction
		>
	>;
	editGlobalLogEmailDrawerOpened: ActionCreator<
		ThunkAction<
			EditGlobalLogEmailDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			EditGlobalLogEmailDrawerOpenedAction
		>
	>;
	editGlobalLogEmailDrawerClosed: ActionCreator<
		ThunkAction<
			EditGlobalLogEmailDrawerClosedAction,
			SalesActivityModuleState,
			null,
			EditGlobalLogEmailDrawerClosedAction
		>
	>;
	updateActiveFilters: ActionCreator<
		ThunkAction<
			UpdateActiveFiltersAction,
			SalesActivityModuleState,
			TableQueryFilter[],
			UpdateActiveFiltersAction
		>
	>;
	addActivityToUsersSalesActivity: ActionCreator<
		ThunkAction<
			AddActivityToUsersSalesActivityAction,
			SalesActivityModuleState,
			SalesActivity,
			AddActivityToUsersSalesActivityAction
		>
	>;
	updateSingleUsersSalesActivity: ActionCreator<
		ThunkAction<
			UpdateSingleUserSalesActivityAction,
			SalesActivityModuleState,
			SalesActivity,
			UpdateSingleUserSalesActivityAction
		>
	>;
	fetchOneSalesActivity: ActionCreator<
		ThunkAction<
			Promise<GetOneSalesActivitySuccessfulAction>,
			SalesActivityModuleState,
			GetOneSaleActivityRequest,
			GetOneSalesActivitySuccessfulAction
		>
	>;
	deleteOneSalesActivity: ActionCreator<
		ThunkAction<
			Promise<DeleteOneSalesActivitySuccessfullyAction>,
			SalesActivityModuleState,
			SalesActivity,
			DeleteOneSalesActivitySuccessfullyAction
		>
	>;
	fetchMeetingClashStatus: ActionCreator<
		ThunkAction<
			Promise<FetchMeetingClashStatusSuccessful>,
			SalesActivityModuleState,
			FetchClashStatusInput,
			FetchMeetingClashStatusSuccessful
		>
	>;
	fetchPSAAuditLogs: ActionCreator<
		ThunkAction<
			Promise<FetchAllPSAAuditLogsSuccessfulAction>,
			SalesActivityModuleState,
			FetchCategoryBasedAuditLogsRequest,
			FetchAllPSAAuditLogsSuccessfulAction
		>
	>;
	fetchCustomDistributorAuditLogs: ActionCreator<
		ThunkAction<
			Promise<FetchAllPSAAuditLogsSuccessfulAction>,
			SalesActivityModuleState,
			FetchCustomDistributorAuditLogsRequest,
			FetchAllPSAAuditLogsSuccessfulAction
		>
	>;
	retryFailedPSAAuditLog: ActionCreator<
		ThunkAction<
			Promise<RetryFailedAuditLogsSuccesfulAction>,
			SalesActivityModuleState,
			RetryFailedAuditLogsRequest,
			RetryFailedAuditLogsSuccesfulAction
		>
	>;
	getAuditLogRedirectUrl: ActionCreator<
		ThunkAction<
			Promise<AuditLogRedirectUrlSuccessfulAction>,
			SalesActivityModuleState,
			{ id: string },
			AuditLogRedirectUrlSuccessfulAction
		>
	>;
	updateCurrentActiveSalesActivityAutomationActionIndex: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveSalesActivityAutomationActionIndex,
			SalesActivityModuleState,
			number,
			UpdateCurrentActiveSalesActivityAutomationActionIndex
		>
	>;
	showPaymentsDrawer: ActionCreator<
		ThunkAction<
			PaymentDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			PaymentDrawerOpenedAction
		>
	>;
	hidePaymentsDrawer: ActionCreator<
		ThunkAction<
			PaymentDrawerClosedAction,
			SalesActivityModuleState,
			null,
			PaymentDrawerClosedAction
		>
	>;
	showWebhookDrawer: ActionCreator<
		ThunkAction<
			WebhookDrawerOpenedAction,
			SalesActivityModuleState,
			null,
			WebhookDrawerOpenedAction
		>
	>;
	hideWebhookDrawer: ActionCreator<
		ThunkAction<
			WebhookDrawerClosedAction,
			SalesActivityModuleState,
			null,
			WebhookDrawerClosedAction
		>
	>;
	updateSelectedDocumentType: ActionCreator<
		ThunkAction<
			UpdatedSelectedDocumentAction,
			SalesActivityModuleState,
			null,
			UpdatedSelectedDocumentAction
		>
	>;
	getConflictMeetingDetail: ActionCreator<
		ThunkAction<
			Promise<GetConflictMeetingDetailSuccessful>,
			SalesActivityModuleState,
			{ startTime: number },
			GetConflictMeetingDetailSuccessful
		>
	>;
	updateSelectedOwnerView: ActionCreator<
		ThunkAction<
			Promise<UpdateSelectedOwnerViewAction>,
			SalesActivityModuleState,
			{ selectedOwnerView: SalesActivityUserViews },
			UpdateSelectedOwnerViewAction
		>
	>;
	updateAuditLogsCount: ActionCreator<
		ThunkAction<
			Promise<UpdateAuditLogsCountViewAction>,
			SalesActivityModuleState,
			{ auditLogsCount: number },
			UpdateAuditLogsCountViewAction
		>
	>;
}

export const SalesActivityActionCreators: SalesActivityDispatch = {
	// Sales Activity Get Actions
	showSalesActivityLoader: () => {
		return (dispatch: Dispatch): ShowSalesActivityLoaderAction => {
			const showSalesActivityLoaderAction: ShowSalesActivityLoaderAction =
				{
					type: SalesActivityActionTypes.SHOW_SALES_ACTIVITY_LOADER
				};
			return dispatch(showSalesActivityLoaderAction);
		};
	},
	hideSalesActivityLoader: () => {
		return (dispatch: Dispatch): HideSalesActivityLoaderAction => {
			const hideSalesActivityLoaderAction: HideSalesActivityLoaderAction =
				{
					type: SalesActivityActionTypes.HIDE_SALES_ACTIVITY_LOADER
				};
			return dispatch(hideSalesActivityLoaderAction);
		};
	},
	salesActivityActiveTabChanged: (
		salesActivityActiveTab: RecentActivityFeedType | null
	) => {
		return (dispatch: Dispatch): SalesActivityActiveTabChangedAction => {
			const salesActivityActiveTabChangedAction: SalesActivityActiveTabChangedAction =
				{
					type: SalesActivityActionTypes.SALES_ACTIVITY_ACTIVE_TAB_CHANGED,
					salesActivityActiveTab
				};
			return dispatch(salesActivityActiveTabChangedAction);
		};
	},
	getAllSalesActivity: (allSalesActivityRequest: SalesActivityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<AllSalesActivitySuccessfulAction> => {
			const allSalesActivityRequestedAction: AllSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.ALL_SALES_ACTIVITY_REQUESTED
				};
			dispatch(allSalesActivityRequestedAction);
			try {
				const allSalesActivityResponse = await getAllSalesActivity(
					allSalesActivityRequest
				);
				const allSalesActivitySuccessfulAction: AllSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.ALL_SALES_ACTIVITY_SUCCESSFUL,
						allSalesActivity: allSalesActivityResponse,
						paginate: allSalesActivityRequest.paginate
					};
				return dispatch(allSalesActivitySuccessfulAction);
			} catch (error) {
				const allSalesActivityFailedAction: AllSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.ALL_SALES_ACTIVITY_FAILED
					};
				dispatch(allSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getAllCompletedSalesActivity: (
		allCompletedSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AllCompletedSalesActivitySuccessfulAction> => {
			const allCompletedSalesActivityRequestedAction: AllCompletedSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.ALL_COMPLETED_SALES_ACTIVITY_REQUESTED
				};
			dispatch(allCompletedSalesActivityRequestedAction);
			try {
				const allCompletedSalesActivityResponse =
					await getAllCompletedSalesActivity(
						allCompletedSalesActivityRequest
					);
				const allCompletedSalesActivitySuccessfulAction: AllCompletedSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.ALL_COMPLETED_SALES_ACTIVITY_SUCCESSFUL,
						allSalesActivity: allCompletedSalesActivityResponse,
						paginate: allCompletedSalesActivityRequest.paginate
					};
				return dispatch(allCompletedSalesActivitySuccessfulAction);
			} catch (error) {
				const allCompletedSalesActivityFailedAction: AllCompletedSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.ALL_COMPLETED_SALES_ACTIVITY_FAILED
					};
				dispatch(allCompletedSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getAllOverdueSalesActivity: (
		allOverdueSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AllOverdueSalesActivitySuccessfulAction> => {
			const allOverdueSalesActivityRequestedAction: AllOverdueSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.ALL_OVERDUE_SALES_ACTIVITY_REQUESTED
				};
			dispatch(allOverdueSalesActivityRequestedAction);
			try {
				const allOverdueSalesActivityResponse =
					await getAllOverdueSalesActivity(
						allOverdueSalesActivityRequest
					);
				const allOverdueSalesActivitySuccessfulAction: AllOverdueSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.ALL_OVERDUE_SALES_ACTIVITY_SUCCESSFUL,
						allSalesActivity: allOverdueSalesActivityResponse,
						paginate: allOverdueSalesActivityRequest.paginate
					};
				return dispatch(allOverdueSalesActivitySuccessfulAction);
			} catch (error) {
				const allOverdueSalesActivityFailedAction: AllOverdueSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.ALL_OVERDUE_SALES_ACTIVITY_FAILED
					};
				dispatch(allOverdueSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getAllUpcomingSalesActivity: (
		allUpcomingSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AllUpcomingSalesActivitySuccessfulAction> => {
			const allUpcomingSalesActivityRequestedAction: AllUpcomingSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.ALL_UPCOMING_SALES_ACTIVITY_REQUESTED
				};
			dispatch(allUpcomingSalesActivityRequestedAction);
			try {
				const allUpcomingSalesActivityResponse =
					await getAllUpcomingSalesActivity(
						allUpcomingSalesActivityRequest
					);
				const allUpcomingSalesActivitySuccessfulAction: AllUpcomingSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.ALL_UPCOMING_SALES_ACTIVITY_SUCCESSFUL,
						allSalesActivity: allUpcomingSalesActivityResponse,
						paginate: allUpcomingSalesActivityRequest.paginate
					};
				return dispatch(allUpcomingSalesActivitySuccessfulAction);
			} catch (error) {
				const allUpcomingSalesActivityFailedAction: AllUpcomingSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.ALL_UPCOMING_SALES_ACTIVITY_FAILED
					};
				dispatch(allUpcomingSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetAllSalesActivity: () => {
		return (dispatch: Dispatch): AllSalesActivityResetAction => {
			const allSalesActivityResetAction: AllSalesActivityResetAction = {
				type: SalesActivityActionTypes.ALL_SALES_ACTIVITY_RESET
			};
			return dispatch(allSalesActivityResetAction);
		};
	},
	getNotesSalesActivity: (
		notesSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<NotesSalesActivitySuccessfulAction> => {
			const notesSalesActivityRequestedAction: NotesSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.NOTES_SALES_ACTIVITY_REQUESTED
				};
			dispatch(notesSalesActivityRequestedAction);
			try {
				const notesSalesActivityResponse = await getNotesSalesActivity(
					notesSalesActivityRequest
				);
				const notesSalesActivitySuccessfulAction: NotesSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.NOTES_SALES_ACTIVITY_SUCCESSFUL,
						notesSalesActivity: notesSalesActivityResponse,
						paginate: notesSalesActivityRequest.paginate
					};
				return dispatch(notesSalesActivitySuccessfulAction);
			} catch (error) {
				const notesSalesActivityFailedAction: NotesSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.NOTES_SALES_ACTIVITY_FAILED
					};
				dispatch(notesSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getNotesPinnedSalesActivity: (
		notesPinnedSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<NotesPinnedSalesActivitySuccessfulAction> => {
			const notesPinnedSalesActivityRequestedAction: NotesPinnedSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.NOTES_PINNED_SALES_ACTIVITY_REQUESTED
				};
			dispatch(notesPinnedSalesActivityRequestedAction);
			try {
				const notesPinnedSalesActivityResponse =
					await getNotesPinnedSalesActivity(
						notesPinnedSalesActivityRequest
					);
				const notesPinnedSalesActivitySuccessfulAction: NotesPinnedSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.NOTES_PINNED_SALES_ACTIVITY_SUCCESSFUL,
						notesSalesActivity: notesPinnedSalesActivityResponse,
						paginate: notesPinnedSalesActivityRequest.paginate
					};
				return dispatch(notesPinnedSalesActivitySuccessfulAction);
			} catch (error) {
				const notesPinnedSalesActivityFailedAction: NotesPinnedSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.NOTES_PINNED_SALES_ACTIVITY_FAILED
					};
				dispatch(notesPinnedSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getNotesCompletedSalesActivity: (
		notesCompletedSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<NotesCompletedSalesActivitySuccessfulAction> => {
			const notesCompletedSalesActivityRequestedAction: NotesCompletedSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.NOTES_COMPLETED_SALES_ACTIVITY_REQUESTED
				};
			dispatch(notesCompletedSalesActivityRequestedAction);
			try {
				const notesCompletedSalesActivityResponse =
					await getNotesCompletedSalesActivity(
						notesCompletedSalesActivityRequest
					);
				const notesCompletedSalesActivitySuccessfulAction: NotesCompletedSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.NOTES_COMPLETED_SALES_ACTIVITY_SUCCESSFUL,
						notesSalesActivity: notesCompletedSalesActivityResponse,
						paginate: notesCompletedSalesActivityRequest.paginate
					};
				return dispatch(notesCompletedSalesActivitySuccessfulAction);
			} catch (error) {
				const notesCompletedSalesActivityFailedAction: NotesCompletedSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.NOTES_COMPLETED_SALES_ACTIVITY_FAILED
					};
				dispatch(notesCompletedSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetNotesSalesActivity: () => {
		return (dispatch: Dispatch): NotesSalesActivityResetAction => {
			const notesSalesActivityResetAction: NotesSalesActivityResetAction =
				{
					type: SalesActivityActionTypes.NOTES_SALES_ACTIVITY_RESET
				};
			return dispatch(notesSalesActivityResetAction);
		};
	},
	getTasksSalesActivity: (
		tasksSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<TasksSalesActivitySuccessfulAction> => {
			const tasksSalesActivityRequestedAction: TasksSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.TASKS_SALES_ACTIVITY_REQUESTED
				};
			dispatch(tasksSalesActivityRequestedAction);
			try {
				const tasksSalesActivityResponse = await getTasksSalesActivity(
					tasksSalesActivityRequest
				);
				const tasksSalesActivitySuccessfulAction: TasksSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.TASKS_SALES_ACTIVITY_SUCCESSFUL,
						tasksSalesActivity: tasksSalesActivityResponse,
						paginate: tasksSalesActivityRequest.paginate
					};
				return dispatch(tasksSalesActivitySuccessfulAction);
			} catch (error) {
				const tasksSalesActivityFailedAction: TasksSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.TASKS_SALES_ACTIVITY_FAILED
					};
				dispatch(tasksSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getTasksCompletedSalesActivity: (
		tasksCompletedSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<TasksCompletedSalesActivitySuccessfulAction> => {
			const tasksCompletedSalesActivityRequestedAction: TasksCompletedSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.TASKS_COMPLETED_SALES_ACTIVITY_REQUESTED
				};
			dispatch(tasksCompletedSalesActivityRequestedAction);
			try {
				const tasksCompletedSalesActivityResponse =
					await getTasksCompletedSalesActivity(
						tasksCompletedSalesActivityRequest
					);
				const tasksCompletedSalesActivitySuccessfulAction: TasksCompletedSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.TASKS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL,
						tasksSalesActivity: tasksCompletedSalesActivityResponse,
						paginate: tasksCompletedSalesActivityRequest.paginate
					};
				return dispatch(tasksCompletedSalesActivitySuccessfulAction);
			} catch (error) {
				const tasksCompletedSalesActivityFailedAction: TasksCompletedSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.TASKS_COMPLETED_SALES_ACTIVITY_FAILED
					};
				dispatch(tasksCompletedSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getTasksOverdueSalesActivity: (
		tasksOverdueSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<TasksOverdueSalesActivitySuccessfulAction> => {
			const tasksOverdueSalesActivityRequestedAction: TasksOverdueSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.TASKS_OVERDUE_SALES_ACTIVITY_REQUESTED
				};
			dispatch(tasksOverdueSalesActivityRequestedAction);
			try {
				const tasksOverdueSalesActivityResponse =
					await getTasksOverdueSalesActivity(
						tasksOverdueSalesActivityRequest
					);
				const tasksOverdueSalesActivitySuccessfulAction: TasksOverdueSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.TASKS_OVERDUE_SALES_ACTIVITY_SUCCESSFUL,
						tasksSalesActivity: tasksOverdueSalesActivityResponse,
						paginate: tasksOverdueSalesActivityRequest.paginate
					};
				return dispatch(tasksOverdueSalesActivitySuccessfulAction);
			} catch (error) {
				const tasksOverdueSalesActivityFailedAction: TasksOverdueSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.TASKS_OVERDUE_SALES_ACTIVITY_FAILED
					};
				dispatch(tasksOverdueSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getTasksUpcomingSalesActivity: (
		tasksUpcomingSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<TasksUpcomingSalesActivitySuccessfulAction> => {
			const tasksUpcomingSalesActivityRequestedAction: TasksUpcomingSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.TASKS_UPCOMING_SALES_ACTIVITY_REQUESTED
				};
			dispatch(tasksUpcomingSalesActivityRequestedAction);
			try {
				const tasksUpcomingSalesActivityResponse =
					await getTasksUpcomingSalesActivity(
						tasksUpcomingSalesActivityRequest
					);
				const tasksUpcomingSalesActivitySuccessfulAction: TasksUpcomingSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.TASKS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL,
						tasksSalesActivity: tasksUpcomingSalesActivityResponse,
						paginate: tasksUpcomingSalesActivityRequest.paginate
					};
				return dispatch(tasksUpcomingSalesActivitySuccessfulAction);
			} catch (error) {
				const tasksUpcomingSalesActivityFailedAction: TasksUpcomingSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.TASKS_UPCOMING_SALES_ACTIVITY_FAILED
					};
				dispatch(tasksUpcomingSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetTasksSalesActivity: () => {
		return (dispatch: Dispatch): TasksSalesActivityResetAction => {
			const tasksSalesActivityResetAction: TasksSalesActivityResetAction =
				{
					type: SalesActivityActionTypes.TASKS_SALES_ACTIVITY_RESET
				};
			return dispatch(tasksSalesActivityResetAction);
		};
	},
	getMeetingsSalesActivity: (
		meetingsSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<MeetingsSalesActivitySuccessfulAction> => {
			const getMeetingsSalesActivityRequestedAction: MeetingsSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_REQUESTED
				};
			dispatch(getMeetingsSalesActivityRequestedAction);
			try {
				const getMeetingsSalesActivityResponse =
					await getMeetingsSalesActivity(
						meetingsSalesActivityRequest
					);
				const getMeetingsSalesActivitySuccessfulAction: MeetingsSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_SUCCESSFUL,
						meetingsSalesActivity: getMeetingsSalesActivityResponse,
						paginate: meetingsSalesActivityRequest.paginate
					};
				return dispatch(getMeetingsSalesActivitySuccessfulAction);
			} catch (error) {
				const getMeetingsSalesActivityFailedAction: MeetingsSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_FAILED
					};
				dispatch(getMeetingsSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getMeetingsCompletedSalesActivity: (
		meetingsCompletedSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<MeetingsCompletedSalesActivitySuccessfulAction> => {
			const meetingsCompletedSalesActivityRequestedAction: MeetingsCompletedSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.MEETINGS_COMPLETED_SALES_ACTIVITY_REQUESTED
				};
			dispatch(meetingsCompletedSalesActivityRequestedAction);
			try {
				const meetingsCompletedSalesActivityResponse =
					await getMeetingsCompletedSalesActivity(
						meetingsCompletedSalesActivityRequest
					);
				const meetingsCompletedSalesActivitySuccessfulAction: MeetingsCompletedSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.MEETINGS_COMPLETED_SALES_ACTIVITY_SUCCESSFUL,
						meetingsSalesActivity:
							meetingsCompletedSalesActivityResponse,
						paginate: meetingsCompletedSalesActivityRequest.paginate
					};
				return dispatch(meetingsCompletedSalesActivitySuccessfulAction);
			} catch (error) {
				const meetingsCompletedSalesActivityFailedAction: MeetingsCompletedSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.MEETINGS_COMPLETED_SALES_ACTIVITY_FAILED
					};
				dispatch(meetingsCompletedSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getMeetingsUpcomingSalesActivity: (
		meetingsUpcomingSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<MeetingsUpcomingSalesActivitySuccessfulAction> => {
			const meetingsUpcomingSalesActivityRequestedAction: MeetingsUpcomingSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.MEETINGS_UPCOMING_SALES_ACTIVITY_REQUESTED
				};
			dispatch(meetingsUpcomingSalesActivityRequestedAction);
			try {
				const meetingsUpcomingSalesActivityResponse =
					await getMeetingsUpcomingSalesActivity(
						meetingsUpcomingSalesActivityRequest
					);
				const meetingsUpcomingSalesActivitySuccessfulAction: MeetingsUpcomingSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.MEETINGS_UPCOMING_SALES_ACTIVITY_SUCCESSFUL,
						meetingsSalesActivity:
							meetingsUpcomingSalesActivityResponse,
						paginate: meetingsUpcomingSalesActivityRequest.paginate
					};
				return dispatch(meetingsUpcomingSalesActivitySuccessfulAction);
			} catch (error) {
				const meetingsUpcomingSalesActivityFailedAction: MeetingsUpcomingSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.MEETINGS_UPCOMING_SALES_ACTIVITY_FAILED
					};
				dispatch(meetingsUpcomingSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetMeetingsSalesActivity: () => {
		return (dispatch: Dispatch): MeetingsSalesActivityResetAction => {
			const meetingsSalesActivityResetAction: MeetingsSalesActivityResetAction =
				{
					type: SalesActivityActionTypes.MEETINGS_SALES_ACTIVITY_RESET
				};
			return dispatch(meetingsSalesActivityResetAction);
		};
	},
	getCallsSalesActivity: (
		callsSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<CallsSalesActivitySuccessfulAction> => {
			const callsSalesActivityRequestedAction: CallsSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.CALLS_SALES_ACTIVITY_REQUESTED
				};
			dispatch(callsSalesActivityRequestedAction);
			try {
				const callsSalesActivityResponse = await getCallsSalesActivity(
					callsSalesActivityRequest
				);
				const callsSalesActivitySuccessfulAction: CallsSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.CALLS_SALES_ACTIVITY_SUCCESSFUL,
						callsSalesActivity: callsSalesActivityResponse,
						paginate: callsSalesActivityRequest.paginate
					};
				return dispatch(callsSalesActivitySuccessfulAction);
			} catch (error) {
				const callsSalesActivityFailedAction: CallsSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.CALLS_SALES_ACTIVITY_FAILED
					};
				dispatch(callsSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetCallsSalesActivity: () => {
		return (dispatch: Dispatch): CallsSalesActivityResetAction => {
			const callsSalesActivityResetAction: CallsSalesActivityResetAction =
				{
					type: SalesActivityActionTypes.CALLS_SALES_ACTIVITY_RESET
				};
			return dispatch(callsSalesActivityResetAction);
		};
	},
	getEmailsSalesActivity: (
		emailsSalesActivityRequest: SalesActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<EmailsSalesActivitySuccessfulAction> => {
			const emailsSalesActivityRequestedAction: EmailsSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_REQUESTED
				};
			dispatch(emailsSalesActivityRequestedAction);
			try {
				const emailsSalesActivityResponse =
					await getEmailsSalesActivity(emailsSalesActivityRequest);
				const emailsSalesActivitySuccessfulAction: EmailsSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_SUCCESSFUL,
						emailsSalesActivity: emailsSalesActivityResponse,
						paginate: emailsSalesActivityRequest.paginate
					};
				return dispatch(emailsSalesActivitySuccessfulAction);
			} catch (error) {
				const emailsSalesActivityFailedAction: EmailsSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_FAILED
					};
				dispatch(emailsSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetEmailsSalesActivity: () => {
		return (dispatch: Dispatch): EmailsSalesActivityResetAction => {
			const emailsSalesActivityResetAction: EmailsSalesActivityResetAction =
				{
					type: SalesActivityActionTypes.EMAILS_SALES_ACTIVITY_RESET
				};
			return dispatch(emailsSalesActivityResetAction);
		};
	},
	updateCurrentActiveSalesActivity: (
		currentActiveSalesActivity: SalesActivity | null
	) => {
		return (dispatch: Dispatch): UpdateCurrentActiveSalesActivityAction => {
			const updateCurrentActiveSalesActivityAction: UpdateCurrentActiveSalesActivityAction =
				{
					type: SalesActivityActionTypes.UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY,
					currentActiveSalesActivity
				};
			return dispatch(updateCurrentActiveSalesActivityAction);
		};
	},
	// Sales Activity Delete / Add / Edit Actions
	deleteComment: (deleteCommentRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteCommentSuccessfulAction> => {
			const deleteCommentRequestedAction: DeleteCommentRequestedAction = {
				type: SalesActivityActionTypes.DELETE_COMMENT_REQUESTED
			};
			dispatch(deleteCommentRequestedAction);
			try {
				const deleteCommentResponse = await deleteComment(
					deleteCommentRequest
				);
				if (deleteCommentResponse.deleted) {
					const deleteCommentSuccessfulAction: DeleteCommentSuccessfulAction =
						{
							type: SalesActivityActionTypes.DELETE_COMMENT_SUCCESSFUL,
							deleteComment: deleteCommentRequest
						};
					return dispatch(deleteCommentSuccessfulAction);
				} else {
					const deleteCommentFailedAction: DeleteCommentFailedAction =
						{
							type: SalesActivityActionTypes.DELETE_COMMENT_FAILED
						};
					dispatch(deleteCommentFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteCommentFailedAction: DeleteCommentFailedAction = {
					type: SalesActivityActionTypes.DELETE_COMMENT_FAILED
				};
				dispatch(deleteCommentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addComment: (
		addCommentRequest: AddSalesActivityCommentRequest,
		isCrossAssign: boolean
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AddCommentSuccessfulAction> => {
			const addCommentRequestedAction: AddSalesActivityCommentRequestedAction =
				{
					type: SalesActivityActionTypes.ADD_COMMENT_REQUESTED
				};
			dispatch(addCommentRequestedAction);
			try {
				const addCommentResponse = await addComment(
					addCommentRequest,
					isCrossAssign
				);
				const addCommentSuccessfulAction: AddCommentSuccessfulAction = {
					type: SalesActivityActionTypes.ADD_COMMENT_SUCCESSFUL,
					addComment: addCommentResponse
				};
				return dispatch(addCommentSuccessfulAction);
			} catch (error) {
				const addCommentFailedAction: AddCommentFailedAction = {
					type: SalesActivityActionTypes.ADD_COMMENT_FAILED
				};
				dispatch(addCommentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editComment: (editCommentRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<EditCommentSuccessfulAction> => {
			const editCommentRequestedAction: EditCommentRequestedAction = {
				type: SalesActivityActionTypes.EDIT_COMMENT_REQUESTED
			};
			dispatch(editCommentRequestedAction);
			try {
				const editCommentResponse = await editComment(
					editCommentRequest
				);
				const editCommentSuccessfulAction: EditCommentSuccessfulAction =
					{
						type: SalesActivityActionTypes.EDIT_COMMENT_SUCCESSFUL,
						editComment: editCommentResponse
					};
				return dispatch(editCommentSuccessfulAction);
			} catch (error) {
				const editCommentFailedAction: EditCommentFailedAction = {
					type: SalesActivityActionTypes.EDIT_COMMENT_FAILED
				};
				dispatch(editCommentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteLogCall: (deleteLogCallRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteLogCallSuccessfulAction> => {
			const deleteLogCallRequestedAction: DeleteLogCallRequestedAction = {
				type: SalesActivityActionTypes.DELETE_LOG_CALL_REQUESTED
			};
			dispatch(deleteLogCallRequestedAction);
			try {
				const deleteLogCallResponse = await deleteLogCall(
					deleteLogCallRequest
				);
				if (deleteLogCallResponse.deleted) {
					const deleteLogCallSuccessfulAction: DeleteLogCallSuccessfulAction =
						{
							type: SalesActivityActionTypes.DELETE_LOG_CALL_SUCCESSFUL,
							deleteLogCall: deleteLogCallRequest
						};
					return dispatch(deleteLogCallSuccessfulAction);
				} else {
					const deleteLogCallFailedAction: DeleteLogCallFailedAction =
						{
							type: SalesActivityActionTypes.DELETE_LOG_CALL_FAILED
						};
					dispatch(deleteLogCallFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteLogCallFailedAction: DeleteLogCallFailedAction = {
					type: SalesActivityActionTypes.DELETE_LOG_CALL_FAILED
				};
				dispatch(deleteLogCallFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addLogCall: (
		addLogCallRequest: AddLogCallRequest,
		isCrossAssign: boolean
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AddLogCallSuccessfulAction> => {
			const addLogCallRequestedAction: AddLogCallRequestedAction = {
				type: SalesActivityActionTypes.ADD_LOG_CALL_REQUESTED
			};
			dispatch(addLogCallRequestedAction);
			try {
				const addLogCallResponse = await addLogCall(
					addLogCallRequest,
					isCrossAssign
				);
				const addLogCallSuccessfulAction: AddLogCallSuccessfulAction = {
					type: SalesActivityActionTypes.ADD_LOG_CALL_SUCCESSFUL,
					addLogCall: addLogCallResponse
				};
				return dispatch(addLogCallSuccessfulAction);
			} catch (error) {
				const addLogCallFailedAction: AddLogCallFailedAction = {
					type: SalesActivityActionTypes.ADD_LOG_CALL_FAILED
				};
				dispatch(addLogCallFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editLogCall: (editLogCallRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<EditLogCallSuccessfulAction> => {
			const editLogCallRequestedAction: EditLogCallRequestedAction = {
				type: SalesActivityActionTypes.EDIT_LOG_CALL_REQUESTED
			};
			dispatch(editLogCallRequestedAction);
			try {
				const editLogCallResponse = await editLogCall(
					editLogCallRequest
				);
				const editLogCallSuccessfulAction: EditLogCallSuccessfulAction =
					{
						type: SalesActivityActionTypes.EDIT_LOG_CALL_SUCCESSFUL,
						editLogCall: editLogCallResponse
					};
				return dispatch(editLogCallSuccessfulAction);
			} catch (error) {
				const editLogCallFailedAction: EditLogCallFailedAction = {
					type: SalesActivityActionTypes.EDIT_LOG_CALL_FAILED
				};
				dispatch(editLogCallFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteLogEmail: (deleteLogEmailRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteLogEmailSuccessfulAction> => {
			const deleteLogEmailRequestedAction: DeleteLogEmailRequestedAction =
				{
					type: SalesActivityActionTypes.DELETE_LOG_EMAIL_REQUESTED
				};
			dispatch(deleteLogEmailRequestedAction);
			try {
				const deleteLogEmailResponse = await deleteLogEmail(
					deleteLogEmailRequest
				);
				if (deleteLogEmailResponse.deleted) {
					const deleteLogEmailSuccessfulAction: DeleteLogEmailSuccessfulAction =
						{
							type: SalesActivityActionTypes.DELETE_LOG_EMAIL_SUCCESSFUL,
							deleteLogEmail: deleteLogEmailRequest
						};
					return dispatch(deleteLogEmailSuccessfulAction);
				} else {
					const deleteLogEmailFailedAction: DeleteLogEmailFailedAction =
						{
							type: SalesActivityActionTypes.DELETE_LOG_EMAIL_FAILED
						};
					dispatch(deleteLogEmailFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteLogEmailFailedAction: DeleteLogEmailFailedAction = {
					type: SalesActivityActionTypes.DELETE_LOG_EMAIL_FAILED
				};
				dispatch(deleteLogEmailFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addLogEmail: (addLogEmailRequest: AddLogEmailRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<AddLogEmailSuccessfulAction> => {
			const addLogEmailRequestedAction: AddLogEmailRequestedAction = {
				type: SalesActivityActionTypes.ADD_LOG_EMAIL_REQUESTED
			};
			dispatch(addLogEmailRequestedAction);
			try {
				const addLogEmailResponse = await addLogEmail(
					addLogEmailRequest
				);
				const addLogEmailSuccessfulAction: AddLogEmailSuccessfulAction =
					{
						type: SalesActivityActionTypes.ADD_LOG_EMAIL_SUCCESSFUL,
						addLogEmail: addLogEmailResponse
					};
				return dispatch(addLogEmailSuccessfulAction);
			} catch (error) {
				const addLogEmailFailedAction: AddLogEmailFailedAction = {
					type: SalesActivityActionTypes.ADD_LOG_EMAIL_FAILED
				};
				dispatch(addLogEmailFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editLogEmail: (editLogEmailRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<EditLogEmailSuccessfulAction> => {
			const editLogEmailRequestedAction: EditLogEmailRequestedAction = {
				type: SalesActivityActionTypes.EDIT_LOG_EMAIL_REQUESTED
			};
			dispatch(editLogEmailRequestedAction);
			try {
				const editLogEmailResponse = await editLogEmail(
					editLogEmailRequest
				);
				const editLogEmailSuccessfulAction: EditLogEmailSuccessfulAction =
					{
						type: SalesActivityActionTypes.EDIT_LOG_EMAIL_SUCCESSFUL,
						editLogEmail: editLogEmailResponse
					};
				return dispatch(editLogEmailSuccessfulAction);
			} catch (error) {
				const editLogEmailFailedAction: EditLogEmailFailedAction = {
					type: SalesActivityActionTypes.EDIT_LOG_EMAIL_FAILED
				};
				dispatch(editLogEmailFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteTask: (deleteTaskRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteTaskSuccessfulAction> => {
			const deleteTaskRequestedAction: DeleteTaskRequestedAction = {
				type: SalesActivityActionTypes.DELETE_TASK_REQUESTED
			};
			dispatch(deleteTaskRequestedAction);
			try {
				const deleteTaskResponse = await deleteTask(deleteTaskRequest);
				if (deleteTaskResponse.deleted) {
					const deleteTaskSuccessfulAction: DeleteTaskSuccessfulAction =
						{
							type: SalesActivityActionTypes.DELETE_TASK_SUCCESSFUL,
							deleteTask: deleteTaskRequest
						};
					return dispatch(deleteTaskSuccessfulAction);
				} else {
					const deleteTaskFailedAction: DeleteTaskFailedAction = {
						type: SalesActivityActionTypes.DELETE_TASK_FAILED
					};
					dispatch(deleteTaskFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteTaskFailedAction: DeleteTaskFailedAction = {
					type: SalesActivityActionTypes.DELETE_TASK_FAILED
				};
				dispatch(deleteTaskFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addTask: (addTaskRequest: AddTaskRequest, isCrossAssign: boolean) => {
		return async (dispatch: Dispatch): Promise<AddTaskSuccessfulAction> => {
			const addTaskRequestedAction: AddTaskRequestedAction = {
				type: SalesActivityActionTypes.ADD_TASK_REQUESTED
			};
			dispatch(addTaskRequestedAction);
			try {
				const addTaskResponse = await addTask(
					addTaskRequest,
					isCrossAssign
				);
				const addTaskSuccessfulAction: AddTaskSuccessfulAction = {
					type: SalesActivityActionTypes.ADD_TASK_SUCCESSFUL,
					addTask: addTaskResponse
				};
				return dispatch(addTaskSuccessfulAction);
			} catch (error) {
				const addTaskFailedAction: AddTaskFailedAction = {
					type: SalesActivityActionTypes.ADD_TASK_FAILED
				};
				dispatch(addTaskFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editTask: (editTaskRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<EditTaskSuccessfulAction> => {
			const editTaskRequestedAction: EditTaskRequestedAction = {
				type: SalesActivityActionTypes.EDIT_TASK_REQUESTED
			};
			dispatch(editTaskRequestedAction);
			try {
				const editTaskResponse = await editTask(editTaskRequest);
				const editTaskSuccessfulAction: EditTaskSuccessfulAction = {
					type: SalesActivityActionTypes.EDIT_TASK_SUCCESSFUL,
					editTask: editTaskResponse
				};
				return dispatch(editTaskSuccessfulAction);
			} catch (error) {
				const editTaskFailedAction: EditTaskFailedAction = {
					type: SalesActivityActionTypes.EDIT_TASK_FAILED
				};
				dispatch(editTaskFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteMeeting: (deleteMeetingRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteMeetingSuccessfulAction> => {
			const deleteMeetingRequestedAction: DeleteMeetingRequestedAction = {
				type: SalesActivityActionTypes.DELETE_MEETING_REQUESTED
			};
			dispatch(deleteMeetingRequestedAction);
			try {
				const deleteMeetingResponse = await deleteMeeting(
					deleteMeetingRequest
				);
				if (deleteMeetingResponse.deleted) {
					const deleteMeetingSuccessfulAction: DeleteMeetingSuccessfulAction =
						{
							type: SalesActivityActionTypes.DELETE_MEETING_SUCCESSFUL,
							deleteMeeting: deleteMeetingRequest
						};
					return dispatch(deleteMeetingSuccessfulAction);
				} else {
					const deleteMeetingFailedAction: DeleteMeetingFailedAction =
						{
							type: SalesActivityActionTypes.DELETE_MEETING_FAILED
						};
					dispatch(deleteMeetingFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteMeetingFailedAction: DeleteMeetingFailedAction = {
					type: SalesActivityActionTypes.DELETE_MEETING_FAILED
				};
				dispatch(deleteMeetingFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addMeeting: (addMeetingRequest: AddMeetingRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<AddMeetingSuccessfulAction> => {
			const addMeetingRequestedAction: AddMeetingRequestedAction = {
				type: SalesActivityActionTypes.ADD_MEETING_REQUESTED
			};
			dispatch(addMeetingRequestedAction);
			try {
				const addMeetingResponse = await addMeeting(addMeetingRequest);
				const addMeetingSuccessfulAction: AddMeetingSuccessfulAction = {
					type: SalesActivityActionTypes.ADD_MEETING_SUCCESSFUL,
					addMeeting: addMeetingResponse
				};
				return dispatch(addMeetingSuccessfulAction);
			} catch (error) {
				const addMeetingFailedAction: AddMeetingFailedAction = {
					type: SalesActivityActionTypes.ADD_MEETING_FAILED
				};
				dispatch(addMeetingFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editMeeting: (editMeetingRequest: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<EditMeetingSuccessfulAction> => {
			const editMeetingRequestedAction: EditMeetingRequestedAction = {
				type: SalesActivityActionTypes.EDIT_MEETING_REQUESTED
			};

			dispatch(editMeetingRequestedAction);

			try {
				const editMeetingResponse = await editMeeting(
					editMeetingRequest
				);

				const editMeetingSuccessfulAction: EditMeetingSuccessfulAction =
					{
						type: SalesActivityActionTypes.EDIT_MEETING_SUCCESSFUL,
						editMeeting: editMeetingResponse
					};
				return dispatch(editMeetingSuccessfulAction);
			} catch (error) {
				const editMeetingFailedAction: EditMeetingFailedAction = {
					type: SalesActivityActionTypes.EDIT_MEETING_FAILED
				};
				dispatch(editMeetingFailedAction);

				return Promise.reject(error);
			}
		};
	},
	// Sales Activity Automation Actions
	getSalesActivityAutomations: (version = "v2") => {
		return async (
			dispatch: Dispatch
		): Promise<SalesActivityAutomationsSuccessfulAction> => {
			const salesActivityAutomationsRequestedAction: SalesActivityAutomationsRequestedAction =
				{
					type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATIONS_REQUESTED
				};
			dispatch(salesActivityAutomationsRequestedAction);
			try {
				const salesActivityAutomationsResponse =
					await getSalesActivityAutomations(version);
				const salesActivityAutomationsSuccessfulAction: SalesActivityAutomationsSuccessfulAction =
					{
						type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATIONS_SUCCESSFUL,
						salesActivityAutomationList:
							salesActivityAutomationsResponse.data
					};
				return dispatch(salesActivityAutomationsSuccessfulAction);
			} catch (error) {
				const salesActivityAutomationsFailedAction: SalesActivityAutomationsFailedAction =
					{
						type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATIONS_FAILED
					};
				dispatch(salesActivityAutomationsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getSalesActivityAutomationMetadata: (
		salesActivityAutomationMetadataRequest: SalesActivityAutomationMetadataRequest,
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<SalesActivityAutomationMetadataSuccessfulAction> => {
			const salesActivityAutomationMetadataRequestedAction: SalesActivityAutomationMetadataRequestedAction =
				{
					type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_METADATA_REQUESTED
				};
			dispatch(salesActivityAutomationMetadataRequestedAction);
			try {
				const salesActivityAutomationMetadataResponse =
					await getSalesActivityAutomationMetadata(
						salesActivityAutomationMetadataRequest,
						version
					);
				const salesActivityAutomationMetadataSuccessfulAction: SalesActivityAutomationMetadataSuccessfulAction =
					{
						type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_METADATA_SUCCESSFUL,
						salesActivityAutomationFiltersList:
							salesActivityAutomationMetadataResponse.filters,
						opportunity_stages:
							salesActivityAutomationMetadataResponse.opportunity_stages,
						salesActivityAutomationMergeTags:
							salesActivityAutomationMetadataResponse?.merge_tags
					};
				return dispatch(
					salesActivityAutomationMetadataSuccessfulAction
				);
			} catch (error) {
				const salesActivityAutomationMetadataFailedAction: SalesActivityAutomationMetadataFailedAction =
					{
						type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_METADATA_FAILED
					};
				dispatch(salesActivityAutomationMetadataFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getSalesActivityAutomationDetails: (
		salesActivityAutomationId: string,
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<SalesActivityAutomationDetailsSuccessfulAction> => {
			const salesActivityAutomationDetailsRequestedAction: SalesActivityAutomationDetailsRequestedAction =
				{
					type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_REQUESTED
				};
			dispatch(salesActivityAutomationDetailsRequestedAction);
			try {
				const salesActivityAutomationDetailsResponse =
					await getSalesActivityAutomationDetails(
						salesActivityAutomationId,
						version
					);
				const salesActivityAutomationDetailsSuccessfulAction: SalesActivityAutomationDetailsSuccessfulAction =
					{
						type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_SUCCESSFUL,
						currentActiveSalesActivityAutomation:
							salesActivityAutomationDetailsResponse
					};
				return dispatch(salesActivityAutomationDetailsSuccessfulAction);
			} catch (error) {
				const salesActivityAutomationDetailsFailedAction: SalesActivityAutomationDetailsFailedAction =
					{
						type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_FAILED
					};
				dispatch(salesActivityAutomationDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetSalesActivityAutomationDetails: () => {
		return (
			dispatch: Dispatch
		): SalesActivityAutomationDetailsResetAction => {
			const salesActivityAutomationDetailsResetAction: SalesActivityAutomationDetailsResetAction =
				{
					type: SalesActivityActionTypes.SALES_ACTIVITY_AUTOMATION_DETAILS_RESET
				};
			return dispatch(salesActivityAutomationDetailsResetAction);
		};
	},
	reorderSalesActivityAutomation: (
		reorderedSalesActivityAutomationList: SalesActivityAutomation[],
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<ReorderSalesActivityAutomationSuccessfulAction> => {
			const reorderSalesActivityAutomationRequestedAction: ReorderSalesActivityAutomationRequestedAction =
				{
					type: SalesActivityActionTypes.REORDER_SALES_ACTIVITY_AUTOMATION_REQUESTED
				};
			dispatch(reorderSalesActivityAutomationRequestedAction);
			try {
				const reorderSalesActivityAutomationResponse =
					await reorderSalesActivityAutomation(
						reorderedSalesActivityAutomationList,
						version
					);
				const reorderSalesActivityAutomationSuccessfulAction: ReorderSalesActivityAutomationSuccessfulAction =
					{
						type: SalesActivityActionTypes.REORDER_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL,
						salesActivityAutomationList:
							reorderSalesActivityAutomationResponse.data
					};
				return dispatch(reorderSalesActivityAutomationSuccessfulAction);
			} catch (error) {
				const reorderSalesActivityAutomationFailedAction: ReorderSalesActivityAutomationFailedAction =
					{
						type: SalesActivityActionTypes.REORDER_SALES_ACTIVITY_AUTOMATION_FAILED
					};
				dispatch(reorderSalesActivityAutomationFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetSalesActivityAutomations: () => {
		return (dispatch: Dispatch): ResetSalesActivityAutomationsAction => {
			const resetSalesActivityAutomationsAction: ResetSalesActivityAutomationsAction =
				{
					type: SalesActivityActionTypes.RESET_SALES_ACTIVITY_AUTOMATIONS
				};
			return dispatch(resetSalesActivityAutomationsAction);
		};
	},
	deleteSalesActivityAutomation: (
		deleteSalesActivityAutomationRequest: SalesActivityAutomation,
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteSalesActivityAutomationSuccessfulAction> => {
			const deleteSalesActivityAutomationRequestedAction: DeleteSalesActivityAutomationRequestedAction =
				{
					type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_REQUESTED
				};
			dispatch(deleteSalesActivityAutomationRequestedAction);
			try {
				const deleteSalesActivityAutomationResponse =
					await deleteSalesActivityAutomation(
						deleteSalesActivityAutomationRequest,
						version
					);
				if (deleteSalesActivityAutomationResponse.deleted) {
					const deleteSalesActivityAutomationSuccessfulAction: DeleteSalesActivityAutomationSuccessfulAction =
						{
							type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL,
							deleteSalesActivityAutomation:
								deleteSalesActivityAutomationRequest
						};
					return dispatch(
						deleteSalesActivityAutomationSuccessfulAction
					);
				} else {
					const deleteSalesActivityAutomationFailedAction: DeleteSalesActivityAutomationFailedAction =
						{
							type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_FAILED
						};
					dispatch(deleteSalesActivityAutomationFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteSalesActivityAutomationFailedAction: DeleteSalesActivityAutomationFailedAction =
					{
						type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AUTOMATION_FAILED
					};
				dispatch(deleteSalesActivityAutomationFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addSalesActivityAutomation: (
		addSalesActivityAutomationRequest: AddSalesActivityAutomationRequest,
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<AddSalesActivityAutomationSuccessfulAction> => {
			const addSalesActivityAutomationRequestedAction: AddSalesActivityAutomationRequestedAction =
				{
					type: SalesActivityActionTypes.ADD_SALES_ACTIVITY_AUTOMATION_REQUESTED
				};
			dispatch(addSalesActivityAutomationRequestedAction);
			try {
				const addSalesActivityAutomationResponse =
					await addSalesActivityAutomation(
						addSalesActivityAutomationRequest,
						version
					);
				const addSalesActivityAutomationSuccessfulAction: AddSalesActivityAutomationSuccessfulAction =
					{
						type: SalesActivityActionTypes.ADD_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL,
						addSalesActivityAutomation:
							addSalesActivityAutomationResponse
					};
				return dispatch(addSalesActivityAutomationSuccessfulAction);
			} catch (error) {
				const addSalesActivityAutomationFailedAction: AddSalesActivityAutomationFailedAction =
					{
						type: SalesActivityActionTypes.ADD_SALES_ACTIVITY_AUTOMATION_FAILED
					};
				dispatch(addSalesActivityAutomationFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editSalesActivityAutomation: (
		editSalesActivityAutomationRequest: EditSalesActivityAutomationRequest,
		action?: string,
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<EditSalesActivityAutomationSuccessfulAction> => {
			const editSalesActivityAutomationRequestedAction: EditSalesActivityAutomationRequestedAction =
				{
					type: SalesActivityActionTypes.EDIT_SALES_ACTIVITY_AUTOMATION_REQUESTED
				};
			dispatch(editSalesActivityAutomationRequestedAction);
			try {
				const editSalesActivityAutomationResponse =
					await editSalesActivityAutomation(
						editSalesActivityAutomationRequest,
						version
					);
				const editSalesActivityAutomationSuccessfulAction: EditSalesActivityAutomationSuccessfulAction =
					{
						type: SalesActivityActionTypes.EDIT_SALES_ACTIVITY_AUTOMATION_SUCCESSFUL,
						editSalesActivityAutomation:
							editSalesActivityAutomationResponse
					};
				if (action) {
					ZMessage.success(
						`Sales automation workflow is 
						${action === "enable_automation" ? "enabled" : "disabled"}`
					);
				}
				return dispatch(editSalesActivityAutomationSuccessfulAction);
			} catch (error) {
				const editSalesActivityAutomationFailedAction: EditSalesActivityAutomationFailedAction =
					{
						type: SalesActivityActionTypes.EDIT_SALES_ACTIVITY_AUTOMATION_FAILED
					};
				dispatch(editSalesActivityAutomationFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateCurrentActiveSalesActivityAutomation: (
		currentActiveSalesActivityAutomation: SalesActivityAutomation | null
	) => {
		return (
			dispatch: Dispatch
		): UpdateCurrentActiveSalesActivityAutomationAction => {
			const updateCurrentActiveSalesActivityAutomationAction: UpdateCurrentActiveSalesActivityAutomationAction =
				{
					type: SalesActivityActionTypes.UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION,
					currentActiveSalesActivityAutomation
				};
			return dispatch(updateCurrentActiveSalesActivityAutomationAction);
		};
	},
	// Sales Activity Drawer Actions
	addCommentDrawerOpened: () => {
		return (dispatch: Dispatch): AddCommentDrawerOpenedAction => {
			const addCommentDrawerOpenedAction: AddCommentDrawerOpenedAction = {
				type: SalesActivityActionTypes.ADD_COMMENT_DRAWER_OPENED
			};
			return dispatch(addCommentDrawerOpenedAction);
		};
	},
	addCommentDrawerClosed: () => {
		return (dispatch: Dispatch): AddCommentDrawerClosedAction => {
			const addCommentDrawerClosedAction: AddCommentDrawerClosedAction = {
				type: SalesActivityActionTypes.ADD_COMMENT_DRAWER_CLOSED
			};
			return dispatch(addCommentDrawerClosedAction);
		};
	},
	editCommentDrawerOpened: () => {
		return (dispatch: Dispatch): EditCommentDrawerOpenedAction => {
			const editCommentDrawerOpenedAction: EditCommentDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_COMMENT_DRAWER_OPENED
				};
			return dispatch(editCommentDrawerOpenedAction);
		};
	},
	editCommentDrawerClosed: () => {
		return (dispatch: Dispatch): EditCommentDrawerClosedAction => {
			const editCommentDrawerClosedAction: EditCommentDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_COMMENT_DRAWER_CLOSED
				};
			return dispatch(editCommentDrawerClosedAction);
		};
	},
	addTaskDrawerOpened: () => {
		return (dispatch: Dispatch): AddTaskDrawerOpenedAction => {
			const addTaskDrawerOpenedAction: AddTaskDrawerOpenedAction = {
				type: SalesActivityActionTypes.ADD_TASK_DRAWER_OPENED
			};
			return dispatch(addTaskDrawerOpenedAction);
		};
	},
	addTaskDrawerClosed: () => {
		return (dispatch: Dispatch): AddTaskDrawerClosedAction => {
			const addTaskDrawerClosedAction: AddTaskDrawerClosedAction = {
				type: SalesActivityActionTypes.ADD_TASK_DRAWER_CLOSED
			};
			return dispatch(addTaskDrawerClosedAction);
		};
	},
	editTaskDrawerOpened: () => {
		return (dispatch: Dispatch): EditTaskDrawerOpenedAction => {
			const editTaskDrawerOpenedAction: EditTaskDrawerOpenedAction = {
				type: SalesActivityActionTypes.EDIT_TASK_DRAWER_OPENED
			};
			return dispatch(editTaskDrawerOpenedAction);
		};
	},
	editTaskDrawerClosed: () => {
		return (dispatch: Dispatch): EditTaskDrawerClosedAction => {
			const editTaskDrawerClosedAction: EditTaskDrawerClosedAction = {
				type: SalesActivityActionTypes.EDIT_TASK_DRAWER_CLOSED
			};
			return dispatch(editTaskDrawerClosedAction);
		};
	},
	addMeetingDrawerOpened: () => {
		return (dispatch: Dispatch): AddMeetingDrawerOpenedAction => {
			const addMeetingDrawerOpenedAction: AddMeetingDrawerOpenedAction = {
				type: SalesActivityActionTypes.ADD_MEETING_DRAWER_OPENED
			};
			return dispatch(addMeetingDrawerOpenedAction);
		};
	},
	addMeetingDrawerClosed: () => {
		return (dispatch: Dispatch): AddMeetingDrawerClosedAction => {
			const addMeetingDrawerClosedAction: AddMeetingDrawerClosedAction = {
				type: SalesActivityActionTypes.ADD_MEETING_DRAWER_CLOSED
			};
			return dispatch(addMeetingDrawerClosedAction);
		};
	},
	editMeetingDrawerOpened: () => {
		return (dispatch: Dispatch): EditMeetingDrawerOpenedAction => {
			const editMeetingDrawerOpenedAction: EditMeetingDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_MEETING_DRAWER_OPENED
				};
			return dispatch(editMeetingDrawerOpenedAction);
		};
	},
	editMeetingDrawerClosed: () => {
		return (dispatch: Dispatch): EditMeetingDrawerClosedAction => {
			const editMeetingDrawerClosedAction: EditMeetingDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_MEETING_DRAWER_CLOSED
				};
			return dispatch(editMeetingDrawerClosedAction);
		};
	},
	addLogCallDrawerOpened: () => {
		return (dispatch: Dispatch): AddLogCallDrawerOpenedAction => {
			const addLogCallDrawerOpenedAction: AddLogCallDrawerOpenedAction = {
				type: SalesActivityActionTypes.ADD_LOG_CALL_DRAWER_OPENED
			};
			return dispatch(addLogCallDrawerOpenedAction);
		};
	},
	addLogCallDrawerClosed: () => {
		return (dispatch: Dispatch): AddLogCallDrawerClosedAction => {
			const addLogCallDrawerClosedAction: AddLogCallDrawerClosedAction = {
				type: SalesActivityActionTypes.ADD_LOG_CALL_DRAWER_CLOSED
			};
			return dispatch(addLogCallDrawerClosedAction);
		};
	},
	editLogCallDrawerOpened: () => {
		return (dispatch: Dispatch): EditLogCallDrawerOpenedAction => {
			const editLogCallDrawerOpenedAction: EditLogCallDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_LOG_CALL_DRAWER_OPENED
				};
			return dispatch(editLogCallDrawerOpenedAction);
		};
	},
	editLogCallDrawerClosed: () => {
		return (dispatch: Dispatch): EditLogCallDrawerClosedAction => {
			const editLogCallDrawerClosedAction: EditLogCallDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_LOG_CALL_DRAWER_CLOSED
				};
			return dispatch(editLogCallDrawerClosedAction);
		};
	},
	addLogEmailDrawerOpened: () => {
		return (dispatch: Dispatch): AddLogEmailDrawerOpenedAction => {
			const addLogEmailDrawerOpenedAction: AddLogEmailDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.ADD_LOG_EMAIL_DRAWER_OPENED
				};
			return dispatch(addLogEmailDrawerOpenedAction);
		};
	},
	addLogEmailDrawerClosed: () => {
		return (dispatch: Dispatch): AddLogEmailDrawerClosedAction => {
			const addLogEmailDrawerClosedAction: AddLogEmailDrawerClosedAction =
				{
					type: SalesActivityActionTypes.ADD_LOG_EMAIL_DRAWER_CLOSED
				};
			return dispatch(addLogEmailDrawerClosedAction);
		};
	},
	editLogEmailDrawerOpened: () => {
		return (dispatch: Dispatch): EditLogEmailDrawerOpenedAction => {
			const editLogEmailDrawerOpenedAction: EditLogEmailDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_LOG_EMAIL_DRAWER_OPENED
				};
			return dispatch(editLogEmailDrawerOpenedAction);
		};
	},
	editLogEmailDrawerClosed: () => {
		return (dispatch: Dispatch): EditLogEmailDrawerClosedAction => {
			const editLogEmailDrawerClosedAction: EditLogEmailDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_LOG_EMAIL_DRAWER_CLOSED
				};
			return dispatch(editLogEmailDrawerClosedAction);
		};
	},
	upcomingActivitiesDrawerOpened: () => {
		return (dispatch: Dispatch): UpcomingActivitiesDrawerOpenedAction => {
			const upcomingActivitiesDrawerOpened: UpcomingActivitiesDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.UPCOMING_ACTIVITIES_DRAWER_OPENED
				};
			return dispatch(upcomingActivitiesDrawerOpened);
		};
	},
	upcomingActivitiesDrawerClosed: () => {
		return (dispatch: Dispatch): UpcomingActivitiesDrawerClosedAction => {
			const upcomingActivitiesDrawerClosed: UpcomingActivitiesDrawerClosedAction =
				{
					type: SalesActivityActionTypes.UPCOMING_ACTIVITIES_DRAWER_CLOSED
				};
			return dispatch(upcomingActivitiesDrawerClosed);
		};
	},
	auditLogsDrawerOpened: () => {
		return (dispatch: Dispatch): AuditLogsDrawerOpenedAction => {
			const auditLogsDrawerOpened: AuditLogsDrawerOpenedAction = {
				type: SalesActivityActionTypes.AUDIT_LOGS_DRAWER_OPENED
			};
			return dispatch(auditLogsDrawerOpened);
		};
	},
	auditLogsDrawerClosed: () => {
		return (dispatch: Dispatch): AuditLogsDrawerClosedAction => {
			const auditLogsDrawerClosed: AuditLogsDrawerClosedAction = {
				type: SalesActivityActionTypes.AUDIT_LOGS_DRAWER_CLOSED
			};
			return dispatch(auditLogsDrawerClosed);
		};
	},
	getHistoryActivities: (
		getHistoryActivitiesRequest: HistoryActivityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<HistoryActivitiesSuccessfulAction> => {
			const historyActivitiesRequestedAction: HistoryActivitiesRequestedAction =
				{
					type: SalesActivityActionTypes.HISTORY_ACTIVITIES_REQUESTED
				};
			dispatch(historyActivitiesRequestedAction);

			try {
				const response = await getHistoryActivities(
					getHistoryActivitiesRequest
				);
				const historyActivitiesSuccessfulAction: HistoryActivitiesSuccessfulAction =
					{
						type: SalesActivityActionTypes.HISTORY_ACTIVITIES_SUCCESSFUL,
						historyResponse: response.data as HistoryActivity[],
						next: response.next
					};
				return dispatch(historyActivitiesSuccessfulAction);
			} catch (error) {
				const historyActivitiesFailedAction: HistoryActivitiesFailedAction =
					{
						type: SalesActivityActionTypes.HISTORY_ACTIVITIES_FAILED
					};
				dispatch(historyActivitiesFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetHistoryActivity: () => {
		return (dispatch: Dispatch): HistoryActivityResetAction => {
			const historyActivityResetAction: HistoryActivityResetAction = {
				type: SalesActivityActionTypes.HISTORY_ACTIVITIES_RESET
			};
			return dispatch(historyActivityResetAction);
		};
	},
	getOneMeeting: (getOneSaleActivityRequest: GetOneSaleActivityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<GetOneMeetingSuccessfulAction> => {
			const getOneMeetingRequestedAction: GetOneMeetingRequestedAction = {
				type: SalesActivityActionTypes.GET_ONE_MEETING_REQUESTED
			};

			dispatch(getOneMeetingRequestedAction);

			try {
				const response = await getOneMeeting(getOneSaleActivityRequest);
				const getOneMeetingSuccessfulAction: GetOneMeetingSuccessfulAction =
					{
						type: SalesActivityActionTypes.GET_ONE_MEETING_SUCCESSFUL,
						salesActivity: response
					};

				return dispatch(getOneMeetingSuccessfulAction);
			} catch (error) {
				const getOneMeetingFailedAction: GetOneMeetingFailedAction = {
					type: SalesActivityActionTypes.GET_ONE_MEETING_FAILED
				};

				dispatch(getOneMeetingFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getOneTask: (getOneSaleActivityRequest: GetOneSaleActivityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<GetOneTaskSuccessfulAction> => {
			const getOneTaskRequestedAction: GetOneTaskRequestedAction = {
				type: SalesActivityActionTypes.GET_ONE_TASK_REQUESTED
			};

			dispatch(getOneTaskRequestedAction);

			try {
				const response = await getOneTask(getOneSaleActivityRequest);
				const getOneTaskSuccessfulAction: GetOneTaskSuccessfulAction = {
					type: SalesActivityActionTypes.GET_ONE_TASK_SUCCESSFUL,
					salesActivity: response
				};

				return dispatch(getOneTaskSuccessfulAction);
			} catch (error) {
				const getOneTaskFailedAction: GetOneTaskFailedAction = {
					type: SalesActivityActionTypes.GET_ONE_TASK_FAILED
				};

				dispatch(getOneTaskFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getOneLogCall: (getOneSaleActivityRequest: GetOneSaleActivityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<GetOneLogCallSuccessfulAction> => {
			const getOneLogCallRequestedAction: GetOneLogCallRequestedAction = {
				type: SalesActivityActionTypes.GET_ONE_LOG_CALL_REQUESTED
			};

			dispatch(getOneLogCallRequestedAction);

			try {
				const response = await getOneLogCall(getOneSaleActivityRequest);
				const getOneLogCallSuccessfulAction: GetOneLogCallSuccessfulAction =
					{
						type: SalesActivityActionTypes.GET_ONE_LOG_CALL_SUCCESSFUL,
						salesActivity: response
					};

				return dispatch(getOneLogCallSuccessfulAction);
			} catch (error) {
				const getOneLogCallFailedAction: GetOneLogCallFailedAction = {
					type: SalesActivityActionTypes.GET_ONE_LOG_CALL_FAILED
				};

				dispatch(getOneLogCallFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getOneLogEmail: (getOneSaleActivityRequest: GetOneSaleActivityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<GetOneLogEmailSuccessfulAction> => {
			const getOneLogEmailRequestedAction: GetOneLogEmailRequestedAction =
				{
					type: SalesActivityActionTypes.GET_ONE_LOG_EMAIL_REQUESTED
				};

			dispatch(getOneLogEmailRequestedAction);

			try {
				const response = await getOneLogEmail(
					getOneSaleActivityRequest
				);
				const getOneLogEmailSuccessfulAction: GetOneLogEmailSuccessfulAction =
					{
						type: SalesActivityActionTypes.GET_ONE_LOG_EMAIL_SUCCESSFUL,
						salesActivity: response
					};

				return dispatch(getOneLogEmailSuccessfulAction);
			} catch (error) {
				const getOneLogEmailFailedAction: GetOneLogEmailFailedAction = {
					type: SalesActivityActionTypes.GET_ONE_LOG_EMAIL_FAILED
				};

				dispatch(getOneLogEmailFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getOneNote: (getOneSaleActivityRequest: GetOneSaleActivityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<GetOneNoteSuccessfulAction> => {
			const getOneNoteRequestedAction: GetOneNoteRequestedAction = {
				type: SalesActivityActionTypes.GET_ONE_NOTE_REQUESTED
			};

			dispatch(getOneNoteRequestedAction);

			try {
				const response = await getOneComment(getOneSaleActivityRequest);
				const getOneNoteSuccessfulAction: GetOneNoteSuccessfulAction = {
					type: SalesActivityActionTypes.GET_ONE_NOTE_SUCCESSFUL,
					salesActivity: response
				};

				return dispatch(getOneNoteSuccessfulAction);
			} catch (error) {
				const getOneNoteFailedAction: GetOneNoteFailedAction = {
					type: SalesActivityActionTypes.GET_ONE_NOTE_FAILED
				};

				dispatch(getOneNoteFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchUsersAllSalesActivity: (
		salesActivityPageRequest: SalesActivityPageRequest,
		companyUserList: UserData[]
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchUsersAllSalesActivitySuccessfullyAction> => {
			const fetchUsersAllSalesActivityRequestedAction: FetchUsersAllSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.FETCH_USERS_ALL_SALES_ACTIVITY_REQUESTED
				};
			dispatch(fetchUsersAllSalesActivityRequestedAction);
			try {
				const response = await getUsersAllSalesActivity(
					salesActivityPageRequest
				);

				const fetchUsersAllSalesActivitySuccessfullyAction: FetchUsersAllSalesActivitySuccessfullyAction =
					{
						type: SalesActivityActionTypes.FETCH_USERS_ALL_SALES_ACTIVITY_SUCCESSFULLY,
						salesActivities: hydrateUserData(
							companyUserList,
							response
						)
					};
				return dispatch(fetchUsersAllSalesActivitySuccessfullyAction);
			} catch (error) {
				const fetchUsersAllSalesActivityFailedAction: FetchUsersAllSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.FETCH_USERS_ALL_SALES_ACTIVITY_FAILED
					};
				dispatch(fetchUsersAllSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchOpportunitiesForSalesActivities: (
		opportunityRequest: OpportunityRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchOpportunitiesForSalesActivitySuccessfullyAction> => {
			const fetchOpportunitiesForSalesActivityRequestedAction: FetchOpportunitiesForSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_REQUESTED
				};
			dispatch(fetchOpportunitiesForSalesActivityRequestedAction);
			try {
				const opportunitiesResponse = await getOpportunities(
					opportunityRequest
				);
				const fetchOpportunitiesForSalesActivitySuccessfullyAction: FetchOpportunitiesForSalesActivitySuccessfullyAction =
					{
						type: SalesActivityActionTypes.FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_SUCCESSFUL,
						opportunities: opportunitiesResponse.data
					};
				return dispatch(
					fetchOpportunitiesForSalesActivitySuccessfullyAction
				);
			} catch (error) {
				const fetchOpportunitiesForSalesActivityFailedAction: FetchOpportunitiesForSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.FETCH_OPPORTUNITIES_FOR_SALES_ACTIVITY_FAILED
					};
				dispatch(fetchOpportunitiesForSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchClientsForSalesActivities: (clientsRequest: ClientsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchClientsForSalesActivitySuccessfullyAction> => {
			const fetchClientsForSalesActivityRequestedAction: FetchClientsForSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.FETCH_CLIENTS_FOR_SALES_ACTIVITY_REQUESTED
				};
			dispatch(fetchClientsForSalesActivityRequestedAction);
			try {
				const clientsResponse = await getClients(clientsRequest);
				const fetchClientsForSalesActivitySuccessfullyAction: FetchClientsForSalesActivitySuccessfullyAction =
					{
						type: SalesActivityActionTypes.FETCH_CLIENTS_FOR_SALES_ACTIVITY_SUCCESSFUL,
						clients: clientsResponse.data
					};
				return dispatch(fetchClientsForSalesActivitySuccessfullyAction);
			} catch (error) {
				const fetchClientsForSalesActivityFailedAction: FetchClientsForSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.FETCH_CLIENTS_FOR_SALES_ACTIVITY_FAILED
					};
				dispatch(fetchClientsForSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchClientsContactForSalesActivities: (
		clientContactRequest: ClientContactRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchClientContactsForSalesActivitySuccessfullyAction> => {
			const fetchClientContactsForSalesActivityRequestedAction: FetchClientContactsForSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_REQUESTED
				};
			dispatch(fetchClientContactsForSalesActivityRequestedAction);
			try {
				const clientContactsResponse = await getClientContacts(
					clientContactRequest
				);
				const fetchClientContactsForSalesActivitySuccessfullyAction: FetchClientContactsForSalesActivitySuccessfullyAction =
					{
						type: SalesActivityActionTypes.FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_SUCCESSFUL,
						clientContacts: clientContactsResponse.data
					};
				return dispatch(
					fetchClientContactsForSalesActivitySuccessfullyAction
				);
			} catch (error) {
				console.error(error);
				const fetchClientContactsForSalesActivityFailedAction: FetchClientContactsForSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.FETCH_CLIENT_CONTACTS_FOR_SALES_ACTIVITY_FAILED
					};
				dispatch(fetchClientContactsForSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetSalesActivityOpportunities: () => {
		return (dispatch: Dispatch): ResetSalesActivityOpportunitiesAction => {
			const resetSalesActivityOpportunitiesAction: ResetSalesActivityOpportunitiesAction =
				{
					type: SalesActivityActionTypes.RESET_SALES_ACTIVITY_OPPORTUNITIES
				};
			return dispatch(resetSalesActivityOpportunitiesAction);
		};
	},
	resetSalesActivityClients: () => {
		return (dispatch: Dispatch): ResetSalesActivityClientsAction => {
			const resetSalesActivityClientsAction: ResetSalesActivityClientsAction =
				{
					type: SalesActivityActionTypes.RESET_SALES_ACTIVITY_CLIENTS
				};
			return dispatch(resetSalesActivityClientsAction);
		};
	},
	resetSalesActivityClientContacts: () => {
		return (dispatch: Dispatch): ResetSalesActivityClientContactsAction => {
			const resetSalesActivityClientContactsAction: ResetSalesActivityClientContactsAction =
				{
					type: SalesActivityActionTypes.RESET_SALES_ACTIVITY_CLIENT_CONTACTS
				};
			return dispatch(resetSalesActivityClientContactsAction);
		};
	},
	syncEntityWithPSA: (syncEntityRequest: SyncEntityRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<SyncWithPSASuccessfulAction> => {
			const syncWithPSARequestedAction: SyncWithPSARequestedAction = {
				type: SalesActivityActionTypes.SYNC_WITH_PSA_REQUESTED
			};
			dispatch(syncWithPSARequestedAction);
			try {
				await syncEntityWithPsa(syncEntityRequest);
				const syncWithPSASuccessfulAction: SyncWithPSASuccessfulAction =
					{
						type: SalesActivityActionTypes.SYNC_WITH_PSA_SUCCESSFUL
					};
				return dispatch(syncWithPSASuccessfulAction);
			} catch (error) {
				const syncWithPSAFailedAction: SyncWithPSAFailedAction = {
					type: SalesActivityActionTypes.SYNC_WITH_PSA_FAILED
				};
				dispatch(syncWithPSAFailedAction);
				return Promise.reject(error);
			}
		};
	},
	resetAllUsersSalesActivity: () => {
		return (dispatch: Dispatch): ResetAllUserSalesActivityAction => {
			const resetAllUserSalesActivityAction: ResetAllUserSalesActivityAction =
				{
					type: SalesActivityActionTypes.RESET_USERS_ALL_SALES_ACTIVITY
				};
			return dispatch(resetAllUserSalesActivityAction);
		};
	},
	addGlobalTaskDrawerOpened: () => {
		return (dispatch: Dispatch): AddGlobalTaskDrawerOpenedAction => {
			const addGlobalTaskDrawerOpenedAction: AddGlobalTaskDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_TASK_DRAWER_OPENED
				};
			return dispatch(addGlobalTaskDrawerOpenedAction);
		};
	},
	addGlobalTaskDrawerClosed: () => {
		return (dispatch: Dispatch): AddGlobalTaskDrawerClosedAction => {
			const addGlobalTaskDrawerClosedAction: AddGlobalTaskDrawerClosedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_TASK_DRAWER_CLOSED
				};
			return dispatch(addGlobalTaskDrawerClosedAction);
		};
	},
	addGlobalCommentDrawerOpened: () => {
		return (dispatch: Dispatch): AddGlobalCommentDrawerOpenedAction => {
			const addGlobalCommentDrawerOpenedAction: AddGlobalCommentDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_COMMENT_DRAWER_OPENED
				};
			return dispatch(addGlobalCommentDrawerOpenedAction);
		};
	},
	addGlobalCommentDrawerClosed: () => {
		return (dispatch: Dispatch): AddGlobalCommentDrawerClosedAction => {
			const addGlobalCommentDrawerClosedAction: AddGlobalCommentDrawerClosedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_COMMENT_DRAWER_CLOSED
				};
			return dispatch(addGlobalCommentDrawerClosedAction);
		};
	},
	addGlobalLogCallDrawerOpened: () => {
		return (dispatch: Dispatch): AddGlobalLogCallDrawerOpenedAction => {
			const addGlobalLogCallDrawerOpenedAction: AddGlobalLogCallDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_LOG_CALL_DRAWER_OPENED
				};
			return dispatch(addGlobalLogCallDrawerOpenedAction);
		};
	},
	addGlobalLogCallDrawerClosed: () => {
		return (dispatch: Dispatch): AddGlobalLogCallDrawerClosedAction => {
			const addGlobalLogCallDrawerClosedAction: AddGlobalLogCallDrawerClosedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_LOG_CALL_DRAWER_CLOSED
				};
			return dispatch(addGlobalLogCallDrawerClosedAction);
		};
	},
	addGlobalLogEmailDrawerOpened: () => {
		return (dispatch: Dispatch): AddGlobalLogEmailDrawerOpenedAction => {
			const addGlobalLogEmailDrawerOpenedAction: AddGlobalLogEmailDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_LOG_EMAIL_DRAWER_OPENED
				};
			return dispatch(addGlobalLogEmailDrawerOpenedAction);
		};
	},
	addGlobalLogEmailDrawerClosed: () => {
		return (dispatch: Dispatch): AddGlobalLogEmailDrawerClosedAction => {
			const addGlobalLogEmailDrawerClosedAction: AddGlobalLogEmailDrawerClosedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_LOG_EMAIL_DRAWER_CLOSED
				};
			return dispatch(addGlobalLogEmailDrawerClosedAction);
		};
	},
	addGlobalMeetingDrawerOpened: () => {
		return (dispatch: Dispatch): AddGlobalMeetingDrawerOpenedAction => {
			const addGlobalMeetingDrawerOpenedAction: AddGlobalMeetingDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_MEETING_DRAWER_OPENED
				};
			return dispatch(addGlobalMeetingDrawerOpenedAction);
		};
	},
	addGlobalMeetingDrawerClosed: () => {
		return (dispatch: Dispatch): AddGlobalMeetingDrawerClosedAction => {
			const addGlobalMeetingDrawerClosedAction: AddGlobalMeetingDrawerClosedAction =
				{
					type: SalesActivityActionTypes.ADD_GLOBAL_MEETING_DRAWER_CLOSED
				};
			return dispatch(addGlobalMeetingDrawerClosedAction);
		};
	},
	editGlobalTaskDrawerOpened: () => {
		return (dispatch: Dispatch): EditGlobalTaskDrawerOpenedAction => {
			const editGlobalTaskDrawerOpenedAction: EditGlobalTaskDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_TASK_DRAWER_OPENED
				};
			return dispatch(editGlobalTaskDrawerOpenedAction);
		};
	},
	editGlobalTaskDrawerClosed: () => {
		return (dispatch: Dispatch): EditGlobalTaskDrawerClosedAction => {
			const editGlobalTaskDrawerClosedAction: EditGlobalTaskDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_TASK_DRAWER_CLOSED
				};
			return dispatch(editGlobalTaskDrawerClosedAction);
		};
	},
	editGlobalCommentDrawerOpened: () => {
		return (dispatch: Dispatch): EditGlobalCommentDrawerOpenedAction => {
			const editGlobalCommentDrawerOpenedAction: EditGlobalCommentDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_COMMENT_DRAWER_OPENED
				};
			return dispatch(editGlobalCommentDrawerOpenedAction);
		};
	},
	editGlobalCommentDrawerClosed: () => {
		return (dispatch: Dispatch): EditGlobalCommentDrawerClosedAction => {
			const editGlobalCommentDrawerClosedAction: EditGlobalCommentDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_COMMENT_DRAWER_CLOSED
				};
			return dispatch(editGlobalCommentDrawerClosedAction);
		};
	},
	editGlobalLogCallDrawerOpened: () => {
		return (dispatch: Dispatch): EditGlobalLogCallDrawerOpenedAction => {
			const editGlobalLogCallDrawerOpenedAction: EditGlobalLogCallDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_LOG_CALL_DRAWER_OPENED
				};
			return dispatch(editGlobalLogCallDrawerOpenedAction);
		};
	},
	editGlobalLogCallDrawerClosed: () => {
		return (dispatch: Dispatch): EditGlobalLogCallDrawerClosedAction => {
			const editGlobalLogCallDrawerClosedAction: EditGlobalLogCallDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_LOG_CALL_DRAWER_CLOSED
				};
			return dispatch(editGlobalLogCallDrawerClosedAction);
		};
	},
	editGlobalLogEmailDrawerOpened: () => {
		return (dispatch: Dispatch): EditGlobalLogEmailDrawerOpenedAction => {
			const editGlobalLogEmailDrawerOpenedAction: EditGlobalLogEmailDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_LOG_EMAIL_DRAWER_OPENED
				};
			return dispatch(editGlobalLogEmailDrawerOpenedAction);
		};
	},
	editGlobalLogEmailDrawerClosed: () => {
		return (dispatch: Dispatch): EditGlobalLogEmailDrawerClosedAction => {
			const editGlobalLogEmailDrawerClosedAction: EditGlobalLogEmailDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_LOG_EMAIL_DRAWER_CLOSED
				};
			return dispatch(editGlobalLogEmailDrawerClosedAction);
		};
	},
	editGlobalMeetingDrawerOpened: () => {
		return (dispatch: Dispatch): EditGlobalMeetingDrawerOpenedAction => {
			const editGlobalMeetingDrawerOpenedAction: EditGlobalMeetingDrawerOpenedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_MEETING_DRAWER_OPENED
				};
			return dispatch(editGlobalMeetingDrawerOpenedAction);
		};
	},
	editGlobalMeetingDrawerClosed: () => {
		return (dispatch: Dispatch): EditGlobalMeetingDrawerClosedAction => {
			const editGlobalMeetingDrawerClosedAction: EditGlobalMeetingDrawerClosedAction =
				{
					type: SalesActivityActionTypes.EDIT_GLOBAL_MEETING_DRAWER_CLOSED
				};
			return dispatch(editGlobalMeetingDrawerClosedAction);
		};
	},
	updateActiveFilters: (activeFilters: TableQueryFilter[]) => {
		return (dispatch: Dispatch): UpdateActiveFiltersAction => {
			const updateActiveFiltersAction: UpdateActiveFiltersAction = {
				type: SalesActivityActionTypes.UPDATE_ACTIVE_FILTERS,
				activeFilters: activeFilters
			};
			return dispatch(updateActiveFiltersAction);
		};
	},
	addActivityToUsersSalesActivity: (salesActivity: SalesActivity) => {
		return (dispatch: Dispatch): AddActivityToUsersSalesActivityAction => {
			const addActivityToUsersSalesActivityAction: AddActivityToUsersSalesActivityAction =
				{
					type: SalesActivityActionTypes.ADD_ACTIVITY_TO_USERS_SALES_ACTIVITY,
					salesActivity: salesActivity
				};
			return dispatch(addActivityToUsersSalesActivityAction);
		};
	},
	updateSingleUsersSalesActivity: (salesActivity: SalesActivity) => {
		return (dispatch: Dispatch): UpdateSingleUserSalesActivityAction => {
			const updateSingleUserSalesActivityAction: UpdateSingleUserSalesActivityAction =
				{
					type: SalesActivityActionTypes.UPDATE_SINGLE_USERS_SALES_ACTIVITY,
					salesActivity: salesActivity
				};
			return dispatch(updateSingleUserSalesActivityAction);
		};
	},
	fetchOneSalesActivity: (
		getOneSaleActivityRequest: GetOneSaleActivityRequest,
		companyUserList: UserData[]
	) => {
		return async (
			dispatch: Dispatch
		): Promise<GetOneSalesActivitySuccessfulAction> => {
			const getOneSalesActivityRequestedAction: GetOneSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.GET_ONE_SALES_ACTIVITY_REQUESTED
				};

			dispatch(getOneSalesActivityRequestedAction);

			try {
				const response = await getOneSalesActivity(
					getOneSaleActivityRequest
				);
				const getOneSalesActivitySuccessfulAction: GetOneSalesActivitySuccessfulAction =
					{
						type: SalesActivityActionTypes.GET_ONE_SALES_ACTIVITY_SUCCESSFUL,
						salesActivity: hydrateUserData(
							companyUserList,
							response
						)
					};

				return dispatch(getOneSalesActivitySuccessfulAction);
			} catch (error) {
				const getOneSalesActivityFailedAction: GetOneSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.GET_ONE_SALES_ACTIVITY_FAILED
					};

				dispatch(getOneSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteOneSalesActivity: (salesActivity: SalesActivity) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteOneSalesActivitySuccessfullyAction> => {
			const deleteOneSalesActivityRequestedAction: DeleteOneSalesActivityRequestedAction =
				{
					type: SalesActivityActionTypes.DELETE_ONE_SALES_ACTIVITY_REQUESTED
				};

			dispatch(deleteOneSalesActivityRequestedAction);

			try {
				await deleteOneSalesActivity(salesActivity);
				const deleteOneSalesActivitySuccessfullyAction: DeleteOneSalesActivitySuccessfullyAction =
					{
						type: SalesActivityActionTypes.DELETE_ONE_SALES_ACTIVITY_SUCCESSFULLY,
						salesActivityId: salesActivity.id
					};

				return dispatch(deleteOneSalesActivitySuccessfullyAction);
			} catch (error) {
				const deleteOneSalesActivityFailedAction: DeleteOneSalesActivityFailedAction =
					{
						type: SalesActivityActionTypes.DELETE_ONE_SALES_ACTIVITY_FAILED
					};

				dispatch(deleteOneSalesActivityFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchMeetingClashStatus: (
		startTime: number,
		endTime: number,
		id: string
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchMeetingClashStatusSuccessful> => {
			const fetchMeetingClashStatusRequested: FetchMeetingClashStatusRequested =
				{
					type: SalesActivityActionTypes.FETCHING_MEETING_CLASH_STATUS_REQUESTED
				};
			dispatch(fetchMeetingClashStatusRequested);

			try {
				const response = await fetchMeetingClashStatus(
					startTime,
					endTime,
					id
				);
				const fetchMeetingClashStatusSuccessful: FetchMeetingClashStatusSuccessful =
					{
						type: SalesActivityActionTypes.FETCHING_MEETING_CLASH_STATUS_SUCCESSFUL,
						meetingStatus: response.status
					};

				return dispatch(fetchMeetingClashStatusSuccessful);
			} catch (error) {
				const fetchMeetingClashStatusFailed: FetchMeetingClashStatusFailed =
					{
						type: SalesActivityActionTypes.FETCHING_MEETING_CLASH_STATUS_FAILED
					};
				dispatch(fetchMeetingClashStatusFailed);

				return Promise.reject(error);
			}
		};
	},
	fetchPSAAuditLogs: (
		fetchAuditLogsRequest: FetchCategoryBasedAuditLogsRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchAllPSAAuditLogsSuccessfulAction> => {
			const fetchAllPSAAuditLogsRequestedAction: FetchAllPSAAuditLogsRequestedAction =
				{
					type: SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_REQUESTED
				};
			dispatch(fetchAllPSAAuditLogsRequestedAction);
			try {
				const isPaymentLogs =
					!!fetchAuditLogsRequest.sync_source?.length;
				const response = await fetchAuditLogs(fetchAuditLogsRequest);
				const fetchAllPSAAuditLogsSuccessfulAction: FetchAllPSAAuditLogsSuccessfulAction =
					{
						type: SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_SUCCESSFUL,
						auditLogs: response.data as HistoryActivity[],
						paymentLogs: isPaymentLogs
							? (response.data as PaymentHistoryActivity[])
							: undefined,
						next: response.next,
						count: response.filtered_count_map?.count
					};
				return dispatch(fetchAllPSAAuditLogsSuccessfulAction);
			} catch (error) {
				const fetchAllPSAAuditLogsFailedAction: FetchAllPSAAuditLogsFailedAction =
					{
						type: SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_FAILED
					};
				dispatch(fetchAllPSAAuditLogsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	retryFailedPSAAuditLog: (
		retryFailedAuditLogRequest: RetryFailedAuditLogsRequest
	) => {
		return async (dispatch: Dispatch): Promise<any> => {
			const retryFailedAuditLogsRequestAction: RetryFailedAuditLogsRequestedAction =
				{
					type: SalesActivityActionTypes.RETRY_FAILED_AUDIT_LOG_REQUESTED
				};

			dispatch(retryFailedAuditLogsRequestAction);

			try {
				await retryFailedAuditLog(retryFailedAuditLogRequest);

				const retryFailedAuditLogsSuccesfulAction: RetryFailedAuditLogsSuccesfulAction =
					{
						type: SalesActivityActionTypes.RETRY_FAILED_AUDIT_LOG_SUCCESFUL
					};

				return dispatch(retryFailedAuditLogsSuccesfulAction);
			} catch (error) {
				const retryFailedAuditLogsFailedAction: RetryFailedAuditLogsFailedAction =
					{
						type: SalesActivityActionTypes.RETRY_FAILED_AUDIT_LOG_FAILED
					};

				dispatch(retryFailedAuditLogsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getAuditLogRedirectUrl: (id: string) => {
		return async (
			dispatch: Dispatch
		): Promise<AuditLogRedirectUrlSuccessfulAction> => {
			const auditLogRedirectUrlRequestedAction: AuditLogRedirectUrlRequestedAction =
				{
					type: SalesActivityActionTypes.AUDIT_LOG_REDIRECT_URL_REQUESTED
				};
			dispatch(auditLogRedirectUrlRequestedAction);

			try {
				const response = await getAuditLogRedirectUrl(id);
				const auditLogRedirectUrlSuccessfulAction: AuditLogRedirectUrlSuccessfulAction =
					{
						type: SalesActivityActionTypes.AUDIT_LOG_REDIRECT_URL_SUCCESFUL,
						redirectUrl: response
					};
				return dispatch(auditLogRedirectUrlSuccessfulAction);
			} catch (err) {
				const auditLogRedirectUrlFailedAction: AuditLogRedirectUrlFailedAction =
					{
						type: SalesActivityActionTypes.AUDIT_LOG_REDIRECT_URL_FAILED
					};
				dispatch(auditLogRedirectUrlFailedAction);
				return Promise.reject(err);
			}
		};
	},
	fetchCustomDistributorAuditLogs: (
		fetchAuditLogsRequest: FetchCustomDistributorAuditLogsRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchAllPSAAuditLogsSuccessfulAction> => {
			const fetchAllPSAAuditLogsRequestedAction: FetchAllPSAAuditLogsRequestedAction =
				{
					type: SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_REQUESTED
				};
			dispatch(fetchAllPSAAuditLogsRequestedAction);
			try {
				const response = await fetchCustomDistributorAuditLogs(
					fetchAuditLogsRequest
				);
				const fetchAllPSAAuditLogsSuccessfulAction: FetchAllPSAAuditLogsSuccessfulAction =
					{
						type: SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_SUCCESSFUL,
						auditLogs: response,
						next: response.next,
						count: response.filtered_count_map?.count
					};
				return dispatch(fetchAllPSAAuditLogsSuccessfulAction);
			} catch (error) {
				const fetchAllPSAAuditLogsFailedAction: FetchAllPSAAuditLogsFailedAction =
					{
						type: SalesActivityActionTypes.FETCH_ALL_PSA_AUDIT_LOGS_FAILED
					};
				dispatch(fetchAllPSAAuditLogsFailedAction);

				return Promise.reject(error);
			}
		};
	},

	updateCurrentActiveSalesActivityAutomationActionIndex: (
		updatedIndex: number
	) => {
		return (
			dispatch: Dispatch
		): UpdateCurrentActiveSalesActivityAutomationActionIndex => {
			const updateCurrentActiveSalesActivityAutomationActionIndex: UpdateCurrentActiveSalesActivityAutomationActionIndex =
				{
					type: SalesActivityActionTypes.UPDATE_CURRENT_ACTIVE_SALES_ACTIVITY_AUTOMATION_ACTION_INDEX,
					index: updatedIndex
				};
			return dispatch(
				updateCurrentActiveSalesActivityAutomationActionIndex
			);
		};
	},
	showPaymentsDrawer: () => {
		return (dispatch: Dispatch): PaymentDrawerOpenedAction => {
			const paymentDrawerOpenedAction: PaymentDrawerOpenedAction = {
				type: SalesActivityActionTypes.SHOW_PAYMENT_DRAWER
			};
			return dispatch(paymentDrawerOpenedAction);
		};
	},
	hidePaymentsDrawer: () => {
		return (dispatch: Dispatch): PaymentDrawerClosedAction => {
			const paymentDrawerClosedAction: PaymentDrawerClosedAction = {
				type: SalesActivityActionTypes.HIDE_PAYMENT_DRAWER
			};
			return dispatch(paymentDrawerClosedAction);
		};
	},
	showWebhookDrawer: () => {
		return (dispatch: Dispatch): WebhookDrawerOpenedAction => {
			const webhookDrawerOpenedAction: WebhookDrawerOpenedAction = {
				type: SalesActivityActionTypes.SHOW_WEBHOOK_DRAWER
			};
			return dispatch(webhookDrawerOpenedAction);
		};
	},
	hideWebhookDrawer: () => {
		return (dispatch: Dispatch): WebhookDrawerClosedAction => {
			const webhookDrawerClosedAction: WebhookDrawerClosedAction = {
				type: SalesActivityActionTypes.HIDE_WEBHOOK_DRAWER
			};
			return dispatch(webhookDrawerClosedAction);
		};
	},
	updateSelectedDocumentType: (
		selectedDocumentType: SelectedDocumentAndTemplate
	) => {
		return (dispatch: Dispatch): UpdatedSelectedDocumentAction => {
			const updatedSelectedDocumentAction: UpdatedSelectedDocumentAction =
				{
					type: SalesActivityActionTypes.UPDATE_SELECTED_DOCUMENT_TYPE,
					selectedDocumentType
				};
			return dispatch(updatedSelectedDocumentAction);
		};
	},
	// Sales Automation views and filter actions
	fetchSalesActivityAndAutomationViewMetadata: (entity: ZomentumEntities) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchSalesActivityAndAutomationViewMetadataSuccessful> => {
			const fetchSalesActivityViewMetadataRequested: FetchSalesActivityAndAutomationViewMetadataRequested =
				{
					type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_REQUESTED
				};

			dispatch(fetchSalesActivityViewMetadataRequested);

			try {
				const response =
					await fetchSalesActivityAndAutomationViewMetadata(entity);
				const fetchSalesActivityViewMetadataSuccessful: FetchSalesActivityAndAutomationViewMetadataSuccessful =
					{
						type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_SUCCESSFUL,
						metadata: response
					};
				return dispatch(fetchSalesActivityViewMetadataSuccessful);
			} catch (error) {
				console.error(error);

				const fetchSalesActivityViewMetadataFailed: FetchSalesActivityAndAutomationViewMetadataFailed =
					{
						type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEW_METADATA_FAILED
					};
				dispatch(fetchSalesActivityViewMetadataFailed);

				return Promise.reject(error);
			}
		};
	},

	fetchSalesActivityAndAutomationViewsList: (entity: ZomentumEntities) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchSalesActivityAndAutomationViewsSussessfull> => {
			const fetchSalesActivityViewsListRequested: FetchSalesActivityAndAutomationViewsRequested =
				{
					type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_REQUESTED
				};

			dispatch(fetchSalesActivityViewsListRequested);

			try {
				const response = await getAllSalesActivityAndAutomationViews(
					entity
				);
				const fetchSalesActivityViewListSuccessful: FetchSalesActivityAndAutomationViewsSussessfull =
					{
						type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_SUCCESSFUL,
						viewsList: response
					};
				return dispatch(fetchSalesActivityViewListSuccessful);
			} catch (error) {
				console.error(error);

				const fetchSalesActivityViewListFailed: FetchSalesActivityAndAutomationViewsFailed =
					{
						type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_VIEWS_FAILED
					};
				dispatch(fetchSalesActivityViewListFailed);

				return Promise.reject(error);
			}
		};
	},
	updateCurrentActiveView: (
		selectedCurrentActiveView: CustomView,
		discardingView?: boolean
	) => {
		return (
			dispatch: Dispatch,
			getState: () => SalesActivityModuleState
		): UpdateCurrentActiveViewAction => {
			const currentActiveView =
				getState().salesActivity.currentActiveView;
			const prevViewData = getState().salesActivity.viewList?.data.find(
				view => view.id === selectedCurrentActiveView?.id
			);

			const isSameView =
				currentActiveView?.id === selectedCurrentActiveView?.id;

			if (isSameView) {
				// if its a custom view then it would have an id
				if (prevViewData?.id) {
					const hasFiltersChanged = areFiltersChanged(
						prevViewData.filter_criteria,
						selectedCurrentActiveView.filter_criteria
					);

					const hasColumnsChanged =
						JSON.stringify(selectedCurrentActiveView.columns) !==
						JSON.stringify(prevViewData.columns);

					const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
						{
							type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_CURRENT_ACTIVE_VIEW,
							currentActiveView: selectedCurrentActiveView,
							isViewChanged: discardingView
								? false
								: hasFiltersChanged || hasColumnsChanged
						};
					return dispatch(updateCurrentActiveViewAction);
				}

				// if its a system view then no id

				if (currentActiveView) {
					const hasFiltersChanged = areFiltersChanged(
						currentActiveView.filter_criteria,
						selectedCurrentActiveView.filter_criteria
					);

					const hasColumnsChanged =
						JSON.stringify(selectedCurrentActiveView.columns) !==
						JSON.stringify(currentActiveView?.columns);

					const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
						{
							type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_CURRENT_ACTIVE_VIEW,
							currentActiveView: selectedCurrentActiveView,
							isViewChanged: discardingView
								? false
								: hasFiltersChanged || hasColumnsChanged
						};
					return dispatch(updateCurrentActiveViewAction);
				}
			}

			const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
				{
					type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_CURRENT_ACTIVE_VIEW,
					currentActiveView: selectedCurrentActiveView,
					isViewChanged: discardingView ? true : false
				};
			return dispatch(updateCurrentActiveViewAction);
		};
	},
	createSalesActivityAndAutomationView: (view: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<CreateSalesActivityAndAutomationViewSuccessfulAction> => {
			const createSalesActivityViewRequestedAction: CreateSalesActivityAndAutomationViewRequestedAction =
				{
					type: SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED
				};

			dispatch(createSalesActivityViewRequestedAction);

			try {
				if (view.entity_type === ZomentumEntities.SalesActivity) {
					const updatedView = {
						...view,
						filter_criteria: []
					};
					const response = await createSalesActivityAndAutomationView(
						updatedView
					);
					const updatedResponse = {
						...response,
						filter_criteria: view.filter_criteria
					};
					const createSalesActivityViewSuccessfulAction: CreateSalesActivityAndAutomationViewSuccessfulAction =
						{
							type: SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL,
							view: updatedResponse
						};
					return dispatch(createSalesActivityViewSuccessfulAction);
				}
				const response = await createSalesActivityAndAutomationView(
					view
				);
				const createSalesActivityViewSuccessfulAction: CreateSalesActivityAndAutomationViewSuccessfulAction =
					{
						type: SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL,
						view: response
					};
				return dispatch(createSalesActivityViewSuccessfulAction);
			} catch (error) {
				const createSalesActivityViewFailedAction: CreateSalesActivityAndAutomationViewFailedAction =
					{
						type: SalesActivityActionTypes.CREATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED
					};
				dispatch(createSalesActivityViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateSalesActivityAndAutomationView: (view: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateSalesActivityAndAutomationViewSuccessfulAction> => {
			const updateSalesActivityViewRequestedAction: UpdateSalesActivityAndAutomationViewRequestedAction =
				{
					type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED
				};

			dispatch(updateSalesActivityViewRequestedAction);

			try {
				if (view.entity_type === ZomentumEntities.SalesActivity) {
					const updatedView = {
						...view,
						filter_criteria: []
					};
					const response = await updateSalesActivityAndAutomationView(
						updatedView
					);
					const updatedResponse = {
						...response,
						filter_criteria: view.filter_criteria
					};
					const updateSalesActivityViewSuccessfulAction: UpdateSalesActivityAndAutomationViewSuccessfulAction =
						{
							type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL,
							view: updatedResponse
						};
					return dispatch(updateSalesActivityViewSuccessfulAction);
				}
				const response = await updateSalesActivityAndAutomationView(
					view
				);
				const updateSalesActivityViewSuccessfulAction: UpdateSalesActivityAndAutomationViewSuccessfulAction =
					{
						type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL,
						view: response
					};
				return dispatch(updateSalesActivityViewSuccessfulAction);
			} catch (error) {
				const updateSalesActivityViewFailedAction: UpdateSalesActivityAndAutomationViewFailedAction =
					{
						type: SalesActivityActionTypes.UPDATE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED
					};
				dispatch(updateSalesActivityViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteSalesActivityAndAutomationView: (
		deleteView: CustomView,
		initialView: CustomView
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteSalesActivityAndAutomationViewSuccessfulAction> => {
			const deleteSalesActivityViewRequestedAction: DeleteSalesActivityAndAutomationViewRequestedAction =
				{
					type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_REQUESTED
				};

			dispatch(deleteSalesActivityViewRequestedAction);

			try {
				await deleteSalesActivityAndAutomationView(deleteView.id);
				const deleteSalesActivityViewSuccessfulAction: DeleteSalesActivityAndAutomationViewSuccessfulAction =
					{
						type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_SUCCESSFUL,
						deletedView: deleteView,
						initialView: initialView
					};
				return dispatch(deleteSalesActivityViewSuccessfulAction);
			} catch (error) {
				const deleteSalesActivityViewFailedAction: DeleteSalesActivityAndAutomationViewFailedAction =
					{
						type: SalesActivityActionTypes.DELETE_SALES_ACTIVITY_AND_AUTOMATION_VIEW_FAILED
					};
				dispatch(deleteSalesActivityViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchAllSalesActivityAndAutomation: (
		salesAutomationRequest: ListPagePostRequest,
		version = "v2"
	) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchSalesActivityAndAutomationListSuccessful> => {
			const fetchSalesAutomationListRequested: FetchSalesActivityAndAutomationListRequested =
				{
					type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_REQUESTED
				};
			dispatch(fetchSalesAutomationListRequested);
			try {
				const response = await getSalesActivityAndAutomationListPost(
					salesAutomationRequest,
					version
				);

				const fetchSalesAutomationListSuccessful: FetchSalesActivityAndAutomationListSuccessful =
					{
						type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_SUCCESSFUL,
						salesAutomationList: response
					};

				return dispatch(fetchSalesAutomationListSuccessful);
			} catch (error) {
				const fetchSalesAutomationListFailed: FetchSalesActivityAndAutomationListFailed =
					{
						type: SalesActivityActionTypes.FETCH_SALES_ACTIVITY_AND_AUTOMATION_LIST_FAILED
					};

				dispatch(fetchSalesAutomationListFailed);

				return Promise.reject(error);
			}
		};
	},
	getConflictMeetingDetail: (startTime: number) => {
		return async (
			dispatch: Dispatch
		): Promise<GetConflictMeetingDetailSuccessful> => {
			try {
				const response = await getConflictMeetingsDetail(startTime);
				const getConflictMeetingSuccessfulAction: GetConflictMeetingDetailSuccessful =
					{
						type: SalesActivityActionTypes.GET_CONFLICT_MEETING_DETAIL_SUCCESSFUL,
						conflictMeetings: response
					};

				return dispatch(getConflictMeetingSuccessfulAction);
			} catch (error) {
				return Promise.reject(error);
			}
		};
	},
	updateSelectedOwnerView: (selectedOwnerView: SalesActivityUserViews) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateSelectedOwnerViewAction> => {
			const updateSelectedOwnerViewAction: UpdateSelectedOwnerViewAction =
				{
					type: SalesActivityActionTypes.UPDATE_SELECTED_OWNER,
					selectedOwnerView: selectedOwnerView
				};
			return dispatch(updateSelectedOwnerViewAction);
		};
	},
	updateAuditLogsCount: (auditLogsCount: number) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateAuditLogsCountViewAction> => {
			const updateAuditLogsCountAction: UpdateAuditLogsCountViewAction = {
				type: SalesActivityActionTypes.UPDATE_AUDIT_LOGS_COUNT,
				auditLogsCount
			};
			return dispatch(updateAuditLogsCountAction);
		};
	}
};

export default SalesActivityActionCreators;
